import axios from "axios";
import { cloneDeep } from "lodash";
import {
  RegisterReqWebSocket,
  SendFile,
  SendAttendant,
  ActiveCallSocket,
  SendByeAttendant,
  InsertIdleSocket,
  GetListCallQueue,
  ReqSocketLogout,
  editAgentSocket,
  EfectBlockUserSocket,
  ActiveCallSocketVoz,
  RequestCallParkSocket,
  RequestCallParkTransferSocket,
  CarregarChatSocket,
  StopMonitoring,
  SendFileMonitoring,
  sendIPSocket,
  SendSocketConferenceCall,
  ActiveConfSocketVoz,
  SendReqAfterCallWork,
  sendPauseFuture,
  UpdateContactInteraction,
  checkLStatusstAgIMSDN,
} from "../actions/websocket";
import setupSocket from "./websocket";
import { InsertContactIngDesk } from "./ingdesk_shipments";
// import broadcastChannel from './broadcastchannel';
import * as types from "../constants/ActionTypes";
import Moment from "moment";
import { webphone_api } from "../actions/webphone_api";
import { changeStatusOfIngFaqConditions } from "./changeStatusOfIngFaqConditions";
import { codeBase64Convert } from "../utils/codeBase64Convert";
import { previusMessagesService } from "../containers/PreviousMessages/utils/PreviusMessagesService";
import { ingDeskService } from "../services/IngDesk/ingDeskService";
import { differenceInSeconds, parse } from "date-fns";
import { clientWalletIntegration } from "../utils/clientWalletIntegration";
import { toast } from "react-toastify";
import { STATUS_ID_MAPPING } from "../utils/statusIdMapping";
import { delay } from "../utils/delay";
import { formatMimeType56 } from "../utils/formatMimetype56";
import { EAgentStatus } from "../thunks/IngDeskIntegration/verifyIfCallIsStillInQueue";

var useridRefresh = "";
var useridPauseRefresh = "";

const { connection_platform } = require("../services/api");
const {
  meses,
  tela_atual_ingweb,
  aviso_sonoro_interacao,
  aviso_sonoro_mensagem,
  aviso_sonoro_chamada,
  voz,
  filtro_fila,
  fila_checkbox_callback,
  fila_checkbox_em_tratamento,
  fila_checkbox_espera,
  fila_checkbox_retorno,
  log_full_ingenium,
} = require("../services/data");

const md5 = require("md5");
const ip = require("ip");
const h2p = require("html2plaintext");

let OrderAtd = 0;
let nextMessageId = 0;
let nextAttId = 0;
let numberAdd = 1;
let structAcwCallIndex = [];
let idAtdACW = [];
var last_statusAgent = 0;
var confatendimento = [];
var checkTransferACW = false;

var gethostname = window.location.hostname;
var pathname = "";

const iplocal = connection_platform.ip_intern;
var port = connection_platform.port_backend_intern;
var portims = connection_platform.port_socket_intern;

if (localStorage.getItem("aviso_sonoro_interacao") === null) {
  localStorage.setItem("aviso_sonoro_interacao", true);
}
if (localStorage.getItem("aviso_sonoro_mensagem") === null) {
  localStorage.setItem("aviso_sonoro_mensagem", true);
}

if (localStorage.getItem("aviso_sonoro_chamada") === null) {
  localStorage.setItem("aviso_sonoro_chamada", true);
}

if (
  gethostname === "localhost" ||
  connection_platform.ip_intern === gethostname
)
  pathname = iplocal;
else pathname = gethostname;
if (connection_platform.client_differentip === true)
  pathname = connection_platform.ip_extern;

var ipcurrent = pathname;

if (pathname !== connection_platform.ip_intern) {
  ipcurrent =
    connection_platform.ip_extern +
    ":" +
    connection_platform.port_apache_view_extern;
  port = connection_platform.port_backend_extern;
  portims = connection_platform.port_socket_extern;
}

if (connection_platform.client_webrtc) {
  webphone_api.parameters = {
    enginepriority_webrtc: 5,
    enginepriority_ns: 0,
    loglevel: 5,
    configversion: 1,
  };
} else {
  webphone_api.parameters = {
    enginepriority_webrtc: 0,
    enginepriority_ns: 5,
    loglevel: 5,
    configversion: 1,
  };
}

localStorage.setItem("jsonchannelstatus", "");
localStorage.setItem("pathname", pathname);

if (!connection_platform.multitenancy) {
  localStorage.setItem("port", port);
}

const groupRoutesGroupsByMidiaId = (data) => {
  let groupedRouteById = {};
  const hasData = Boolean(data) && Array.isArray(data);
  if (!hasData) return groupedRouteById;
  groupedRouteById = data.reduce((acc, curr) => {
    let routesOfThisMidiaId = acc[curr.idmidia];
    const hasAnyDataInThisMidia = Boolean(routesOfThisMidiaId);
    if (!hasAnyDataInThisMidia) {
      acc[curr.idmidia] = [curr];
    } else if (Array.isArray(routesOfThisMidiaId)) {
      acc[curr.idmidia] = [...acc[curr.idmidia], curr];
    }
    return acc;
  }, {});

  return groupedRouteById;
};

const getStorageSubservice = (filtersInDbObj) => {
  let storageSubservice = [];
  const hasSubservico =
    Boolean(filtersInDbObj) &&
    Boolean(filtersInDbObj.subservico) &&
    typeof filtersInDbObj.subservico === "object";
  if (!hasSubservico) return storageSubservice;

  for (const key in filtersInDbObj.subservico) {
    const isActive = Boolean(filtersInDbObj.subservico[key]);
    if (isActive) storageSubservice.push(parseInt(key));
  }

  return storageSubservice;
};

const getStorageStatus = (filtersInDbObj) => {
  const STATUS_ID_MAPPING = {
    callback: "0",
    fila: "1",
    tratamento: "2",
    retornando: "5",
  };
  let storageStatus = [];
  const hasStatus =
    Boolean(filtersInDbObj) &&
    Boolean(filtersInDbObj.status) &&
    typeof filtersInDbObj.status === "object";
  if (!hasStatus) return storageStatus;
  for (const key in filtersInDbObj.status) {
    const isActive = Boolean(filtersInDbObj.status[key]);
    if (isActive) storageStatus.push(STATUS_ID_MAPPING[key]);
  }

  return storageStatus;
};
const getStorageMedia = (filtersInDbObj) => {
  let storageMedia = [];
  const hasStorageMedia =
    Boolean(filtersInDbObj) &&
    Boolean(filtersInDbObj.canais) &&
    typeof filtersInDbObj.canais === "object";
  if (!hasStorageMedia) return storageMedia;

  for (const key in filtersInDbObj.canais) {
    const isActive = Boolean(filtersInDbObj.canais[key]);
    if (isActive) storageMedia.push(parseInt(key));
  }

  return storageMedia;
};
export const AdicionarValoresIniciaisDoFiltroDeFila = (
  filtersInDb,
  defaultFilter = null,
  isToBlockEdition = false,
) => {
  try {
    const hasFiltersInDb = Boolean(filtersInDb);
    if (!hasFiltersInDb)
      return {
        type: types.ADICIONAR_VALORES_INICIAIS_DO_FILTRO_DE_FILA,
        filtersInDb: null,
        canais: {},
        subservico: {},
        status: {},
        storageMedia: [],
        storageStatus: [],
        storageSubservice: [],
        isToBlockEdition,
      };
    const filtersInDbObj = filtersInDb;
    const storageMedia = getStorageMedia(filtersInDbObj);
    const storageStatus = getStorageStatus(filtersInDbObj);
    const storageSubservice = getStorageSubservice(filtersInDbObj);
    const canais = filtersInDbObj.canais;
    const subservico = filtersInDbObj.subservico;
    const status = filtersInDbObj.status;
    if (Boolean(defaultFilter)) {
      return {
        type: types.ADICIONAR_VALORES_INICIAIS_DO_FILTRO_DE_FILA,
        filtersInDb: filtersInDbObj,
        filtroDefault: defaultFilter,
        canais,
        subservico,
        status,
        storageMedia: storageMedia || [],
        storageStatus: storageStatus || [],
        storageSubservice: storageSubservice || [],
        isToBlockEdition,
      };
    }
    return {
      type: types.ADICIONAR_VALORES_INICIAIS_DO_FILTRO_DE_FILA,
      filtersInDb: filtersInDbObj,
      canais,
      subservico,
      status,
      storageMedia: storageMedia || [],
      storageStatus: storageStatus || [],
      storageSubservice: storageSubservice || [],
      isToBlockEdition,
    };
  } catch (error) {
    return {
      type: types.ADICIONAR_VALORES_INICIAIS_DO_FILTRO_DE_FILA,
      filtersInDb: null,
      canais: {},
      subservico: {},
      status: {},
      storageMedia: [],
      storageStatus: [],
      storageSubservice: [],
      isToBlockEdition,
    };
  }
};

export const TestConnection = (post) => {
  return (dispatch) => {
    axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/testconection`,
      )
      .then((response) => {
        if (response.data !== true) {
          dispatch(
            ConnectionsAPI(true, false, true, "Sem conexão com banco de dados"),
          );
        } else {
          dispatch(
            ConnectionsAPI(true, true, true, "Sem conexão com banco de dados"),
          );
        }
      })
      .catch((error) => {
        dispatch(
          ConnectionsAPI(true, false, true, "Sem conexão com banco de dados"),
        );
      });
  };
};

export const AuthLoginAzure = (username) => {
  return (dispatch) => {
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/loginazure?username=${username}`,
      )
      .then((response) => {
        if (response.data !== "") {
          if (
            response.data[0].priimsdn != null &&
            !response.data[0].secimsdn != null
          ) {
            var user_midias = [];
            response.data.map((midias) => {
              user_midias.push(midias.midiaid);
            });
            dispatch(CallParkCapture(true));
            useridRefresh = response.data[0].id;
            dispatch(
              createLoginSuccess(
                username,
                response.data[0].id,
                user_midias,
                response.data[0].id_auth_set,
                response.data[0].jobin_autoblocking,
                response.data[0].desc_aut_meth,
                response.data[0].address_backend,
                response.data[0].link_webchat,
              ),
            );
            sendIPSocket(
              response.data[0].priimsdn,
              response.data[0].secimsdn,
              portims,
            );
            dispatch(
              GetInformationUsers(
                response.data[0].id,
                md5("post"),
                false,
                0,
                0,
                0,
                0,
                response.data[0].desc_aut_meth,
              ),
            );
          } else {
            dispatch(errorLogin(null, null, "ON"));
          }
        } else {
          dispatch(errorLogin(null, null, "OFF"));
        }
      })
      .catch((error) => {
        dispatch(
          ConnectionsAPI(
            true,
            false,
            true,
            "Conexão com banco de dados foi perdida :" + error,
          ),
        );
      });
  };
};

export const checkDomain = (domain, login) => {
  let obterUrlBackend = "";
  if (
    gethostname === "localhost" ||
    connection_platform.ip_intern === gethostname
  )
    obterUrlBackend =
      connection_platform.backendCentralIntern +
      ":" +
      connection_platform.backendCentralInternPort;
  else
    obterUrlBackend =
      connection_platform.backendCentralExtern +
      ":" +
      connection_platform.backendCentralExternPort;
  return (dispatch) => {
    return axios
      .post(`${connection_platform.type_connect}://${obterUrlBackend}/login`, {
        domain: domain,
      })
      .then((response) => {
        if (response.data !== "") {
          let retorno = response.data.Dados[0];
          if (
            gethostname === "localhost" ||
            connection_platform.ip_intern === gethostname
          ) {
            pathname = retorno.ip_backend_internal;
            port = retorno.port_backend_internal;
            localStorage.setItem("pathname", pathname);
            localStorage.setItem("port", port);
          } else {
            pathname = retorno.ip_backend_external;
            port = retorno.port_backend_external;
            localStorage.setItem("pathname", pathname);
            localStorage.setItem("port", port);
          }
          dispatch(LoginUsername({ email: login }));
        } else {
          dispatch(errorLogin(null, null, "ON2"));
        }
      })
      .catch((error) => {
        dispatch(
          ConnectionsAPI(
            true,
            false,
            true,
            "Conexão com banco de dados foi perdida :" + error,
          ),
        );
      });
  };
};

export const LoginUsername = (post) => {
  return (dispatch) => {
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/login2?username=${post.email}`,
      )
      .then((response) => {
        if (response.data.length !== 0) {
          if (
            response.data[0].priimsdn != null &&
            !response.data[0].secimsdn != null
          ) {
            var user_midias = [];
            response.data.map((midias) => {
              user_midias.push(midias.midiaid);
            });
            dispatch(CallParkCapture(true));
            useridRefresh = response.data[0].id;
            dispatch(
              createLoginSuccess(
                post.email,
                response.data[0].id,
                user_midias,
                response.data[0].id_auth_set,
                response.data[0].jobin_autoblocking,
                response.data[0].desc_aut_meth,
                response.data[0].address_backend,
                response.data[0].link_webchat,
                response.data[0].force_password_change,
              ),
            );
            sendIPSocket(
              response.data[0].priimsdn,
              response.data[0].secimsdn,
              portims,
            );
          } else {
            dispatch(errorLogin(null, null, "ON"));
          }
        } else {
          dispatch(errorLogin(null, null, "OFF"));
        }
      })
      .catch((error) => {
        dispatch(
          ConnectionsAPI(
            true,
            false,
            true,
            "Conexão com banco de dados foi perdida :" + error,
          ),
        );
      });
  };
};

export const AuthLogin = (post) => {
  return (dispatch, getState) => {
    const { informationusers } = getState();
    if (informationusers.ad === null) {
      return axios
        .get(
          `${
            connection_platform.type_connect
          }://${pathname}:${port}/conn/password?username=${
            informationusers.email
          }&password=${md5(post)}`,
        )
        .then((response) => {
          if (response.data !== "") {
            dispatch(
              VerifyHourWork(
                response.data.id,
                md5(post),
                informationusers.jobin_autoblocking,
                response.data.idsystem,
              ),
            );
          } else {
            dispatch(errorSenha(informationusers.email, informationusers.id));
          }
        })
        .catch((error) => {
          dispatch(
            ConnectionsAPI(
              true,
              false,
              true,
              "Conexão com banco de dados foi perdida :" + error,
            ),
          );
        });
    } else {
      if (
        informationusers.nameauth === "IngDesk" ||
        informationusers.nameauth === "URLExt"
      ) {
        return axios
          .get(
            `${
              connection_platform.type_connect
            }://${pathname}:${port}/conn/password?username=${
              informationusers.email
            }&password=${md5(post)}`,
          )
          .then((response) => {
            if (response.data !== "") {
              dispatch(
                VerifyHourWork(
                  response.data.id,
                  md5(post),
                  informationusers.jobin_autoblocking,
                  response.data.idsystem,
                  informationusers.nameauth,
                ),
              );
            } else {
              dispatch(errorSenha(informationusers.email, informationusers.id));
            }
          })
          .catch((error) => {
            dispatch(
              ConnectionsAPI(
                true,
                false,
                true,
                "Conexão com banco de dados foi perdida :" + error,
              ),
            );
          });
      } else if (informationusers.nameauth !== "Saml") {
        return axios
          .get(
            `${connection_platform.type_connect}://${pathname}:${port}/conn/loginad?username=${informationusers.email}&password=${post}`,
          )
          .then((response) => {
            if (response.data === true) {
              dispatch(GetInformationUsers(informationusers.id, md5(post)));
            } else {
              dispatch(errorSenha(informationusers.email, informationusers.id));
            }
          })
          .catch((error) => {
            dispatch(
              ConnectionsAPI(
                true,
                false,
                true,
                "Conexão com banco de dados foi perdida :" + error,
              ),
            );
          });
      } else {
        window.open(
          `${"http"}://${window.location.hostname}:${
            connection_platform.port_node
          }/azure`,
          "_self",
        );
        // if(response.data[0].desc_aut_meth === 'Saml'){
        //   window.open(`${'http'}://${window.location.hostname}:${connection_platform.port_node}/azure`, "_self");
      }
    }
  };
};

export const VerifyHourWork = (
  iduser,
  post,
  time_block,
  idsystem,
  nameauth,
) => {
  var permission = false;
  return (dispatch, getState) => {
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/checkloginday?iduser=${iduser}`,
      )
      .then((response) => {
        if (response.data === "") {
          axios
            .get(
              `${connection_platform.type_connect}://${pathname}:${port}/conn/hourworkday?iduser=${iduser}`,
            )
            .then((response) => {
              if (response.data.length !== 0) {
                permission = response.data;
                var e = Moment(permission[0].proximaentrada, "hh:mm:ss");
                //var s = Moment(permission[0].proximasaida, 'hh:mm:ss');
                var h = Moment(permission[0].hora_atual, "hh:mm:ss");
                var checkE = Moment(
                  permission[0].checkproximaentrada,
                  "hh:mm:ss",
                );
                var checkS = Moment(
                  permission[0].checkproximasaida,
                  "hh:mm:ss",
                );

                //permission = Moment(h).isBetween(e, s);
                permission = Moment(h).isBetween(checkE, checkS);
                if (permission !== false) {
                  if (time_block > 0) {
                    var returned_endate = Moment(e, "hh:mm:ss").add(
                      time_block,
                      "minutes",
                    );
                    var hour_login_exceed = Moment(returned_endate).add(
                      time_block,
                      "minutes",
                    );
                    var timeexceed = 0;
                    timeexceed = Moment(h).diff(hour_login_exceed, "seconds");
                    permission = Moment(h).isBetween(checkE, returned_endate);
                    axios
                      .get(
                        `${connection_platform.type_connect}://${pathname}:${port}/conn/checkuserblock?iduser=${iduser}`,
                      )
                      .then((response) => {
                        if (
                          response.data !== "" &&
                          response.data.durationblock === 0
                        ) {
                          var idreturnblockdescription = response.data.id;
                          axios
                            .get(
                              `${connection_platform.type_connect}://${pathname}:${port}/conn/checkuserblocksup?iduser=${iduser}`,
                            )
                            .then((response) => {
                              dispatch(
                                GetInformationUsers(
                                  iduser,
                                  post,
                                  true,
                                  idreturnblockdescription,
                                  timeexceed,
                                  response.data.id,
                                  "2",
                                  nameauth,
                                ),
                              );
                            })
                            .catch((error) => {
                              dispatch(
                                ConnectionsAPI(
                                  true,
                                  false,
                                  true,
                                  "Conexão com banco de dados foi perdida :" +
                                    error,
                                ),
                              );
                            });
                        } else {
                          if (permission === true) {
                            dispatch(
                              GetInformationUsers(iduser, post, false, 0, 0, 0),
                            );
                          } else {
                            axios
                              .get(
                                `${
                                  connection_platform.type_connect
                                }://${pathname}:${port}/conn/insertblockday?iduser=${iduser}&reason='Bloqueado por ultrapassar o limite de atraso de entrada'&touser=${idsystem}&timeexceed=${timeexceed}&exceed=${true}&typeblock=${"1"}`,
                              )
                              .then((response) => {
                                var idreturnblockdescription = response.data.id;
                                axios
                                  .get(
                                    `${
                                      connection_platform.type_connect
                                    }://${pathname}:${port}/conn/insertblockdaysup?iduser=${iduser}&reason='Bloqueado por ultrapassar o limite de atraso de entrada'&touser=${idsystem}&timeexceed=${timeexceed}&exceed=${true}&typeblock=${"1"}`,
                                  )
                                  .then((response) => {
                                    dispatch(
                                      GetInformationUsers(
                                        iduser,
                                        post,
                                        true,
                                        idreturnblockdescription,
                                        timeexceed,
                                        response.data.id,
                                        "1",
                                        nameauth,
                                      ),
                                    );
                                  })
                                  .catch((error) => {
                                    dispatch(
                                      ConnectionsAPI(
                                        true,
                                        false,
                                        true,
                                        "Conexão com banco de dados foi perdida :" +
                                          error,
                                      ),
                                    );
                                  });
                              })
                              .catch((error) => {
                                dispatch(
                                  ConnectionsAPI(
                                    true,
                                    false,
                                    true,
                                    "Conexão com banco de dados foi perdida :" +
                                      error,
                                  ),
                                );
                              });
                          }
                        }
                      })
                      .catch((error) => {
                        dispatch(
                          ConnectionsAPI(
                            true,
                            false,
                            true,
                            "Conexão com banco de dados foi perdida :" + error,
                          ),
                        );
                      });
                  } else {
                    dispatch(
                      GetInformationUsers(
                        iduser,
                        post,
                        false,
                        0,
                        0,
                        0,
                        nameauth,
                      ),
                    );
                  }
                } else {
                  dispatch(errorHour(iduser));
                }
              } else {
                dispatch(VerifyBlockUser(iduser, post, nameauth));
              }
            })
            .catch((error) => {
              dispatch(
                ConnectionsAPI(
                  true,
                  false,
                  true,
                  "Conexão com banco de dados foi perdida :" + error,
                ),
              );
            });
        } else {
          dispatch(VerifyBlockUser(iduser, post, nameauth));
        }
      })
      .catch((error) => {
        dispatch(
          ConnectionsAPI(
            true,
            false,
            true,
            "Conexão com banco de dados foi perdida :" + error,
          ),
        );
      });
  };
};

export const addChatSimultIndex = (
  iduser,
  displayname,
  active,
  opencall,
  ramal,
  datatime,
) => {
  return (dispatch, getState) => {
    const { chatsimult } = getState();

    let erro = 0;
    if (chatsimult.length != 0) {
      chatsimult.map((chat) => {
        if (parseInt(chat.iduserout) === parseInt(iduser)) {
          erro = 1;
        } else if (erro != 1) {
          erro = 0;
        }
      });
      if (erro === 1) {
        console.log("JA POSSUI CHAT ATIVO");
      } else {
        dispatch(
          addChatSimult(iduser, displayname, active, opencall, ramal, datatime),
        );
        dispatch(
          addChat(iduser, displayname, active, opencall, ramal, datatime),
        );
        dispatch(typingadd(iduser, displayname));
      }
    } else {
      dispatch(
        addChatSimult(iduser, displayname, active, opencall, ramal, datatime),
      );
      dispatch(addChat(iduser, displayname, active, opencall, ramal, datatime));
      dispatch(typingadd(iduser, displayname));
    }
  };
};

export const VerifyBlockUser = (iduser, post, nameauth) => {
  return (dispatch, getState) => {
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/checkuserblock?iduser=${iduser}`,
      )
      .then((response) => {
        if (response.data.durationblock === 0) {
          var idreturnblockdescription = response.data.id;
          axios
            .get(
              `${connection_platform.type_connect}://${pathname}:${port}/conn/checkuserblocksup?iduser=${iduser}`,
            )
            .then((response) => {
              dispatch(
                GetInformationUsers(
                  iduser,
                  post,
                  true,
                  idreturnblockdescription,
                  0,
                  response.data.id,
                  "2",
                  nameauth,
                ),
              );
              dispatch(EditReasonBlock(response.data.blockingreason));
            })
            .catch((error) => {
              dispatch(
                ConnectionsAPI(
                  true,
                  false,
                  true,
                  "Conexão com banco de dados foi perdida :" + error,
                ),
              );
            });
        } else {
          dispatch(
            GetInformationUsers(iduser, post, false, 0, 0, 0, 0, nameauth),
          );
        }
      })
      .catch((error) => {
        dispatch(
          ConnectionsAPI(
            true,
            false,
            true,
            "Conexão com banco de dados foi perdida :" + error,
          ),
        );
      });
  };
};

export const PosLoginAd = (post) => {
  return (dispatch, getState) => {
    const { informationusers } = getState();
    return axios
      .get(
        `${
          connection_platform.type_connect
        }://${pathname}:${port}/conn/password?username=${
          informationusers.email
        }&password=${md5(post)}`,
      )
      .then((response) => {
        if (response.data !== "") {
          dispatch(
            GetInformationUsers(response.data.id, md5(post), false, 0, 0, 0),
          );
        } else {
          dispatch(errorSenha(informationusers.email, informationusers.id));
        }
      })
      .catch((error) => {
        dispatch(
          ConnectionsAPI(
            true,
            false,
            true,
            "Conexão com banco de dados foi perdida :" + error,
          ),
        );
      });
  };
};

export const RefreshLogin = (username, password) => {
  return (dispatch) => {
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/password?username=${username}&password=${password}`,
      )
      .then((response) => {
        if (response.data !== "") {
          dispatch(GetInformationUsers(response.data.id, password));
        } else {
          dispatch(errorSenha(username, password));
        }
      })
      .catch((error) => {
        dispatch(
          ConnectionsAPI(
            true,
            false,
            true,
            "Conexão com banco de dados foi perdida :" + error,
          ),
        );
      });
  };
};

export const AuthLoginChangePass = (post, passwordNew) => {
  return (dispatch, getState) => {
    const { informationusers } = getState();
    return axios
      .get(
        `${
          connection_platform.type_connect
        }://${pathname}:${port}/conn/password?username=${
          informationusers.email
        }&password=${md5(post)}`,
      )
      .then((response) => {
        if (response.data !== "") {
          return axios
            .get(
              `${connection_platform.type_connect}://${pathname}:${port}/conn/updatepassword?id=${informationusers.id}&newpassword=` +
                md5(passwordNew),
            )
            .then((response) => {
              if (response.data !== "") {
                // dispatch(
                //   authSucess(informationusers.email, informationusers.id)
                // );

                // dispatch(AuthLogin(passwordNew));
                dispatch(
                  authSucess(informationusers.email, informationusers.id),
                );
                // comentado acima
                setTimeout(() => {
                  dispatch(
                    login({
                      email: informationusers.email,
                      password: md5(passwordNew),
                      setLoading: () => {},
                    }),
                  );
                }, 500);
              }
            });
        } else {
          dispatch(errorSenha(informationusers.email, informationusers.id));
        }
      })
      .catch((error) => {
        dispatch(
          ConnectionsAPI(
            true,
            false,
            true,
            "Conexão com banco de dados foi perdida :" + error,
          ),
        );
      });
  };
};

export const UpdatePasswordUser = (email, iduser, passwordNew) => {
  return (dispatch, getState) => {
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/updatepassword?id=${iduser}&newpassword=` +
          md5(passwordNew),
      )
      .then((response) => {
        dispatch(authSucess(email, iduser));
      })
      .catch((error) => {
        dispatch(
          ConnectionsAPI(
            true,
            false,
            true,
            "Conexão com banco de dados foi perdida :" + error,
          ),
        );
      });
  };
};

const getDefaultFilterFromDb = (data) => {
  try {
    const filtersInDb = data.filters_group_json;
    if (!Boolean(filtersInDb)) return null;
    const filtersInDbObj = JSON.parse(filtersInDb);
    return filtersInDbObj;
  } catch (error) {
    return null;
  }
};

const verifyIfIsToBlockEdition = (data) => {
  try {
    const allowEditFilters = data.allow_edit_filters;
    return !allowEditFilters;
  } catch (error) {
    return false;
  }
};

const getStatus = (filtersInDbObj) => {
  try {
    let status = filtersInDbObj.status;
    for (const key in STATUS_ID_MAPPING) {
      const hasThisStatus = status[key] !== undefined;
      if (!hasThisStatus) {
        status[key] = true;
      }
    }
    return status;
  } catch (error) {
    return {};
  }
};

const getQueueFilterFromDb = (data) => {
  try {
    const filtersInDb = data.filters_user_json || data.filters_group_json;
    if (!Boolean(filtersInDb)) return null;
    const filtersInDbObj = JSON.parse(filtersInDb);
    const status = getStatus(filtersInDbObj);
    filtersInDbObj.status = status;
    return filtersInDbObj;
  } catch (error) {
    return null;
  }
};

export const GetInformationUsers = (
  IdUser,
  Password,
  blockscreen,
  idblockdescription,
  timeexceed,
  idblocksupervision,
  typeblock,
  nameauth,
) => {
  return (dispatch, getState) => {
    const { informationusers } = getState();

    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/displayname?id=${IdUser}`,
      )
      .then((response) => {
        const hasData = Boolean(response) && Boolean(response.data);
        if (hasData) {
          const filtersInDbObj = getQueueFilterFromDb(response.data);
          const defaultFilter = getDefaultFilterFromDb(response.data);
          //a constante abaixo vai armazenar o valor de permitir o agente a modificar os filtros
          const isToBlockEdition = verifyIfIsToBlockEdition(response.data);
          dispatch(
            AdicionarValoresIniciaisDoFiltroDeFila(
              filtersInDbObj,
              defaultFilter,
              isToBlockEdition,
            ),
          );
        }
        setLastLogout(response.data.id)(dispatch, getState);

        setTimeout(() => {
          setLoadingDash(
            informationusers.email,
            Password,
            response.data.id,
            response.data.displayname,
            response.data.grupo,
            response.data.ramal,
            response.data.idgroup,
            response.data.username,
            response.data.idsupervisao,
            response.data.sipid,
            response.data.acessofila,
            response.data.qtdequeue,
            response.data.permitsupervisor,
            response.data.inanscount,
            response.data.incallcount,
            response.data.intmans != null ? response.data.intmans : 0,
            response.data.outanscount,
            response.data.outcallcount,
            response.data.outtmans != null ? response.data.outtmans : 0,
            response.data.psdcount,
            response.data.psdtma != null ? response.data.psdtma : 0,
            response.data.tmlogin != null ? response.data.tmlogin : 0,
            response.data.autoanswer,
            response.data.idin,
            response.data.idout,
            informationusers.user_midias,
            blockscreen,
            idblockdescription,
            timeexceed,
            idblocksupervision,
            typeblock,
            response.data.allowcallpickup,
            response.data.tmoutacw,
            response.data.allows_download,
            response.data.allow_reproduce,
            response.data.tm_camp,
            response.data.max_callback_contact,
            nameauth,
            response.data.skill,
            response.data.relatorio,
            informationusers.backendingdesk,
            informationusers.link_webchat,
            response.data.usedmodule,
            response.data.view_queue_interaction,
            response.data.gerente,
            response.data.psdfbreak,
            response.data.variables_integration,
            response.data.cadastros,
            response.data.portal,
            response.data.suporte,
            response.data.serviceout,
            response.data.force_password_change,
            response.data.qualidade,
            informationusers.tokenLogin,
            response.data.evaluation_feedback,
            response.data.classificationcount,
            response.data.tmnoreply,
            {
              maxtimerow: response.data.tempo_max_fila,
              medtimerow: response.data.tempo_medio_fila,
            },
            response.data.sending_audio,
            response.data.callback_midias,
            response.data.standby_permission,
            response.data.attach_sender_name,
            response.data.confirm_before_close,
            response.data.max_agents_on_pause,
            response.data.checkpausa,
          )(dispatch, getState);
        }, 500);

        let codec = null;

        switch (response.data.codec) {
          case "gsm":
            codec = "GSM";
            break;
          case "g729":
            codec = "G.729";
            break;
          case "alaw":
            codec = "PCMA";
            break;
          case "ulaw":
            codec = "PCMU";
            break;
          case "ilbc":
            codec = "iLBC";
            break;
          case "all":
            codec = "opus";
            break;
          case "opus":
            codec = "opus";
            break;
          default:
            codec = "all";
            break;
        }

        if (connection_platform.client_webrtc) {
          codec = "opus";
        }

        var verification_midia = false;
        // if(informationusers.user_midias)

        informationusers.user_midias.map((midia) => {
          if (midia === 1) verification_midia = true;
        });

        if (voz === true && verification_midia === true) {
          webphone_api.setparameter("language", "en");
          if (log_full_ingenium) {
            webphone_api.setparameter("loglevel", 5);
          } else {
            webphone_api.setparameter("loglevel", 5);
          }
          webphone_api.setparameter(
            "serveraddress",
            response.data.prisipproxy + ":" + response.data.prisipproxy_port,
          );
          webphone_api.setparameter("username", response.data.ramal);
          webphone_api.setparameter("sipusername", response.data.ramal);
          webphone_api.setparameter("displayname", response.data.ramal);
          webphone_api.setparameter("password", response.data.secret);
          webphone_api.setparameter("ssidcode", "w5mg8nzt");
          // webphone_api.setparameter('transfertype', 1);
          webphone_api.setparameter("transfertype", -1);
          webphone_api.setparameter("transfwithreplace", -1);
          webphone_api.setparameter("replacetype", -1);

          //webphone_api.setparameter('transfertype', 5);
          //webphone_api.setparameter('transfwithreplace', 0);
          // webphone_api.setparameter('replacetype', 0);
          webphone_api.setparameter("brandname", response.data.displayname);
          //webphone_api.setparameter('autoaccept', response.data.autoanswer);
          //webphone_api.setparameter('Beeponincoming', 1);

          webphone_api.setparameter("enginepriority_java", 0);
          if (response.data.transport === "wss") {
            webphone_api.setparameter("enginepriority_webrtc", 5);
            webphone_api.setparameter("enginepriority_ns", 0);
            webphone_api.setparameter(
              "webrtcserveraddress",
              "wss://" +
                response.data.prisipproxy +
                ":" +
                connection_platform.port_http_voz +
                "/ws",
            );
            webphone_api.setparameter(
              "stunserveraddress",
              response.data.prisipproxy + ":8090",
            );
            //webphone_api.setparameter('turnserveraddress', 'cloud.ingweb.com.br:5349');
            webphone_api.setparameter(
              "ice",
              '[{ url:"stun:' + response.data.prisipproxy + ':8090"}]',
            );
            webphone_api.setparameter("stunturnonlocal", 1);
          } else {
            webphone_api.setparameter("enginepriority_webrtc", 0);
            webphone_api.setparameter("enginepriority_ns", 5);
          }
          webphone_api.setparameter("enginepriority_flash", 0);
          webphone_api.setparameter("enginepriority_app", 0);
          webphone_api.setparameter("enginepriority_p2p", 0);
          webphone_api.setparameter("enginepriority_accessnum", 0);
          webphone_api.setparameter("enginepriority_nativedial", 0);
          webphone_api.setparameter("enginepriority_otherbrowser", 0);
          webphone_api.setparameter("dtmfmode", 4);
          webphone_api.setparameter("codec", codec);
          webphone_api.setparameter("bargeinheader", "yes");
          webphone_api.setparameter("registerinterval", 600);
          // webphone_api.setparameter('registerinterval', 30);
          webphone_api.setparameter("useragent", "Ingweb 2.0");
          webphone_api.setparameter("vad", 1);
          // webphone_api.setsipheader("");
          webphone_api.setparameter("volumein", 50);
          webphone_api.setparameter("volumeout", 50);
          webphone_api.setparameter("volumering", 50);
          webphone_api.setparameter("allowspeedup", 0);
          webphone_api.setparameter("aec", 2);
          webphone_api.setparameter("aec2", 2);
          webphone_api.setparameter("ringtimeout", 10800000);
          webphone_api.setparameter("conferencetype", 3);
          webphone_api.setparameter("mediatimeout", 0);
          webphone_api.setparameter("disableoptions", "CHAT, VIDEO, VOICEMAIL");
          webphone_api.setparameter("nsupgrademode", 2);
          webphone_api.setparameter("autohold", 0);
          webphone_api.setparameter("checkvolumesettings", 0);
          webphone_api.setparameter("keepaliveival", 30000);
          webphone_api.setparameter("wskeepaliveival", 30000);
          webphone_api.setparameter("setfinalcodec", 0);
          webphone_api.setparameter("sendrtponmuted", true);
          webphone_api.setparameter("invrecordroute", true);
          webphone_api.setparameter("forcereregister", 2); //nao encontro na documentação
          webphone_api.setparameter("use_fast_stun", 2);
          // webphone_api.setparameter("autostart", 2);
          //ALTERADO DIA 23/03/2026
          // webphone_api.setparameter("autostart", 1);
          webphone_api.setparameter("autostart", 0);
          webphone_api.setparameter("enablepresence", 0);
          webphone_api.setparameter("use_rport", 1);
          webphone_api.setparameter("defmute", 0);
          webphone_api.setparameter("multilineoop ", 3);
          webphone_api.setparameter("p2psignaling", 0);
          webphone_api.setparameter("showtoasts", false);
          webphone_api.setparameter("callreceiver", -1);
          webphone_api.setparameter("enablepush", 0);
          webphone_api.setparameter("allowcallredirect", 0);
          webphone_api.setparameter("jsscriptevent", "3");

          // Aguarda a inicialização da aplicação(ter algum status definido) antes de iniciar o webphone
          const startAfterApplicationIsReady = () => {
            const { status } = getState();
            const isNotReady = Array.isArray(status) && status.length === 0;
            if (isNotReady) {
              setTimeout(startAfterApplicationIsReady, 1000);
              return;
            } else {
              webphone_api.start();
              checkStartVoice();
            }
          };

          const requestAudioPermission = async () => {
            try {
              if (
                connection_platform.type_connect !== "https" ||
                !navigator.mediaDevices.getUserMedia
              ) {
                return;
              }
              const stream = await navigator.mediaDevices.getUserMedia({
                audio: true,
              });
              stream.getTracks().forEach((track) => track.stop());
            } catch (error) {
              console.error("Erro ao solicitar permissão de áudio: ", error);
            }
          };

          const initializeRegistration = async () => {
            await requestAudioPermission();
            startAfterApplicationIsReady();
          };

          initializeRegistration();
          // startAfterApplicationIsReady();
        }
      })
      .catch((error) => {
        dispatch(
          ConnectionsAPI(
            true,
            false,
            true,
            "Conexão com banco de dados foi perdida :" + error,
          ),
        );
      });
  };
};

function checkStartVoice() {
  setTimeout(() => {
    if (!webphone_api.isregistered()) {
      webphone_api.start();
    }
    checkStartVoice();
  }, 30000);
}

export const InsertPauseSocketAction = (
  infousers,
  pausa,
  datalogin,
  idpausa,
  status,
) => {
  return (dispatch, getState) => {
    editAgentSocket(
      infousers,
      pausa,
      datalogin,
      idpausa,
      status,
      dispatch,
      getState,
    );
  };
};

export const setLastLogout = (iduser) => {
  return (dispatch, getState) => {
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/checklastlogout?iduser=${iduser}`,
      )
      .then((response) => {
        if (parseInt(response.data.durationlogin) === 0) {
          let strDataFim =
            response.data.data_fim.substring(0, 4) +
            "-" +
            response.data.data_fim.substring(4, 6) +
            "-" +
            response.data.data_fim.substring(6, 8) +
            " " +
            response.data.data_fim.substring(8, 10) +
            ":" +
            response.data.data_fim.substring(10, 12) +
            ":" +
            response.data.data_fim.substring(12, 14);
          let valorDataFim = response.data.data_fim;
          let idLoginCorrection = response.data.id;

          return axios
            .get(
              `${connection_platform.type_connect}://${pathname}:${port}/conn/checklastaction?iduser=${iduser}&datalogin=${strDataFim}`,
            )
            .then((response2) => {
              let meuArray = [
                response2.data.fim_pausa !== null
                  ? parseInt(response2.data.fim_pausa)
                  : 0,
                response2.data.fim_pausa_futura !== null
                  ? parseInt(response2.data.fim_pausa_futura)
                  : 0,
                response2.data.fim_atendimento !== null
                  ? parseInt(response2.data.fim_atendimento)
                  : 0,
              ];
              let maior = Math.max.apply(null, meuArray);

              // if (parseInt(response2.data.duracao_pausa) === 0) {
              //   axios
              //     .get(
              //       `${connection_platform.type_connect}://${pathname}:${port}/conn/updatepausecorrection?idpause=${response2.data.id_pausa}`
              //     )
              //     .then((response4) => {})
              //     .catch((error) => {
              //       console.log("INGENIUM_PAUSECORRECTION_ERROR_2 : ", error);
              //     });
              // }

              if (parseInt(valorDataFim) < parseInt(maior)) {
                let maiorStr = maior.toString();
                let strDataFimLogin =
                  maiorStr.substring(0, 4) +
                  "-" +
                  maiorStr.substring(4, 6) +
                  "-" +
                  maiorStr.substring(6, 8) +
                  " " +
                  maiorStr.substring(8, 10) +
                  ":" +
                  maiorStr.substring(10, 12) +
                  ":" +
                  maiorStr.substring(12, 14);

                return axios
                  .get(
                    `${connection_platform.type_connect}://${pathname}:${port}/conn/updatelogincorrection?idlogin=${idLoginCorrection}&datalogout=${strDataFimLogin}`,
                  )
                  .then((response3) => {})
                  .catch((error) => {
                    console.log("INGENIUM_CHECK_LAST_LOGOUT_ERROR_2 : ", error);
                  });
              }
            })
            .catch((error) => {
              console.log("INGENIUM_CHECK_LAST_LOGOUT_ERROR_2 : ", error);
            });

          // IRA BUSCAR OS ULTIMOS ATENDIMENTOS, PAUSAS E PAUSAS FUTURAS NA DATA RETOANDA  response.data.data_fim
        }
      })
      .catch((error) => {
        console.log("INGENIUM_CHECK_LAST_LOGOUT_ERROR : ", error);
      });
  };
};
export const setLoadingDash = (
  email,
  password,
  id,
  displayname,
  grupo,
  ramal,
  idgroup,
  username,
  idsupervisao,
  sipid,
  acessofila,
  qtdequeue,
  supervisor,
  inanscount,
  incallcount,
  intmans,
  outanscount,
  outcallcount,
  outtmans,
  psdcount,
  psdtma,
  tmlogin,
  atdauto,
  idin,
  idout,
  user_midias,
  blockscreen,
  idblockdescription,
  timeexceed,
  idblocksupervision,
  typeblock,
  allowcallpickup,
  tmoutacw,
  permdownload,
  permreproduce,
  tmcallback,
  qtdecallback,
  nameauth,
  skill,
  relatorio,
  backendingdesk,
  link_webchat,
  usedmodule,
  view_queue_interaction,
  gerente,
  psdfbreak,
  variables_integration,
  cadastros,
  portal,
  suporte,
  serviceout,
  force_password_change,
  qualidade,
  tokenLogin,
  evaluation_feedback,
  classificationcount,
  tmnoreply,
  tmsdashboard,
  sending_audio,
  callback_midias,
  standby_permission,
  attach_sender_name,
  confirm_before_close,
  max_agents_on_pause,
  checkpausa,
) => {
  return (dispatch, getState) => {
    const { informationusers } = getState();
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/pausas?idsupervisiongroup=${idsupervisao}`,
      )
      .then((response) => {
        dispatch(createReasonBlock(response.data));
        getReasonBlockSup(dispatch, idsupervisao);
        getListMimetypes(dispatch);
        let data_hora_login = Moment().format("YYYY/MM/DD HH:mm:ss");
        dispatch(
          createInfoUsers(
            email,
            password,
            id,
            displayname,
            grupo,
            ramal,
            idgroup,
            username,
            idsupervisao,
            sipid,
            acessofila,
            response.reasons,
            supervisor,
            inanscount,
            incallcount,
            intmans,
            outanscount,
            outcallcount,
            outtmans,
            psdcount,
            psdtma,
            tmlogin,
            atdauto,
            idin,
            idout,
            user_midias,
            blockscreen,
            idblockdescription,
            timeexceed,
            idblocksupervision,
            typeblock,
            allowcallpickup,
            tmoutacw,
            permdownload,
            permreproduce,
            tmcallback,
            qtdecallback,
            informationusers.nameauth,
            skill,
            relatorio,
            backendingdesk,
            link_webchat,
            usedmodule,
            data_hora_login,
            view_queue_interaction,
            gerente,
            psdfbreak,
            variables_integration,
            cadastros,
            portal,
            suporte,
            serviceout,
            force_password_change,
            qualidade,
            tokenLogin,
            evaluation_feedback,
            classificationcount,
            tmnoreply,
            tmsdashboard,
            sending_audio,
            callback_midias,
            standby_permission,
            attach_sender_name,
            confirm_before_close,
            max_agents_on_pause,
            checkpausa,
          ),
        );
        IvrCallTransfer(dispatch, id);
        UsersAgents(
          id,
          displayname,
          idgroup,
          ramal,
          grupo,
          username,
          sipid,
          acessofila,
          qtdequeue,
          supervisor,
          inanscount,
          incallcount,
          intmans,
          outanscount,
          outcallcount,
          outtmans,
          psdcount,
          psdtma,
          tmlogin,
          password,
          getState,
          blockscreen,
          user_midias,
        )(dispatch);
        ServiceURL(idin, idout, informationusers.nameauth)(dispatch);
      })
      .catch((error) => {
        dispatch(
          ConnectionsAPI(
            true,
            false,
            true,
            "Conexão com banco de dados foi perdida :" + error,
          ),
        );
      });
  };
};

export const getListMimetypes = (dispatch) => {
  return axios
    .get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/list-mimetypes`,
    )
    .then((response) => {
      dispatch(addMimetypes(response.data));
    });
};

export const SearchingHistoryData = (
  histstart,
  histend,
  cdrid,
  telefone,
  idgroup,
) => {
  telefone = telefone ? telefone.replace(/^[0.]+/, "") : telefone;
  if (cdrid) {
    return (dispatch, getState) => {
      return axios
        .get(
          `${
            connection_platform.type_connect
          }://${pathname}:${port}/conn/historico?dataini=${histstart}&dataend=${histend}&telefone=${telefone}&cdr=${"1"}&idgroup=${idgroup}`,
        )
        .then((response) => {
          if (response.data !== "") {
            let responseData = response.data;
            let arrayData = [];

            responseData.forEach((item) => {
              if (item.typename === "contact") {
                const cleanedJsonString = item.messagem.replace(
                  /\\(?!["\\/bfnrtu])/g,
                  "",
                );
                let json = JSON.parse(cleanedJsonString);
                const msgArray = Array.isArray(json) ? json : [json];

                msgArray.forEach((msg, index) => {
                  arrayData.push({
                    ...item,
                    messagem: JSON.stringify(msg),
                    id: index === 0 ? item.id : `${item.id}v_${index}`,
                  });
                });
              } else {
                arrayData.push(item);
              }
            });
            dispatch(GetHistory(arrayData));
          }
        })
        .catch((error) => {
          dispatch(
            ConnectionsAPI(
              true,
              false,
              true,
              "Conexão com banco de dados foi perdida :" + error,
            ),
          );
        });
    };
  } else {
    return (dispatch, getState) => {
      const { atendimento } = getState();
      return axios
        .get(
          `${connection_platform.type_connect}://${pathname}:${port}/conn/historico?dataini=${histstart}&dataend=${histend}&telefone=${atendimento.telefone}&cdr=${atendimento.idatendimento}&idgroup=${idgroup}`,
        )
        .then((response) => {
          if (response.data !== "") {
            let responseData = response.data;
            let arrayData = [];

            responseData.forEach((item) => {
              if (item.typename === "contact") {
                const cleanedJsonString = item.messagem.replace(
                  /\\(?!["\\/bfnrtu])/g,
                  "",
                );
                let json = JSON.parse(cleanedJsonString);
                const msgArray = Array.isArray(json) ? json : [json];

                msgArray.forEach((msg, index) => {
                  arrayData.push({
                    ...item,
                    messagem: JSON.stringify(msg),
                    id: index === 0 ? item.id : `${item.id}v_${index}`,
                  });
                });
              } else {
                arrayData.push(item);
              }
            });
            dispatch(GetHistory(arrayData));
          }
        })
        .catch((error) => {
          dispatch(
            ConnectionsAPI(
              true,
              false,
              true,
              "Conexão com banco de dados foi perdida :" + error,
            ),
          );
        });
    };
  }
};

export const SearchingHistoryCDR = (telefone, cdrid, idgroup, infouser) => {
  return (dispatch) => {
    console.log("INGENIUM_SUPERVISOR : ", infouser);
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/historicocdr?telefone=${telefone}&cdr=${cdrid}&idgroup=${idgroup}&supervisor=${infouser.supervisor}`,
      )
      .then((response) => {
        if (response.data !== "") {
          let responseData = response.data;
          let arrayData = [];

          responseData.forEach((item) => {
            if (item.mimetypeid === 56) {
              item.messagem = formatMimeType56(item, "");
              item.mimetypeid = 1;
            }
            if (item.typename === "contact") {
              const cleanedJsonString = item.messagem.replace(
                /\\(?!["\\/bfnrtu])/g,
                "",
              );
              let json = JSON.parse(cleanedJsonString);
              const msgArray = Array.isArray(json) ? json : [json];

              msgArray.forEach((msg, index) => {
                arrayData.push({
                  ...item,
                  messagem: JSON.stringify(msg),
                  id: index === 0 ? item.id : `${item.id}v_${index}`,
                });
              });
            } else {
              arrayData.push(item);
            }
          });
          dispatch(GetHistory(arrayData));
        }
      })
      .catch((error) => {
        dispatch(
          ConnectionsAPI(
            true,
            false,
            true,
            "Conexão com banco de dados foi perdida :" + error,
          ),
        );
      });
  };
};

export const SearchingHistoryCDRVoz = (telefone, cdrid, idgroup) => {
  telefone = telefone.replace(/^[0.]+/, "");
  return (dispatch) => {
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/historicocdrvoz?telefone=${telefone}&cdr=${cdrid}&idgroup=${idgroup}`,
      )
      .then((response) => {
        if (response.data !== "") {
          dispatch(GetHistory(response.data));
        }
      })
      .catch((error) => {
        dispatch(
          ConnectionsAPI(
            true,
            false,
            true,
            "Conexão com banco de dados foi perdida :" + error,
          ),
        );
      });
  };
};

export const CarregamentoCDR = (queueidfila, idgroup) => {
  return (dispatch) => {
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/carregarcallback?cdr=${queueidfila}&idgroup=${idgroup}`,
      )
      .then((response) => {
        if (response.data !== "") {
          dispatch(GetHistory(response.data));
        }
      })
      .catch((error) => {
        dispatch(
          ConnectionsAPI(
            true,
            false,
            true,
            "Conexão com banco de dados foi perdida :" + error,
          ),
        );
      });
  };
};

export const CarregamentoInteractions = (cdrid, idgroup) => {
  return (dispatch, getState) => {
    const { informationusers } = getState();
    // return (dispatch) => {
    console.log("INGENIUM_SUPERVISOR : ", informationusers);
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/carregamento-new?cdr=${cdrid}&idgroup=${idgroup}&supervisor=${informationusers.supervisor}`,
      )
      .then((response) => {
        if (response.data !== "") {
          let responseData = response.data;
          let arrayData = [];

          responseData.forEach((item) => {
            if (item.mimetypeid === 56) {
              item.messagem = formatMimeType56(item, "");
              item.mimetypeid = 1;
            }
            if (item.typename === "contact") {
              const cleanedJsonString = item.messagem.replace(
                /\\(?!["\\/bfnrtu])/g,
                "",
              );
              let json = JSON.parse(cleanedJsonString);
              const msgArray = Array.isArray(json) ? json : [json];

              msgArray.forEach((msg, index) => {
                arrayData.push({
                  ...item,
                  messagem: JSON.stringify(msg),
                  id: index === 0 ? item.id : `${item.id}v_${index}`,
                });
              });
            } else {
              arrayData.push(item);
            }
          });

          dispatch(GetHistory(arrayData));
        }
      })
      .catch((error) => {
        dispatch(
          ConnectionsAPI(
            true,
            false,
            true,
            "Conexão com banco de dados foi perdida :" + error,
          ),
        );
      });
  };
};

export const getContacts = (data, contato, empresa) => {
  if (contato === undefined) {
    contato = "";
  }
  if (empresa === undefined) {
    empresa = "";
  }
  return (dispatch) => {
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/getcontactsv3?number=${data.telefone}&nome=${data.nome}&empresa=${empresa}&contato=${contato}&codext=${data.codext}&email=${data.email}`,
      )
      .then((response) => {
        if (response.data !== "") {
          dispatch(GetContacts(response.data));
        } else {
          dispatch(GetContacts([]));
        }
      })
      .catch((error) => {
        dispatch(
          ConnectionsAPI(
            true,
            false,
            true,
            "Conexão com banco de dados foi perdida :" + error,
          ),
        );
      });
  };
};

export const getContactsV2 = (data, contato, empresa, page) => {
  if (contato === undefined) {
    contato = "";
  }
  if (empresa === undefined) {
    empresa = "";
  }
  return (dispatch) => {
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/getcontacts_v3?number=${data.telefone}&nome=${data.nome}&empresa=${empresa}&contato=${contato}&codext=${data.codext}&email=${data.email}&page=${page}&limit=50`,
      )
      .then((response) => {
        if (response.data !== "") {
          return response.data;
        }
      })
      .catch((error) => {
        dispatch(
          ConnectionsAPI(
            true,
            false,
            true,
            "Conexão com banco de dados foi perdida :" + error,
          ),
        );
      });
  };
};

export const GetContactsUnit = (contactid) => {
  let actualUrl = `${connection_platform.type_connect}://${pathname}:${port}/conn/getcontactsunit?contactid=${contactid}`;
  actualUrl = `${connection_platform.type_connect}://${pathname}:${port}/conn/getcontactsunitv2?contactid=${contactid}`;

  return (dispatch) => {
    return axios
      .get(actualUrl)
      .then((response) => {
        if (response.data !== "") {
          dispatch(infoContact(response.data));
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        dispatch(
          ConnectionsAPI(
            true,
            false,
            true,
            "Conexão com banco de dados foi perdida :" + error,
          ),
        );
        throw error;
      });
  };
};

export const getNumbersContact = (contactid) => {
  return (dispatch) => {
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/getnumberscontact?id=${contactid}`,
      )
      .then((response) => {
        let data = response.data;
        if (data.length !== 0) {
          dispatch(GetNumbersContact(response.data));
        } else {
          dispatch(GetNumbersContact(response.data));
          dispatch(AddNumberContact("post", ""));
        }
      })
      .catch((error) => {
        dispatch(
          ConnectionsAPI(
            true,
            false,
            true,
            "Conexão com banco de dados foi perdida :" + error,
          ),
        );
      });
  };
};

export const getPhoneMidia = (contactid) => {
  let actualUrl = `${connection_platform.type_connect}://${pathname}:${port}/conn/phonemidia?id=${contactid}`;
  actualUrl = `${connection_platform.type_connect}://${pathname}:${port}/conn/phonemidiav2?id=${contactid}`;
  return (dispatch) => {
    return axios
      .get(actualUrl)
      .then((response) => {
        dispatch(GetPhoneMidia(response.data));
      })
      .catch((error) => {
        dispatch(
          ConnectionsAPI(
            true,
            false,
            true,
            "Conexão com banco de dados foi perdida :" + error,
          ),
        );
      });
  };
};

export const DetailsAnotationsida = (
  dataInit,
  dataFim,
  idcriticidade,
  telefone,
) => {
  telefone = telefone.replace(/^[0.]+/, "");
  if (telefone) {
    return (dispatch) => {
      return axios
        .get(
          `${connection_platform.type_connect}://${pathname}:${port}/conn/detailsanotations?numerocli=${telefone}&datainit=${dataInit}&datafim=${dataFim}&idcriticidade=${idcriticidade}`,
        )
        .then((response) => {
          dispatch(GetAnotations(response.data));
        });
    };
  } else {
    return (dispatch, getState) => {
      const { atendimento } = getState();
      return axios
        .get(
          `${connection_platform.type_connect}://${pathname}:${port}/conn/detailsanotations?numerocli=${atendimento.telefone}&datainit=${dataInit}&datafim=${dataFim}&idcriticidade=${idcriticidade}`,
        )
        .then((response) => {
          dispatch(GetAnotations(response.data));
        });
    };
  }
};

export const DetailsMarkstarida = (dataInit, dataFim, telefone) => {
  telefone = telefone.replace(/^[0.]+/, "");
  if (telefone) {
    return (dispatch) => {
      return axios
        .get(
          `${connection_platform.type_connect}://${pathname}:${port}/conn/detailsmarkstars?numerocli=${telefone}&datainit=${dataInit}&datafim=${dataFim}`,
        )
        .then((response) => {
          dispatch(GetMarkstar(response.data));
        });
    };
  } else {
    return (dispatch, getState) => {
      const { atendimento } = getState();
      return axios
        .get(
          `${connection_platform.type_connect}://${pathname}:${port}/conn/detailsmarkstars?numerocli=${atendimento.telefone}&datainit=${dataInit}&datafim=${dataFim}`,
        )
        .then((response) => {
          dispatch(GetMarkstar(response.data));
        });
    };
  }
};

export const HistoryCallsUser = (
  datainit,
  datafim,
  chamador,
  chamado,
  naoatendidas,
  ocupado,
  saida,
  entrada,
  ring,
  atendidas,
  livre,
  midias,
  mensagem,
  finalizadas,
) => {
  datainit = datainit + " 00:00:00";
  datafim = datafim + " 23:59:59";
  return (dispatch, getState) => {
    const { informationusers } = getState();
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/historyuser?iduser=${informationusers.id}&datainit=${datainit}&datafim=${datafim}&chamador=${chamador}&chamado=${chamado}&naoatendidas=${naoatendidas}&ocupado=${ocupado}&saida=${saida}&entrada=${entrada}&ring=${ring}&atendidas=${atendidas}&livre=${livre}&midias=${midias}&mensagem=${mensagem}&finalizadas=${finalizadas}`,
      )
      .then((response) => {
        dispatch(GetHistoryCalls(response.data));
      });
  };
};

export const DetailsFileShared = (
  dataInit,
  dataFim,
  formats,
  midias,
  telefone,
) => {
  telefone = telefone.replace(/^[0.]+/, "");
  if (telefone) {
    return (dispatch) => {
      return axios
        .get(
          // `${connection_platform.type_connect}://${pathname}:${port}/conn/detailsfileshared?numerocli=${telefone}&datainit=${dataInit}&datafim=${dataFim}&formats=${formats}&midias=${midias}`
          `${connection_platform.type_connect}://${pathname}:${port}/conn/detailsfileshared-v2?numerocli=${telefone}&datainit=${dataInit}&datafim=${dataFim}&formats=${formats}&midias=${midias}`,
        )
        .then((response) => {
          dispatch(GetFileShared(response.data));
        });
    };
  } else {
    return (dispatch, getState) => {
      const { atendimento } = getState();
      return axios
        .get(
          `${connection_platform.type_connect}://${pathname}:${port}/conn/detailsfileshared?numerocli=${atendimento.telefone}&datainit=${dataInit}&datafim=${dataFim}&formats=${formats}&midias=${midias}`,
        )
        .then((response) => {
          dispatch(GetFileShared(response.data));
        });
    };
  }
};

export const RespostasRapidasida = (userid) => {
  return (dispatch, getState) => {
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/respostasrapidas?iduser=${userid}`,
      )
      .then((response) => {
        dispatch(GetRespostasRapidas(response.data));
      });
  };
};

export const UserGroups = (dispatch, iduser) => {
  return axios
    .get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/groups?iduser=${iduser}`,
    )
    .then((response) => {
      dispatch(getGroups(response.data));
    });
};

export const Criticality = (dispatch) => {
  return axios
    .get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/criticality`,
    )
    .then((response) => {
      dispatch(getCriticality(response.data));
    });
};

export const Automatic_Pause = (dispatch, iduser) => {
  return axios
    .get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/automatic_pause?iduser=${iduser}`,
    )
    .then((response) => {
      dispatch(getAutomaticPause(response.data));
    });
};

export const AutomaticPause = () => {
  return (dispatch, getState) => {
    const { informationusers } = getState();
    axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/automatic_pause?iduser=${informationusers.id}`,
      )
      .then((response) => {
        dispatch(getAutomaticPause(response.data));
      });
  };
};

export const Midias = (dispatch) => {
  return axios
    .get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/getmidias`,
    )
    .then((response) => {
      dispatch(getMidias(response.data));
    });
};

export const ServicosAgrupados = (dispatch, iduser) => {
  return axios
    .get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/getservicosagrupados?iduser=${iduser}`,
    )
    .then((response) => {
      dispatch(getServicosAgrupados(response.data));
    });
};

export const BlockUserInable = (iduser, reason) => {
  return (dispatch, getState) => {
    const { informationusers } = getState();
    axios
      .get(
        `${
          connection_platform.type_connect
        }://${pathname}:${port}/conn/insertblockday?iduser=${iduser}&reason='${reason}'&touser=${
          informationusers.id
        }&timeexceed=${0}&exceed=${false}&typeblock=${"1"}`,
      )
      .then((response) => {
        axios
          .get(
            `${
              connection_platform.type_connect
            }://${pathname}:${port}/conn/insertblockdaysup?iduser=${iduser}&reason='${reason}'&touser=${
              informationusers.id
            }&timeexceed=${0}&exceed=${false}&typeblock=${"1"}`,
          )
          .then((response) => {})
          .catch((error) => {
            dispatch(
              ConnectionsAPI(
                true,
                false,
                true,
                "Conexão com banco de dados foi perdida :" + error,
              ),
            );
          });
      })
      .catch((error) => {
        dispatch(
          ConnectionsAPI(
            true,
            false,
            true,
            "Conexão com banco de dados foi perdida :" + error,
          ),
        );
      });
  };
};

export const UpdateIdleUser = (id) => {
  //let IPUser = ip.address();
  // return axios.get(`${connection_platform.type_connect}://${pathname}:${port}/conn/insertstatuslogin?id=${IdUser}&machineip=${IPUser}`)

  return axios
    .get(
      `${
        connection_platform.type_connect
      }://${pathname}:${port}/conn/updatepausefuture?id=${id}&status=${"LV"}`,
    )
    .then((response) => {
      console.log("SUCESSO AO INSERIR O STATUS AT: ", response);
    })
    .catch((error) => {
      setTimeout(() => {
        return axios.get(
          `${
            connection_platform.type_connect
          }://${pathname}:${port}/conn/updatepausefuture?id=${id}&status=${"LV"}`,
        );
      }, 2000);
    });
};

export const InsertUserLogin = (
  IdUser,
  displayname,
  idgroup,
  ramal,
  grupo,
  username,
  sipid,
  acessofila,
  qtdequeue,
  supervisor,
  inanscount,
  incallcount,
  intmans,
  outanscount,
  outcallcount,
  outtmans,
  psdcount,
  psdtma,
  tmlogin,
  blockscreen,
  user_midias,
) => {
  let IPUser = ip.address();
  return (dispatch) => {
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/insertstatusloginv3?id=${IdUser}&machineip=${IPUser}`,
      )
      .then((response) => {
        if (parseInt(response.data.id) >= 1) {
          InsertUserServiceLogin(
            IdUser,
            displayname,
            idgroup,
            ramal,
            grupo,
            username,
            sipid,
            acessofila,
            qtdequeue,
            supervisor,
            inanscount,
            incallcount,
            intmans,
            outanscount,
            outcallcount,
            outtmans,
            psdcount,
            psdtma,
            tmlogin,
            blockscreen,
            user_midias,
            response.data.id,
          )(dispatch);
          if (qtdequeue > 0) {
            GetListCallQueue(IdUser)(dispatch);
          }
        }
      });
  };
};

const getCanais = (filtrosDeFila, midias, currentFiltrosDeFila) => {
  try {
    const canais = filtrosDeFila.canais;
    const isToBlockEdition =
      currentFiltrosDeFila && currentFiltrosDeFila.isToBlockEdition;
    if (isToBlockEdition) {
      midias.forEach((midia) => {
        canais[`${midia.id}`] = true;
      });

      return canais;
    }
    midias.forEach((midia) => {
      const temEsteCanal = canais[`${midia.id}`] !== undefined;
      if (!temEsteCanal) {
        canais[`${midia.id}`] = true;
      }
    });
    return canais;
  } catch (error) {
    return {};
  }
};

const atualizarCanaisEmFiltrosDeFila = (midias) => {
  return (dispatch, getState) => {
    try {
      const { filtrosDeFila } = getState();
      const newFiltrosDeFila = {
        canais: filtrosDeFila.canais,
        status: filtrosDeFila.status,
        subservico: filtrosDeFila.subservico,
      };
      const hasMidias = Array.isArray(midias);
      if (!hasMidias) return;
      let canais = getCanais(newFiltrosDeFila, midias, filtrosDeFila);
      newFiltrosDeFila.canais = canais;
      dispatch(
        AdicionarValoresIniciaisDoFiltroDeFila(
          newFiltrosDeFila,
          null,
          filtrosDeFila.isToBlockEdition,
        ),
      );
    } catch (error) {
      console.log("atualizarCanaisEmFiltrosDeFila Error", error);
    }
  };
};

export const InsertUserServiceLogin = (
  IdUser,
  displayname,
  idgroup,
  ramal,
  grupo,
  username,
  sipid,
  acessofila,
  qtdequeue,
  supervisor,
  inanscount,
  incallcount,
  intmans,
  outanscount,
  outcallcount,
  outtmans,
  psdcount,
  psdtma,
  tmlogin,
  blockscreen,
  user_midias,
  idlogin,
) => {
  return (dispatch) => {
    var retorno_dif = "";

    let currenttime = Moment().format("YYYY-MM-DD HH:mm:ss");
    axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/currenttime?data=${currenttime}`,
      )
      .then((response) => {
        retorno_dif = response.data;
        axios
          .get(
            `${connection_platform.type_connect}://${pathname}:${port}/conn/midias`,
          )
          .then(async (response) => {
            const hasData = Boolean(response) && Boolean(response.data);
            if (hasData) {
              dispatch(atualizarCanaisEmFiltrosDeFila(response.data));
            }
            dispatch(
              GetIpCurrent(
                ipcurrent,
                aviso_sonoro_interacao,
                retorno_dif.data,
                aviso_sonoro_mensagem,
                aviso_sonoro_chamada,
                response.data,
                idlogin,
              ),
            );
          });
      });

    //axios.get(`${connection_platform.type_connect}://${pathname}:${port}/conn/insertpausassip?iduser=${IdUser}&sipid=${sipid}&status=${blockscreen ? 'BQ':'LV'}`)

    axios
      .get(
        `${
          connection_platform.type_connect
        }://${pathname}:${port}/conn/insertstatusservice?id=${IdUser}&status=${
          blockscreen ? "BQ" : "LV"
        }&sipid=${sipid}`,
      )
      .then((response) => {
        dispatch(createServiceIdLogin(response.data));
        if (response.data !== "") {
          if (supervisor === true) {
            return axios
              .get(
                `${connection_platform.type_connect}://${pathname}:${port}/conn/servicegroup?id=${IdUser}`,
              )
              .then((response) => {
                var idsss = response.data;
                var strSub = idsss
                  .map(function (elem) {
                    return elem.id;
                  })
                  .join(",");
                return axios
                  .get(
                    `${connection_platform.type_connect}://${pathname}:${port}/conn/groupmonitoring?id=${IdUser}`,
                  )
                  .then((response) => {
                    var idgrp = response.data;
                    dispatch(handleGroupsPermissionSupervisor(idgrp));
                    var strGrp = idgrp
                      .map(function (elem) {
                        return elem.usergroup;
                      })
                      .join("&");
                    return axios
                      .get(
                        `${connection_platform.type_connect}://${pathname}:${port}/conn/listgroupsupervision_v2?id=${strSub}`,
                      )
                      .then((response) => {
                        dispatch(getListSupervisionGroup(response.data));
                        return axios
                          .get(
                            `${connection_platform.type_connect}://${pathname}:${port}/conn/servicegroupgestor?id=${strSub}`,
                          )
                          .then((response) => {
                            if (response.data !== "") {
                              var subMonit = response.data;
                              var strSubMonit = subMonit
                                .map(function (elem) {
                                  return elem.serviceinid;
                                })
                                .join("&");
                              dispatch(ShowVisibleNextGroup(true, true));
                            }
                            RegisterReqWebSocket(
                              dispatch,
                              IdUser,
                              displayname,
                              idgroup,
                              ramal,
                              grupo,
                              username,
                              sipid,
                              acessofila,
                              qtdequeue,
                              supervisor,
                              strSubMonit,
                              strGrp,
                              inanscount,
                              incallcount,
                              intmans,
                              outanscount,
                              outcallcount,
                              outtmans,
                              psdcount,
                              psdtma,
                              tmlogin,
                              retorno_dif,
                              blockscreen,
                              user_midias,
                            );
                            return axios
                              .get(
                                `${connection_platform.type_connect}://${pathname}:${port}/conn/listgroupmsg?id=${IdUser}`,
                              )
                              .then((response) => {
                                dispatch(getListGroupsMsg(response.data));
                              });
                          });
                      });
                  });
              });
          } else {
            var strGrp = "";
            var strSubMonit = "";
            RegisterReqWebSocket(
              dispatch,
              IdUser,
              displayname,
              idgroup,
              ramal,
              grupo,
              username,
              sipid,
              acessofila,
              qtdequeue,
              supervisor,
              strSubMonit,
              strGrp,
              inanscount,
              incallcount,
              intmans,
              outanscount,
              outcallcount,
              outtmans,
              psdcount,
              psdtma,
              tmlogin,
              retorno_dif,
              blockscreen,
              user_midias,
            );
            return axios
              .get(
                `${connection_platform.type_connect}://${pathname}:${port}/conn/listgroupmsg?id=${IdUser}`,
              )
              .then((response) => {
                dispatch(getListGroupsMsg(response.data));
              });
          }
        }
      });
  };
};

export const dbfileSize = (size) => {
  if (size !== undefined) {
    let decimals = 2;
    if (size === 0) return "0 Bytes";
    var k = 1024,
      dm = decimals <= 0 ? 0 : decimals || 2,
      sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
      i = Math.floor(Math.log(size) / Math.log(k));
    return parseFloat((size / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }
};

export const InsertUpload = (
  data,
  InfoUsers,
  ContactId,
  caption,
  makeid,
  size,
  replyid,
) => {
  return (dispatch, getState) => {
    const { ipcurrent } = getState();
    let filePathMidia = "";
    let filePath = ipcurrent.midias.filter(
      (idmidia) => parseInt(idmidia.id) === parseInt(ContactId.idmidia),
    );
    filePathMidia = filePath[0] ? filePath[0].recorder_file_path : "";
    axios
      .post(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/insertuploadv2?filepath=${filePathMidia}`,
        data,
        {
          onUploadProgress: (ProgressEvent) => {
            let loaded = (ProgressEvent.loaded / ProgressEvent.total) * 100;
            dispatch(statusFile(loaded));
          },
        },
      )
      .then((res) => {
        SendFile(InfoUsers, ContactId, res.data.file, caption, makeid, replyid);
        let time = Moment().format("HH:mm");
        let dia = Moment().format("DD");
        let mes = Moment().format("MM");
        let ano = Moment().format("YYYY");
        mes = meses.indexOf(mes);
        dia = dia + " de " + meses[mes - 1];
        let tamanhoimg = dbfileSize(size);
        dispatch(
          addMessage(
            makeid,
            " ~¿" + caption + "~¿" + res.data.file + "~¿" + tamanhoimg,
            "Me",
            time,
            ContactId.idatendimento,
            "1",
            "enviado",
            false,
            dia,
            "",
            "",
            "",
            "0",
            replyid,
            "",
            "",
            Moment().format("YYYY"),
            Moment().format("DD/MM/YYYY HH:mm"),
          ),
        );
      });
  };
};

export const InsertUploadMonitoring = (
  data,
  InfoUsers,
  ContactId,
  caption,
  makeid,
  size,
  line,
) => {
  return (dispatch, getState) => {
    const { ipcurrent } = getState();

    let filePathMidia = "";
    let filePath = ipcurrent.midias.filter(
      (idmidia) => parseInt(idmidia.id) === parseInt(ContactId.idmidia),
    );
    filePathMidia = filePath[0] ? filePath[0].recorder_file_path : "";

    axios
      .post(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/insertuploadv2?filepath=${filePathMidia}`,
        data,
        {
          onUploadProgress: (ProgressEvent) => {
            let loaded = (ProgressEvent.loaded / ProgressEvent.total) * 100;
            dispatch(statusFile(loaded));
          },
        },
      )
      .then((res) => {
        SendFileMonitoring(
          InfoUsers,
          ContactId,
          res.data.file,
          caption,
          makeid,
          line,
        );
        let time = Moment().format("HH:mm");
        let dia = Moment().format("DD");
        let mes = Moment().format("MM");
        let ano = Moment().format("YYYY");
        mes = meses.indexOf(mes);
        dia = dia + " de " + meses[mes - 1];
        let tamanhoimg = dbfileSize(size);
        dispatch(
          addMessage(
            makeid,
            " ~¿" + caption + "~¿" + res.data.file + "~¿" + tamanhoimg,
            "Me",
            time,
            ContactId.idatendimento,
            "1",
            "enviado",
            false,
            dia,
            InfoUsers.username,
            "",
            "",
            line,
            "",
            "",
            "",
            ano,
            Moment().format("DD/MM/YYYY HH:mm"),
          ),
        );
      });
  };
};

export const UpdateInRgBlock = (
  InfoUsers,
  Pausa,
  Justificativa,
  idpausaanterior,
  idserviceslogin,
  agent,
  logout,
) => {
  return (dispatch) => {
    if (parseInt(Pausa) !== parseInt(idpausaanterior)) {
      useridPauseRefresh = InfoUsers.id;
      axios
        .get(
          `${connection_platform.type_connect}://${pathname}:${port}/conn/updatepausasdesc?iduser=${InfoUsers.id}`,
        )
        .then((response) => {
          if (response.data === true) {
            if (Justificativa === undefined) {
              InsertRgBlock(InfoUsers, Pausa)(dispatch);
            } else {
              InsertRgBlock(InfoUsers, Pausa, Justificativa)(dispatch);
            }

            if (logout) {
              dispatch(LogoutIn(InfoUsers, idserviceslogin, agent));
            }
          }
        });
    } else {
      if (Justificativa === undefined) {
        InsertRgBlock(InfoUsers, Pausa)(dispatch);
      } else {
        InsertRgBlock(InfoUsers, Pausa, Justificativa)(dispatch);
      }
    }
  };
};

export const SendNextAtd = (
  proximoatd,
  mensagem,
  contactid,
  infousers,
  ipcurrent,
  atdsimult,
) => {
  return (dispatch) => {
    SendAttendant(
      proximoatd,
      mensagem,
      contactid,
      infousers,
      dispatch,
      ipcurrent,
      undefined,
      atdsimult,
    );
  };
};

export const SendNextChat = (proximochat) => {
  return (dispatch) => {
    dispatch(addChat(proximochat.iduserout, proximochat.agent));
  };
};
export const setHoldCall = (line) => {
  webphone_api.setline(parseInt(line));
  // webphone_api.mute(true, 2);
  if (!webphone_api.isonhold()) webphone_api.hold(true);
};

export const CallConsultaInterna = (number, iduser) => {
  clearConferenceExt();
  return (dispatch, getState) => {
    const { atendimento, atdsimult } = getState();
    webphone_api.setsipheader("");

    let qtdeatdvoz = atdsimult.filter((atd) => parseInt(atd.idmidia) === 1);

    if (parseInt(qtdeatdvoz.length) !== 0) {
      webphone_api.setline(parseInt(qtdeatdvoz[0].line));
      // webphone_api.setline(webphone_api.getline());
      // setHoldCall(webphone_api.getline());
      if (!webphone_api.isonhold()) {
        webphone_api.hold(true);
      }
      dispatch(editmultiplesatd(qtdeatdvoz[0].idatendimento, 2));
      dispatch(editatd(2));
    }

    webphone_api.call(number);
    let datatime = Moment().format("YYYY/MM/DD HH:mm:ss");

    dispatch(editChat(iduser, true, true, datatime, webphone_api.getline()));
    dispatch(editChatInternal(iduser, true, true, webphone_api.getline()));

    if (atendimento.serviceatd !== undefined) {
      axios
        .get(
          `${connection_platform.type_connect}://${pathname}:${port}/conn/insertattendantactivity?idatt=${atendimento.serviceatd}&idfunc=10`,
        )
        .then((response) => {
          last_statusAgent = response.data[0].id;
        });
    } else {
      dispatch(
        createStatusAgent(
          "Atendimento",
          "CONSULTA",
          Moment().format("DD/MM/YYYY HH:mm:ss"),
          -4,
        ),
      );
    }
  };
};

export const CallConferenciaInterna = (contactId, chat) => {
  return (dispatch, getState) => {
    SendSocketConferenceCall(contactId, chat, dispatch);
  };
};

export const SendNextMonitoring = (proximomonitoring) => {
  return (dispatch) => {
    dispatch(
      addMonitoring(
        proximomonitoring.userout,
        proximomonitoring.agent,
        proximomonitoring.line,
        proximomonitoring.ramal,
      ),
    );
  };
};

export const EndcallConsultIndex = (e, agent) => {
  return (dispatch, getState) => {
    // const {atendimento} = getState();

    webphone_api.setline(parseInt(agent.line));

    //mudança feita em 06/10/2020 comentando a linha abaixo
    //webphone_api.conference('',false);

    let datatime = Moment().format("YYYY/MM/DD HH:mm:ss");
    //webphone_api.setline(webphone_api.getline());
    if (parseInt(webphone_api.getline()) > 0) {
      webphone_api.hangup(-1);
    } else {
      webphone_api.dtmf("A");
    }
    dispatch(editChat(agent.iduser, true, false, datatime, 0));
    dispatch(editChatInternal(agent.iduser, true, false, 0));

    axios.get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/updateattendantactivity?idact=${last_statusAgent}&idfunc=10`,
    );
    webphone_api.mute(false, 0);
  };
};

export const EndcallConsultIndexAtd = (e, agent) => {
  return (dispatch, getState) => {
    let datatime = Moment().format("YYYY/MM/DD HH:mm:ss");
    webphone_api.hangup();
    dispatch(editChat(agent.iduser, true, false, datatime, 0));
    dispatch(editChatInternal(agent.iduser, true, false, 0));
    axios.get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/updateattendantactivity?idact=${last_statusAgent}&idfunc=10`,
    );
    webphone_api.mute(false, 0);
  };
};

export const TransferCall = (e) => {
  return (dispatch, getState) => {
    const { atendimento } = getState();
    axios.get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/updateattendantactivity?idact=${last_statusAgent}&idfunc=10`,
    );

    axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/insertattendantactivity?idatt=${atendimento.serviceatd}&idfunc=5`,
      )
      .then((response) => {
        last_statusAgent = response.data[0].id;
      });
    // }
  };
};

export const ConferenceCall = (e) => {
  return (dispatch, getState) => {
    const { atendimento } = getState();
    axios.get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/updateattendantactivity?idact=${last_statusAgent}&idfunc=5`,
    );

    axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/insertattendantactivity?idatt=${atendimento.serviceatd}&idfunc=6`,
      )
      .then((response) => {
        last_statusAgent = response.data[0].id;
      });
    // }
  };
};

export const UpdateChamadasRecuperadas = (teste) => {
  var ongoing = "0";
  return (dispatch, getState) => {
    const { atdsimult, informationusers } = getState();
    atdsimult.map((simult) => {
      if (ongoing === "0") ongoing = simult.idatendimento;
      else ongoing = ongoing + "," + simult.idatendimento;
    });
    axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/updatecallongoing?iduser=${informationusers.id}&contactid=${ongoing}`,
      )
      .then(function (response) {
        if (response.data) {
          var array = response.data;
          array.map((ar) => {
            axios.get(
              `${connection_platform.type_connect}://${pathname}:${port}/conn/updatestartongoing?id=${ar.id}`,
            );
          });
        }
      });
  };
};

export const CloseAttendant = (contactid, infousers, reason) => {
  return (dispatch, getState) => {
    const { atendimento, atdsimult, ipcurrent, status, interactioningdesk } =
      getState();

    var now = Moment().format("YYYY/MM/DD HH:mm:ss");

    let valorDiferenca = parseInt(Math.abs(Math.round(ipcurrent.difftime)));

    if (parseInt(ipcurrent.difftime) < 0) {
      now = Moment()
        .subtract(valorDiferenca, "seconds")
        .format("YYYY/MM/DD HH:mm:ss");
    } else {
      now = Moment()
        .add(valorDiferenca, "seconds")
        .format("YYYY/MM/DD HH:mm:ss");
    }

    if (parseInt(contactid.idmidia) === 1) {
      if (infousers.tmoutacw === 0 && contactid.acw !== true) {
        webphone_api.setline(parseInt(contactid.line));
        webphone_api.hangup();
      } else if (infousers.tmoutacw !== 0 && contactid.acw !== true) {
        webphone_api.setline(parseInt(contactid.line));
        webphone_api.hangup();
      }

      if (infousers.tmoutacw === 0 || contactid.acw === true) {
        if (webphone_api.ismuted() === false) {
          webphone_api.mute(false, 0);
        }

        if (atendimento.nps_call) {
          dispatch(clearDetailsNps(atendimento.telefone));
        }
      }

      setTimeout(() => {
        dispatch(TestConnection());
      }, 3000);

      setTimeout(() => {
        SendByeAttendant(
          getState,
          contactid,
          infousers,
          dispatch,
          reason,
          atdsimult,
          status,
          interactioningdesk.payload,
        );
      }, 500);
    } else {
      SendByeAttendant(
        getState,
        contactid,
        infousers,
        dispatch,
        reason,
        atdsimult,
        status,
        interactioningdesk.payload,
      );
      if (infousers.tmoutacw !== 0 && reason !== "quarentine") {
        if (contactid.acw === true) {
          dispatch(RemoveAtd(contactid.idatendimento));

          if (atendimento.nps_call) {
            dispatch(clearDetailsNps(atendimento.telefone));
          }
          if (atdsimult.length < 2) {
            dispatch(removeAtdUnique());
            dispatch(
              createStatusAgent(
                "Encerrou",
                contactid.cliente,
                Moment().format("DD/MM/YYYY HH:mm:ss"),
                -5,
              ),
            );
            setTimeout(() => {
              dispatch(TestConnection());
            }, 3000);
          }
        } else {
          dispatch(
            createStatusAgent(
              "Aftercallwork",
              contactid.telefone,
              Moment().format("DD/MM/YYYY HH:mm:ss"),
            ),
          );
          dispatch(EditAcwContact(contactid.idatendimento));
          if (infousers.classificationcount > 0) {
            dispatch(
              EditIsTabulatorToClassification(contactid.idatendimento, false),
            );
          }
        }
      } else {
        dispatch(RemoveAtd(contactid.idatendimento));

        if (atendimento.nps_call) {
          dispatch(clearDetailsNps(atendimento.telefone));
        }
        if (atdsimult.length < 2) {
          dispatch(removeAtdUnique());
          dispatch(
            createStatusAgent(
              "Encerrou",
              contactid.cliente,
              Moment().format("DD/MM/YYYY HH:mm:ss"),
              -5,
            ),
          );
          setTimeout(() => {
            dispatch(TestConnection());
          }, 3000);
        }
      }
    }
    let duracaodocall = Moment(now).diff(
      atendimento.timecomplete,
      "seconds",
      true,
    );

    if (
      parseInt(contactid.idmidia) !== 1 &&
      status.status !== "Aftercallwork"
    ) {
      dispatch(
        EditIndicatorsUser(
          parseInt(atendimento.direction) === 2
            ? duracaodocall + parseInt(infousers.outtmans)
            : parseInt(infousers.outtmans),
          parseInt(atendimento.direction) === 1
            ? duracaodocall + parseInt(infousers.intmans)
            : parseInt(infousers.intmans),
        ),
      );
    }
  };
};

export const CloseChat = (chat) => {
  return (dispatch, getState) => {
    dispatch(removeConversation(chat.iduserout));
    dispatch(RemoveChat(chat.iduserout));
  };
};

export const CloseMonitoring = (monitoring, monitoringsimult) => {
  return (dispatch, getState) => {
    var cdrin = [];
    const { informationusers, clientusermonitors, atdsimult } = getState();

    StopMonitoring(informationusers.id, monitoring.userout);
    dispatch(removeMonitoring(monitoring.userout));
    dispatch(removeUserMonitoring(monitoring.userout));
    dispatch(removeConversationMon(monitoring.monuser));
    cdrin = clientusermonitors.filter(
      (client) => parseInt(client.monuser) === parseInt(monitoring.userout),
    );
    cdrin.map((cli) => {
      dispatch(removeConversation(cli.idatendimento));
      if (parseInt(cli.idmidia) === 3)
        dispatch(deleteEmailMsg(cli.idatendimento));
    });

    let checkatdprot = false;
    atdsimult.map((atend) => {
      if (parseInt(atend.idmidia) === 1) checkatdprot = true;
    });
    if (!checkatdprot) {
      webphone_api.hangup();
    }
  };
};

export const ReturningCallback = (
  queueid,
  inforetorno,
  recvcount,
  cdrid,
  media,
  srvin,
  caller,
  called,
  callback_count,
) => {
  return (dispatch) => {
    if (inforetorno === true) {
      const respclient = 0;
      const respatendente = 0;
      dispatch(
        initiatingReturn(
          0,
          queueid,
          recvcount,
          cdrid,
          respclient,
          media,
          srvin,
          caller,
          called,
          callback_count,
          respatendente,
        ),
      );
    }
  };
};

export const ActionIdleSocket = (
  infousers,
  pausa,
  datalogin,
  idpausa,
  status,
  statusagent,
  dispatch,
  getState,
) => {
  return (dispatch, getState) => {
    const { ipcurrent, chatsimult } = getState();
    InsertIdleSocket(
      infousers,
      pausa,
      datalogin,
      idpausa,
      status,
      statusagent,
      dispatch,
      getState,
      ipcurrent,
      chatsimult,
    );
    dispatch(
      createStatusAgent(
        "Livre",
        "Livre",
        Moment().format("DD/MM/YYYY HH:mm:ss"),
        -1,
      ),
    );
  };
};

export const UsersAgents = (
  id,
  displayname,
  idgroup,
  ramal,
  grupo,
  username,
  sipid,
  acessofila,
  qtdequeue,
  supervisor,
  inanscount,
  incallcount,
  intmans,
  outanscount,
  outcallcount,
  outtmans,
  psdcount,
  psdtma,
  tmlogin,
  password,
  getState,
  blockscreen,
  user_midias,
) => {
  return (dispatch) => {
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/users?id=${id}`,
      )
      .then((response) => {
        dispatch(addTmnoreplyPerAgent(response.data));
        dispatch(createUsersAgents(response.data));
        dispatch(EnableCall(true, false));
        setupSocket(
          getState,
          dispatch,
          id,
          displayname,
          idgroup,
          ramal,
          grupo,
          username,
          sipid,
        );

        let actualUrl =
          `${connection_platform.type_connect}://${pathname}:${port}/conn/queue?userid=` +
          id;
        actualUrl =
          `${connection_platform.type_connect}://${pathname}:${port}/conn/queuev2?userid=` +
          id;

        axios.get(actualUrl).then((response) => {
          dispatch(hstListCallQueue(response.data));
          InsertUserLogin(
            id,
            displayname,
            idgroup,
            ramal,
            grupo,
            username,
            sipid,
            acessofila,
            qtdequeue,
            supervisor,
            inanscount,
            incallcount,
            intmans,
            outanscount,
            outcallcount,
            outtmans,
            psdcount,
            psdtma,
            tmlogin,
            blockscreen,
            user_midias,
          )(dispatch);
          // broadcastChannel(getState, dispatch);
          dispatch(
            createStatusAgent(
              blockscreen ? "Pausado" : "Livre",
              blockscreen ? "Pausado" : "Livre",
              Moment().format("DD/MM/YYYY HH:mm:ss"),
              -2,
            ),
          );

          //dispatch(changeBlockStatus());

          dispatch(ShowActiveCall(""));
          // ListCallQueue(id)(dispatch);
          UserGroups(dispatch, id);
          Criticality(dispatch);
          Automatic_Pause(dispatch, id);

          setTimeout(function () {
            routerGroup(id)(dispatch);
          }, 200);

          outbandService(id)(dispatch);
          dispatch(ShowVisibleNextAtd(true, true));
          dispatch(ShowModalsMenu("Modal_INIT"));
          dispatch(
            ShowInfoDisplay(
              tela_atual_ingweb === "IngDesk" ||
                tela_atual_ingweb === "Casos" ||
                tela_atual_ingweb === "PlatformNps" ||
                tela_atual_ingweb === "NPS" ||
                tela_atual_ingweb === "QualityAgent" ||
                tela_atual_ingweb === "CarteiraDeClientes"
                ? "Clientes"
                : tela_atual_ingweb,
            ),
          );
          dispatch(
            AlterScreen(
              tela_atual_ingweb === "IngDesk" ||
                tela_atual_ingweb === "Casos" ||
                tela_atual_ingweb === "PlatformNps" ||
                tela_atual_ingweb === "NPS" ||
                tela_atual_ingweb === "QualityAgent" ||
                tela_atual_ingweb === "CarteiraDeClientes"
                ? "Clientes"
                : tela_atual_ingweb,
            ),
          );
          dispatch(ConnectionsAPI(true, true, true, ""));
          Midias(dispatch);
          ServicosAgrupados(dispatch, id);
          CarregarChatNotRead(id)(dispatch, getState);
          ChangeRecorder(id)(dispatch);
          localStorage.setItem("info_login", username + "||" + password);
          localStorage.setItem("info_iduser", id);
          dispatch(
            StartFilters(
              fila_checkbox_callback,
              fila_checkbox_espera,
              fila_checkbox_em_tratamento,
              fila_checkbox_retorno,
              filtro_fila,
            ),
          );
        });
      });
  };
};

export const ServiceURL = (idin, idout, nameauth) => {
  return (dispatch) => {
    let arrayservice = new Array(idin, idout);
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/serviceurl?id=${arrayservice}`,
      )
      .then((response) => {
        let arrayServices = response.data;
        // descomentar apenas para testes nos desenvolvimentos
        // arrayServices.map((todo) => {
        //   if (todo.typeofcrm === "IngDesk") {
        //     todo.param = "http://localhost:3000";
        //   }
        // });
        // finaliza aqui

        //aqui iremos verificar se teremos a parte do ingFaq
        const hasArrayServices =
          !!arrayServices &&
          Array.isArray(arrayServices) &&
          arrayServices.length > 0;
        if (hasArrayServices) {
          const ingFaqInfos = arrayServices.find((service) => {
            return service.typeofcrm === "IngFaq" && !!service.param;
          });
          const hasIngFaqInfos = !!ingFaqInfos;
          if (hasIngFaqInfos) {
            dispatch(
              changeStatusOfIngFaqConditions(true, true, ingFaqInfos.param),
            );
          } else {
            dispatch(changeStatusOfIngFaqConditions(false, false, ""));
          }
        }

        dispatch(createServiceUrl(arrayServices));
        if (response.data.length !== 0) {
          let ArrayServiceURL = [];
          let url_iframe = "";
          if (nameauth === "IngDesk") {
            ArrayServiceURL = response.data.filter(
              (url) => url.typeofcrm === "IngDesk",
            );
            if (ArrayServiceURL.length !== 0) {
              url_iframe = ArrayServiceURL[0].param;
              // descomentar apenas para testes nos desenvolvimentos
              // url_iframe = "http://localhost:3000";
              // finaliza aqui
              localStorage.setItem("url_iframe", url_iframe);
            }
          }
        }
      });
  };
};

export const ChangeRecorder = (IdUser) => {
  return (dispatch) => {
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/changerecorder?userid=${IdUser}`,
      )
      .then((response) => {
        dispatch(getChangeRecorder(response.data));
      });
  };
};

export const ListCallQueue = (IdUser) => {
  let actualUrl =
    `${connection_platform.type_connect}://${pathname}:${port}/conn/queue?userid=` +
    IdUser;
  actualUrl =
    `${connection_platform.type_connect}://${pathname}:${port}/conn/queuev2?userid=` +
    IdUser;
  return (dispatch) => {
    return axios.get(actualUrl).then((response) => {
      dispatch(hstListCallQueue(response.data));
    });
  };
};

export const addRouterGroupGroupedByMidiaId = (payload) => ({
  type: types.ADD_ROUTER_GROUP_GROUPED_BY_MIDIA_ID,
  payload,
});

export const routerGroup = (IdUser) => {
  return (dispatch) => {
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/routergroup?id=${IdUser}`,
      )
      .then((response) => {
        dispatch(GetRouterGroup(response.data));
        const groupedRouteById = groupRoutesGroupsByMidiaId(response.data);
        dispatch(addRouterGroupGroupedByMidiaId(groupedRouteById));
      });
  };
};

export const outbandService = (IdUser) => {
  return (dispatch) => {
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/outservice?id=${IdUser}`,
      )
      .then((response) => {
        dispatch(GetOutService(response.data));
      });
  };
};

export const ClientDetails = (post) => {
  return (dispatch) => {
    dispatch(createClientDetails(post));
  };
};

export const DownloadFileByURL = (file, name) => {
  let url = `${connection_platform.type_connect}://${ipcurrent}:${
    pathname !== connection_platform.ip_intern
      ? connection_platform.port_apache_view_extern
      : connection_platform.port_apache_view_intern
  }${file.path}`;
  return () => {
    axios({
      url: url,
      method: "GET",
      responseType: "blob",
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", name);
      document.body.appendChild(link);
      link.click();
    });
  };
};

export async function DownloadFileReturnURL(data) {
  try {
    const response = await axios.post(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/insertupload`,
      data,
      {
        onUploadProgress: (ProgressEvent) => {
          let loaded = (ProgressEvent.loaded / ProgressEvent.total) * 100;
        },
      },
    );
    return response.data.file;
  } catch (error) {
    return error;
  }
}

export const DownloadFile = (url, name) => {
  return () => {
    axios({
      url: url,
      method: "GET",
      responseType: "blob",
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", name);
      document.body.appendChild(link);
      link.click();
    });
  };
};

export const senfFileQuickAsw = (InfoUsers, ContactId, Data, texto, makeid) => {
  SendFile(InfoUsers, ContactId, Data, texto, makeid);
};

export const senfFileQuickAswMonitoring = (
  InfoUsers,
  ContactId,
  Data,
  texto,
  makeid,
  line,
) => {
  SendFileMonitoring(InfoUsers, ContactId, Data, texto, makeid, line);
};

export const InsertPausaDB = (InfoUsers, Status, isToReturn = false) => {
  return (dispatch, getState) => {
    const { atdsimult } = getState();
    if (Status === "LV") {
      useridPauseRefresh = "";
      if (isToReturn) return;
      axios
        .get(
          `${connection_platform.type_connect}://${pathname}:${port}/conn/insertpausaslv?sipid=${InfoUsers.sipid}&iduser=${InfoUsers.id}`,
        )
        .then((response) => {
          console.log("SUCESSO AO INSERIR O STATUS InsertPausaDB: ", response);
        })
        .catch((error) => {
          console.log("ERRO AO INSERIR O STATUS InsertPausaDB: ", error);

          setTimeout(() => {
            axios.get(
              `${connection_platform.type_connect}://${pathname}:${port}/conn/insertpausaslv?sipid=${InfoUsers.sipid}&iduser=${InfoUsers.id}`,
            );
          }, 1000);
        });
    } else {
      useridPauseRefresh = InfoUsers.id;
      axios
        .get(
          `${connection_platform.type_connect}://${pathname}:${port}/conn/insertpausasbq?sipid=${InfoUsers.sipid}&iduser=${InfoUsers.id}`,
        )
        .then((response) => {
          console.log(
            "SUCESSO AO INSERIR A PAUSA NO  InsertPausaDB: ",
            response,
          );
        })
        .catch((error) => {
          // dispatch(
          //   ConnectionsAPI(true, false, true, "Erro ao inserir a pausa :")
          // );

          dispatch(
            InterationNotifier(
              "Erro ao atualizar seu status. Tente novamente ou contacte o administrador do sistema!",
              "errordb",
            ),
          );
          dispatch(
            createStatusAgent(
              "Livre",
              "Livre",
              Moment().format("DD/MM/YYYY HH:mm:ss"),
            ),
          );
        });
    }

    if (InfoUsers.blockfuture === true && atdsimult.length === 0) {
      dispatch(BlockFuture(false));

      axios
        .get(
          `${connection_platform.type_connect}://${pathname}:${port}/conn/updatefuturebreak?iduser=${InfoUsers.id}`,
        )
        .then((response) => {
          if (response.data === true) {
            //aqui vou enviar para o websocket
            checkLStatusstAgIMSDN("BQ");
            console.log(
              "INGENIUMPAUSEFUTURE_ENDPOINT_INDEX : ",
              "UPDATE EFETUADO COM SUCESSO",
            );
          }
        });
    }
  };
};

export const InsertPausaBlock = (iduser, sipid) => {
  return () => {
    useridPauseRefresh = iduser;
    axios.get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/insertpausasbq?sipid=${sipid}&iduser=${iduser}`,
    );
  };
};

export const UpdateRgBlock = (InfoUsers) => {
  useridPauseRefresh = "";
  return () => {
    axios.get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/updatepausasdesc?iduser=${InfoUsers.id}`,
    );
  };
};

export const InsertTabulador = (selectedNodesTree, textTyped) => {
  return (dispatch, getState) => {
    const { atendimento, informationusers } = getState();
    selectedNodesTree.map((select) => {
      if (select._children) {
        axios
          .get(
            `${connection_platform.type_connect}://${pathname}:${port}/conn/gettabulatorfatherinsert?groupid=${informationusers.idgroup}&idfather=${select.value}`,
          )
          .then((response) => {
            if (response.data.length !== 0) {
              let array = response.data;
              array.map((todo) => {
                axios.get(
                  `${
                    connection_platform.type_connect
                  }://${pathname}:${port}/conn/insertsubcatidtabulador?subcatid=${
                    todo.subcatid
                  }&userid=${informationusers.id}&serviceatdid=${
                    atendimento.serviceatd
                  }&contactid=${null}&observation=${textTyped}&cdrid=${
                    atendimento.idatendimento
                  }`,
                );
              });
            } else {
              axios.get(
                `${
                  connection_platform.type_connect
                }://${pathname}:${port}/conn/insertsubcatidtabulador?subcatid=${
                  select.value
                }&userid=${informationusers.id}&serviceatdid=${
                  atendimento.serviceatd
                }&contactid=${null}&observation=${textTyped}&cdrid=${
                  atendimento.idatendimento
                }`,
              );
            }
          })
          .catch((error) => {
            console.log("ERROR", error);
          });
      } else {
        axios.get(
          `${
            connection_platform.type_connect
          }://${pathname}:${port}/conn/insertsubcatidtabulador?subcatid=${
            select.value
          }&userid=${informationusers.id}&serviceatdid=${
            atendimento.serviceatd
          }&contactid=${null}&observation=${textTyped}&cdrid=${
            atendimento.idatendimento
          }`,
        );
      }
    });
    dispatch(EditIsTabulatorToClassification(atendimento.idatendimento, true));
  };
};

export const UpdateRgBlockReturn = (InfoUsers) => {
  return (dispatch, getState) => {
    const { status } = getState();
    if (status.afterStatus === "Pausado") {
      useridPauseRefresh = InfoUsers.id;
      axios.get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/updatepausasdesc?iduser=${InfoUsers.id}`,
      );
    }
  };
};

export const InsertRgBlock = (InfoUsers, Pausa, Justificativa) => {
  return (dispatch) => {
    if (Pausa !== undefined && parseInt(Pausa) > 0) {
      if (Justificativa === undefined) {
        useridPauseRefresh = InfoUsers.id;
        axios
          .get(
            `${connection_platform.type_connect}://${pathname}:${port}/conn/insertpausasdesc?idreason=${Pausa}&iduser=${InfoUsers.id}`,
          )
          .then((response) => {
            console.log("LOGINGENIUM_SUCESSO_BACKEND_PAUSE: ", response);
          })
          .catch((error) => {
            dispatch(
              InterationNotifier(
                "Erro ao inserir a pausa. Tente novamente ou contacte o administrador do sistema!",
                "errordb",
              ),
            );
            dispatch(
              createStatusAgent(
                "Livre",
                "Livre",
                Moment().format("DD/MM/YYYY HH:mm:ss"),
                -1,
              ),
            );
          });
      } else {
        axios
          .get(
            `${connection_platform.type_connect}://${pathname}:${port}/conn/insertpausascomdesc?idreason=${Pausa}&iduser=${InfoUsers.id}&description=${Justificativa}`,
          )
          .then((response) => {
            console.log("LOGINGENIUM_SUCESSO_BACKEND_PAUSE: ", response);
          })
          .catch((error) => {
            dispatch(
              InterationNotifier(
                "Erro ao inserir a pausa. Tente novamente ou contacte o administrador do sistema!",
                "errordb",
              ),
            );
            dispatch(
              createStatusAgent(
                "Livre",
                "Livre",
                Moment().format("DD/MM/YYYY HH:mm:ss"),
                -1,
              ),
            );
          });
      }
    }
  };
};

export const MarkMessage = (markstar, infouser, verificarfavorito) => {
  return () => {
    axios.get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/markstar?iduser=${infouser}&messageid=${markstar}&favorito=${verificarfavorito}`,
    );
  };
};

export const LogoutIn = (InfoUsers, ServiceID, statusagent) => {
  return (dispatch, getState) => {
    const { ipcurrent, atdsimult } = getState();
    axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/updatelogout?id=${InfoUsers.id}`,
      )
      .then((response) => {
        if (response.data === true) {
          UpdateServiceLoginID(ServiceID);
          ReqSocketLogout(InfoUsers, statusagent, ipcurrent, atdsimult);
        }
      })
      .catch((error) => {
        axios
          .get(
            `${connection_platform.type_connect}://${pathname}:${port}/conn/updatelogout?id=${InfoUsers.id}`,
          )
          .then((response) => {
            if (response.data === true) {
              UpdateServiceLoginID(ServiceID);
              ReqSocketLogout(InfoUsers, statusagent, ipcurrent, atdsimult);
            }
          });
      });
  };
};

export const LogoutInGestor = (IdUser) => {
  axios.get(
    `${connection_platform.type_connect}://${pathname}:${port}/conn/updatelogout?id=${IdUser}`,
  );
};

export const UpdateInRgBlockRefresh = () => {
  axios.get(
    `${connection_platform.type_connect}://${pathname}:${port}/conn/updatepausasdesc?iduser=${useridPauseRefresh}`,
  );
};

export const UpdateServiceLoginID = (ServiceID) => {
  axios.get(
    `${connection_platform.type_connect}://${pathname}:${port}/conn/updatelogoutserviceid?id=` +
      ServiceID,
  );
};

export const IvrCallTransfer = (dispatch, iduser) => {
  return axios
    .get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/ivrcalltransfer?iduser=${iduser}`,
    )
    .then((response) => {
      dispatch(createIvrCallTransfer(response.data));
    });
};

export const getReasonBlockSup = (dispatch, idsupervisao) => {
  return axios
    .get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/pausasnc2?idsupervisiongroup=${idsupervisao}`,
    )
    .then((response) => {
      dispatch(createReasonBlockSup(response.data));
    });
};

export const InsertAnswerACK = (
  idcdr,
  telefone,
  userid,
  servicein,
  descricao,
  srvwaitid,
) => {
  telefone = telefone.replace(/^[0.]+/, "");
  return async (dispatch, getState) => {
    const { atendimento, status, informationusers } = getState();

    //ver o lenth do atendimento p ver se está em atendimento ou nao
    if (servicein !== 0) {
      console.log("INGENIUM_SERVICEOUT : ", informationusers);
      let datetimeBR = Moment().format("DD/MM/YYYY HH:mm:ss");
      return axios
        .get(
          `${connection_platform.type_connect}://${pathname}:${port}/conn/insertserviceattendantv2?idcdr=${idcdr}&iduser=${userid}&telefone=${telefone}&serviceinid=${servicein}&descricao=${descricao}&srvwaitid=${srvwaitid}&statususer=${status.status}`,
        )
        .then((response) => {
          return response.data.id;
        });
    } else {
      console.log("INGENIUM_SERVICEOUT : ", informationusers);
      let datetimeBR = Moment().format("DD/MM/YYYY HH:mm:ss");

      return axios
        .get(
          `${connection_platform.type_connect}://${pathname}:${port}/conn/insertserviceattendantv2?idcdr=${idcdr}&iduser=${userid}&telefone=${telefone}&descricao=${descricao}&srvwaitid=${srvwaitid}&statususer=${status.status}&serviceinid=${informationusers.serviceout}`,
        )
        .then((response) => {
          return response.data.id;
        });
    }
  };
};

export const GetTimeAtd = (serviceatdid) => {
  return axios
    .get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/getdataatdrecuperation?serviceatdid=${serviceatdid}`,
    )
    .then((response) => {
      return response.data.duration;
    });
};

export const InsertActivityCDR = (
  cdrid,
  idfunctionality,
  userid,
  observation,
) => {
  return axios
    .get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/insertcdractivity?cdrid=${cdrid}&idfunctionality=${idfunctionality}&userid=${userid}&observation=${observation}`,
    )
    .then((response) => {
      console.log("LOG_INGENIUM_CALLPICKUP :", response);
    });
};

export const InsertActivityATT = (
  atdid,
  idfunctionality,
  userid,
  observation,
) => {
  return axios
    .get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/insertattactivity?atdid=${atdid}&idfunctionality=${idfunctionality}&userid=${userid}&observation=${observation}`,
    )
    .then((response) => {
      console.log("LOG_INGENIUM_CALLPICKUP :", response);
    });
};

export const InsertPausaQAT = (sipid, iduser, dispatch) => {
  axios
    .get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/insertatdqat?sipid=${sipid}&iduser=${iduser}`,
    )
    .then((response) => {
      console.log("SUCESSO AO INSERIR O STATUS QAT: ", response);
    })
    .catch((error) => {
      dispatch(
        InterationNotifier(
          "Erro ao atualizar seu status. Contacte o administrador do sistema!",
          "errordb",
        ),
      );
      dispatch(
        createStatusAgent(
          "Livre",
          "Livre",
          Moment().format("DD/MM/YYYY HH:mm:ss"),
        ),
      );
    });
};

export const InsertPausaRV = (sipid, iduser, dispatch) => {
  axios
    .get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/insertatdrv?sipid=${sipid}&iduser=${iduser}`,
    )
    .then((response) => {
      console.log("SUCESSO AO INSERIR O STATUS AT: ", response);
    })
    .catch((error) => {
      dispatch(
        InterationNotifier(
          "Erro ao atualizar seu status. Contacte o administrador do sistema!",
          "errordb",
        ),
      );
      dispatch(
        createStatusAgent(
          "Livre",
          "Livre",
          Moment().format("DD/MM/YYYY HH:mm:ss"),
        ),
      );
    });
};

function isPauseStatus(status) {
  try {
    if (!Boolean(status)) return false;
    return (
      status.status === EAgentStatus.Pausado ||
      status.afterStatus === EAgentStatus.Pausado
    );
  } catch (error) {
    return false;
  }
}

export const InsertPausaRVV2 = (sipid, iduser) => {
  return (dispatch, getState) => {
    const { status } = getState();
    if (isPauseStatus(status)) return;
    axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/insertatdrv?sipid=${sipid}&iduser=${iduser}`,
      )
      .then((response) => {
        console.log("SUCESSO AO INSERIR O STATUS AT: ", response);
      })
      .catch((error) => {
        dispatch(
          InterationNotifier(
            "Erro ao atualizar seu status. Contacte o administrador do sistema!",
            "errordb",
          ),
        );
        dispatch(
          createStatusAgent(
            "Livre",
            "Livre",
            Moment().format("DD/MM/YYYY HH:mm:ss"),
          ),
        );
      });
  };
};

export const InsertPausaRVATD = (sipid, iduser, dispatch) => {
  axios
    .get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/insertatdlogin?sipid=${sipid}&iduser=${iduser}`,
    )
    .then((response) => {
      console.log("SUCESSO AO INSERIR O STATUS AT: ", response);
    })
    .catch((error) => {
      dispatch(
        InterationNotifier(
          "Erro ao atualizar seu status. Contacte o administrador do sistema!",
          "errordb",
        ),
      );
      dispatch(
        createStatusAgent(
          "Livre",
          "Livre",
          Moment().format("DD/MM/YYYY HH:mm:ss"),
        ),
      );
    });
};

export const InsertPausaLV = (sipid, iduser) => {
  useridPauseRefresh = "";
  return axios
    .get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/insertpausaslv?sipid=${sipid}&iduser=${iduser}`,
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      setTimeout(() => {
        return axios
          .get(
            `${connection_platform.type_connect}://${pathname}:${port}/conn/insertpausaslv?sipid=${sipid}&iduser=${iduser}`,
          )
          .then((response) => {
            return response.data;
          });
      }, 1000);
    });
};

export const UpdateByeAttendant = (idatendimento) => {
  return axios
    .get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/updatebyeattendant?idatendimento=${idatendimento}`,
    )
    .then((response) => {
      if (response[0] !== undefined) {
        return response.data[1].rows[0].datestart;
      } else {
        return Moment().format("YYYY-MM-DDT23:59:00");
      }
    });
};

export const UpdateByeAttendantNew = (idatendimento) => {
  return axios
    .get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/updatebyeattendantnew?idatendimento=${idatendimento}`,
    )
    .then((response) => {
      return "OK!";
    });
};

export const GetInsertCallHistory = (cdr, userid) => {
  return axios
    .get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/getidcallhistory?cdr=${cdr}&userid=` +
        userid,
    )
    .then((response) => {
      return response.data.id;
    });
};

export const UpdateByeAttendantDis = (idatendimento) => {
  return (dispatch) => {
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/updatebyeattendant?idatendimento=${idatendimento}`,
      )
      .then((response) => {
        if (response[0] !== undefined) {
          return response.data[1].rows[0].datestart;
        } else {
          return Moment().format("YYYY-MM-DDT23:59:00");
        }
      });
  };
};

export const UpdateByeAttendantCdr = (idcdr, userid) => {
  return axios
    .get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/updatebyeattendantcdr?idcdr=${idcdr}`,
    )
    .then((response) => {
      return response.data[1].rows[0].datestart;
    });
};

export const UpdateByeAttendantRecuperation = (idatendimento) => {
  return axios
    .get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/updatebyeattendantrecuperation?idatendimento=${idatendimento}`,
    )
    .then((response) => {
      return response.data;
    });
};

export const InsertAnotations = (
  idcdr,
  criticidade,
  comentario,
  userid,
  serviceatd,
) => {
  return () => {
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/insertanotation?idcdr=` +
          idcdr +
          `&userid=` +
          userid +
          `&criticidade=` +
          criticidade +
          `&comentario=` +
          comentario +
          `&serviceatd=` +
          serviceatd,
      )
      .then((response) => {
        return response.data;
      });
  };
};

export const GetCompanys = (IdUser) => {
  return (dispatch) => {
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/companys`,
      )
      .then((response) => {
        dispatch(getCompanys(response.data));
      });
  };
};

export const GetCompanysV2 = (title, page) => {
  if (!title) {
    title = "";
  }
  return (dispatch) => {
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/companys_v2?page=${page}&limit=50&title=${title}`,
      )
      .then((response) => {
        if (response.status === 200) {
          return response.data;
        }
      });
  };
};

export const GetTypeNumbers = (post) => {
  return (dispatch) => {
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/typenumbers`,
      )
      .then((response) => {
        dispatch(getTypeNumbers(response.data));
      });
  };
};

export const getCep = (cep) => {
  cep = cep.replace(/\D+/g, "");
  return (dispatch) => {
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/getcep?cep=` +
          cep,
      )
      .then((response) => {
        dispatch(GetCep(response.data));
      });
  };
};

export const getCepApi = (cep) => {
  cep = cep.replace(/\D+/g, "");
  return (dispatch) => {
    if (cep.length < 8) {
      return dispatch(GetCep([]));
    } else {
      return axios
        .get(`https://viacep.com.br/ws/${cep}/json/`)
        .then((response) => {
          if (response.status === 200) {
            dispatch(GetCep([response.data]));
          }
        });
    }
  };
};

export const UpdateContact = (
  contactid,
  displayname,
  name,
  email,
  cpf,
  rg,
  codigoexterno,
  nascimento,
  endereco,
  numero,
  district,
  cepassociationid,
  numberdel,
  particular,
  contatode,
  editAtendimento,
) => {
  return (dispatch) => {
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/updatecontact?contactid=` +
          contactid +
          `&displayname=` +
          displayname +
          `&name=` +
          name +
          `&email=` +
          email +
          `&cpf=` +
          cpf +
          `&rg=` +
          rg +
          `&codigoexterno=` +
          codigoexterno +
          `&nascimento=` +
          nascimento +
          `&district=` +
          district +
          `&endereco=` +
          endereco +
          `&numero=` +
          numero +
          `&cepassociationid=` +
          cepassociationid +
          `&particular=` +
          particular +
          `&contatode=` +
          contatode,
      )
      .then((response) => {
        if (response.data) {
          if (editAtendimento) {
          }
          return response.data;
        }
      });
  };
};

export const UpdateCompany = (
  inscricaoestadual,
  estadualmunicipal,
  site,
  emailcompany,
  cnpj,
  business,
  companyid,
) => {
  return (dispatch) => {
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/updatecompany?companyid=` +
          companyid +
          `&inscricaoestadual=` +
          inscricaoestadual +
          `&estadualmunicipal=` +
          estadualmunicipal +
          `&site=` +
          site +
          `&emailcompany=` +
          emailcompany +
          `&cnpj=` +
          cnpj +
          `&business=` +
          business,
      )
      .then((response) => {
        return response.data;
      });
  };
};

export const InsertCompany = (
  inscricaoestadual,
  estadualmunicipal,
  site,
  emailcompany,
  cnpj,
  business,
  iduser,
) => {
  cnpj = cnpj.replace(/\D+/g, "");
  return (dispatch) => {
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/insertcompany?inscricaoestadual=` +
          inscricaoestadual +
          `&estadualmunicipal=` +
          estadualmunicipal +
          `&site=` +
          site +
          `&emailcompany=` +
          emailcompany +
          `&cnpj=` +
          cnpj +
          `&business=` +
          business +
          `&iduser=` +
          iduser,
      )
      .then((response) => {
        if (response.data) {
          dispatch(ShowModalsMenu("cadastro_company"));
        }
      });
  };
};

export const UpdateCompanyContact = (contactid, companyid) => {
  return (dispatch) => {
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/updatecompanycontact?contactid=` +
          contactid +
          `&companyid=` +
          companyid,
      )
      .then((response) => {
        return response.data;
      });
  };
};

export const deleteNumberContact = (numberdel, iduser) => {
  return (dispatch, getState) => {
    const { informationusers } = getState();
    let iduser = informationusers.id;
    numberdel.map((number) =>
      axios
        .get(
          `${connection_platform.type_connect}://${pathname}:${port}/conn/deletenumber?idphone=` +
            number +
            `&iduser=` +
            iduser,
        )
        .then((response) => {
          return response.data;
        }),
    );
  };
};

export const UpdateContactNumber = (numberscontact, iduser, contactid) => {
  return (dispatch) => {
    numberscontact.map((number) => {
      if (number.type === 0) {
        axios
          .get(
            `${connection_platform.type_connect}://${pathname}:${port}/conn/phonexist?contactid=` +
              contactid +
              `&number=` +
              number.number,
          )
          .then((response) => {
            if (response.data.length === 0) {
              axios
                .get(
                  `${connection_platform.type_connect}://${pathname}:${port}/conn/updatephonev2?idphone=` +
                    number.idphone +
                    `&phonetypeid=` +
                    number.phonetypeid +
                    `&number=` +
                    number.number +
                    `&midiaid=` +
                    number.midiaid,
                )
                .then((response) => {
                  return response.data;
                });
            } else {
              dispatch(ErrorNumberExist(number.number));
            }
          });
      } else {
        if (number.number !== "") {
          axios
            .get(
              `${connection_platform.type_connect}://${pathname}:${port}/conn/phonexist?contactid=` +
                contactid +
                `&number=` +
                number.number,
            )
            .then((response) => {
              if (response.data.length === 0) {
                axios
                  .get(
                    `${connection_platform.type_connect}://${pathname}:${port}/conn/insertphonev2?phonetypeid=` +
                      number.phonetypeid +
                      `&number=` +
                      number.number +
                      `&iduser=` +
                      iduser +
                      `&midiaid=` +
                      number.midiaid,
                  )
                  .then((response) => {
                    if (response.data !== "") {
                      let data = response.data;
                      axios
                        .get(
                          `${connection_platform.type_connect}://${pathname}:${port}/conn/insertcontactphone?contactid=` +
                            contactid +
                            `&phoneid=` +
                            data[0].id,
                        )
                        .then((response) => {
                          return response.data;
                        });
                    }
                  });
              } else {
                dispatch(ErrorNumberExist(number.number));
              }
            });
        }
      }
    });
  };
};

export const InsertCompanyContact = (contactid, companyid) => {
  return (dispatch) => {
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/insertcompanycontact?contactid=` +
          contactid +
          `&companyid=` +
          companyid,
      )
      .then((response) => {
        return response.data;
      });
  };
};

export const SearchCompany = (cnpj, empresa) => {
  return (dispatch) => {
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/getcompanys?cnpj=` +
          cnpj +
          `&empresa=` +
          empresa,
      )
      .then((response) => {
        dispatch(getCompanys(response.data));
      });
  };
};

export const ActionRefreshNoAnswer = (queueid) => {
  return (dispatch) => {
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/actionrefreshnoanwser?queueid=` +
          queueid,
      )
      .then((response) => {
        dispatch(DispatchRefreshNoAnswer(queueid));
      });
  };
};

export const ActionDeleteCall = (queueid, obs, iduser, sucess, mediaid) => {
  return (dispatch) => {
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/actiondeletecall?queueid=` +
          queueid +
          `&obs=` +
          obs +
          `&iduser=` +
          iduser +
          `&sucess=` +
          sucess +
          `&mediaid=` +
          mediaid,
      )
      .then((response) => {
        return response.data;
      });
  };
};

export const InsertContactNew = (
  displayname,
  name,
  email,
  cpf,
  rg,
  codigoexterno,
  nascimento,
  endereco,
  numero,
  district,
  cepassociationid,
  particular,
  usercreate,
  numberscontact,
  contatode,
  empresa,
  screen,
  detailscontact,
  detailsScript,
  idrelacao = "",
  idcargo = "",
) => {
  return (dispatch, getState) => {
    const { informationusers } = getState();
    // if (informationusers.nameauth === "IngDesk") {
    //   dispatch(
    //     InsertContactIngDesk(
    //       informationusers.backendingdesk,
    //       displayname,
    //       name,
    //       email,
    //       cpf,
    //       rg,
    //       codigoexterno,
    //       endereco,
    //       numero,
    //       district,
    //       numberscontact,
    //       informationusers.token_ingdesk,
    //       empresa
    //     )
    //   );
    // }
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/insertcontact?displayname=` +
          displayname +
          `&name=` +
          name +
          `&email=` +
          email +
          `&cpf=` +
          cpf +
          `&rg=` +
          rg +
          `&externcode=` +
          codigoexterno +
          `&nascimento=` +
          nascimento +
          `&endereco=` +
          endereco +
          `&numero=` +
          numero +
          `&district=` +
          district +
          `&cepassociationid=` +
          cepassociationid +
          `&particular=` +
          particular +
          `&costumerof=` +
          contatode +
          `&usercreate=` +
          usercreate +
          `&idrelacao=` +
          idrelacao +
          `&idcargo=` +
          idcargo,
      )
      .then((response) => {
        if (response.data !== "") {
          let data = response.data;
          let contactid = data[0].id;
          if (screen !== "history")
            dispatch(ShowModalsMenu("cadastro_contato"));
          if (empresa !== "") {
            var companyid = empresa;
            companyid = companyid[0].value;
            InsertCompanyContact(contactid, companyid)(dispatch);
          }
          if (detailscontact.detailsget) {
            dispatch(editClientName(numberscontact, displayname));
            UpdateContactInteraction(
              informationusers.id,
              detailsScript.serverid,
              detailsScript.cdr,
              contactid,
              displayname,
            );
          }
          numberscontact.map((number) => {
            let telefone = number.number;
            if (telefone.length > 2) {
              axios
                .get(
                  `${connection_platform.type_connect}://${pathname}:${port}/conn/insertphonev2?phonetypeid=` +
                    number.phonetypeid +
                    `&number=` +
                    telefone +
                    `&iduser=` +
                    usercreate +
                    `&midiaid=` +
                    number.midiaid,
                )
                .then((response) => {
                  if (response.data !== "") {
                    let data = response.data;
                    axios
                      .get(
                        `${connection_platform.type_connect}://${pathname}:${port}/conn/insertcontactphone?contactid=` +
                          contactid +
                          `&phoneid=` +
                          data[0].id,
                      )
                      .then((response) => {
                        return response.data;
                      });
                  }
                });
            }
          });
        }
      });
  };
};

export const InteracoesDealGet = (cdrid) => {
  return (dispatch) => {
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/get-deal-interaction?cdrid=${cdrid}`,
      )
      .then((response) => {
        dispatch(GetInteractionsContact(response.data));
      });
  };
};

export const InteracoesContactNumber = (
  post,
  datainit,
  datafim,
  mensagem,
  idgroup,
  idcontact,
) => {
  post = post.replace(/^[0.]+/, "");
  return (dispatch) => {
    if (idcontact > 0 && idcontact) {
      return axios
        .get(
          `${connection_platform.type_connect}://${pathname}:${port}/conn/interactionscontactnumbersv2?datainit=` +
            datainit +
            `&datafim=` +
            datafim +
            `&number=` +
            post +
            `&mensagem=` +
            mensagem +
            `&idgroup=` +
            idgroup +
            `&idcontact=` +
            idcontact,
        )
        .then((response) => {
          dispatch(GetInteractionsContact(response.data));
        });
    } else {
      return axios
        .get(
          `${connection_platform.type_connect}://${pathname}:${port}/conn/interactionscontactnumbers?datainit=` +
            datainit +
            `&datafim=` +
            datafim +
            `&number=` +
            post +
            `&mensagem=` +
            mensagem +
            `&idgroup=` +
            idgroup,
        )
        .then((response) => {
          dispatch(GetInteractionsContact(response.data));
        });
    }
  };
};

export const InteracoesContactNumberPeer = (post, idgroup) => {
  post = post.replace(/^[0.]+/, "");
  const agora = Moment().subtract(7, "days");
  let datainit = agora.format("YYYY-MM-DDT00:00");
  let datafim = Moment().format("YYYY-MM-DDT23:59");
  let mensagem = "";
  return (dispatch) => {
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/interactionscontactnumbers?datainit=` +
          datainit +
          `&datafim=` +
          datafim +
          `&number=` +
          post +
          `&mensagem=` +
          mensagem +
          `&idgroup=` +
          idgroup,
      )
      .then((response) => {
        dispatch(GetInteractionsContact(response.data));
      });
  };
};

export const CallButtonAccept = (idatendimento) => {
  // webphone_api.setline(idatendimento);
  webphone_api.accept();
  webphone_api.mute(false, 2);
  return true;
};

export const CallButtonReject = () => {
  webphone_api.reject();
};

export const CallButtonMute = () => {
  webphone_api.mute(true, 2);
};

export const tratarAfterCallWork = (timeout, idatendimento, finalizar) => {
  return (dispatch, getState) => {
    const { atendimento, informationusers } = getState();
    console.log("INGENIUM_CHECANDO_ACW : ", atendimento.serviceatd);
    if (!checkTransferACW) {
      console.log("INGENIUM_CHECANDO_ACW : ", atendimento.serviceatd);
      if (!finalizar) {
        console.log("INGENIUM_CHECANDO_ACW : ", atendimento.serviceatd);
        dispatch(InsertACW(atendimento.serviceatd));
        SendReqAfterCallWork(informationusers, atendimento);
        const timeoutID = setTimeout(() => {
          dispatch(UpdateACW(atendimento.serviceatd, 62));
          dispatch(tratarAfterCallWorkV2(idatendimento));
        }, timeout * 1000);
        idAtdACW[idatendimento] = timeoutID;
      } else {
        dispatch(UpdateACW(idatendimento, 63));
        clearTimeout(idAtdACW[idatendimento]);
      }
    } else {
      dispatch(UpdateACW(idatendimento, 63));
      clearTimeout(idAtdACW[idatendimento]);
    }
  };
};

export const tratarAfterCallWorkCDR = (timeout, idcdr, finalizar) => {
  return (dispatch, getState) => {
    const { atendimento, informationusers, atdsimult } = getState();

    let idatendimento = atdsimult.filter(
      (atd) => parseInt(atd.idatendimento) === parseInt(idcdr),
    );
    console.log("INGENIUM_CHECANDO_ACW : ", finalizar);

    if (!finalizar) {
      if (!atendimento.serviceatd) return;
      console.log("INGENIUM_CHECANDO_ACW : ", atendimento.serviceatd);
      dispatch(InsertACW(atendimento.serviceatd));
      SendReqAfterCallWork(informationusers, atendimento);
      const timeoutID = setTimeout(() => {
        dispatch(UpdateACW(atendimento.serviceatd, 62));
        dispatch(tratarAfterCallWorkV2(idatendimento[0].serviceatd));
      }, timeout * 1000);
      idAtdACW[idatendimento[0].serviceatd] = timeoutID;
    } else {
      if (!idatendimento[0].serviceatd) return;
      dispatch(UpdateACW(idatendimento[0].serviceatd, 63));
      clearTimeout(idAtdACW[idatendimento[0].serviceatd]);
    }
  };
};

export const tratarAfterCallWorkTransfer = (timeout, idatendimento) => {
  return (dispatch, getState) => {
    const { atendimento, informationusers } = getState();
    checkTransferACW = true;
    console.log("INGENIUM_CHECANDO_ACW : ", atendimento.serviceatd);
    dispatch(InsertACW(atendimento.serviceatd));
    SendReqAfterCallWork(informationusers, atendimento);
    const timeoutID = setTimeout(() => {
      dispatch(UpdateACW(atendimento.serviceatd, 62));
      dispatch(tratarAfterCallWorkV2(idatendimento));
      checkTransferACW = false;
    }, timeout * 1000);
    idAtdACW[idatendimento] = timeoutID;
  };
};

export const tratarAfterCallWorkV2 = (idatendimento) => {
  return (dispatch, getState) => {
    const { atdsimult } = getState();
    const atendimento = atdsimult.filter(
      (atd) => parseInt(atd.serviceatd) === parseInt(idatendimento),
    );
    console.log("INGENIUM_CHECK_ACW_TRATAR_0 : ", atendimento);
    console.log("INGENIUM_CHECK_ACW_TRATAR_1 : ", idatendimento);

    if (atendimento && atendimento.length !== 0) {
      console.log("INGENIUM_CHECK_ACW_TRATAR_2 : ", atendimento[0].serviceatd);
      if (
        parseInt(atendimento[0].serviceatd) === parseInt(idatendimento) ||
        atendimento[0].serviceatd === "retornoatt"
      ) {
        dispatch(byeAcwCall(atendimento[0].idatendimento));
        clearTimeout(idAtdACW[atendimento[0].serviceatd]);
        // clearTimeout(structAcwCallIndex[0].timeoutID);
        // structAcwCallIndex.splice(0, 1);
      }
    }
  };
};

export const MuteStatus = (statusmute) => {
  return (dispatch, getState) => {
    const { atendimento } = getState();
    webphone_api.setline(parseInt(atendimento.line));
    if (webphone_api.isonhold()) webphone_api.hold(false);
    webphone_api.mute(statusmute, 2);
    if (atendimento.statusatd === 0) {
      axios
        .get(
          `${connection_platform.type_connect}://${pathname}:${port}/conn/insertattendantactivity?idatt=${atendimento.serviceatd}&idfunc=3`,
        )
        .then((response) => {
          last_statusAgent = response.data[0].id;
        });
      dispatch(editmultiplesatd(atendimento.idatendimento, 3));
      dispatch(editatd(3));
    } else {
      if (atendimento.statusatd !== 3) {
        axios.get(
          `${connection_platform.type_connect}://${pathname}:${port}/conn/updateattendantactivity?idact=${last_statusAgent}&idfunc=2`,
        );
        axios
          .get(
            `${connection_platform.type_connect}://${pathname}:${port}/conn/insertattendantactivity?idatt=${atendimento.serviceatd}&idfunc=3`,
          )
          .then((response) => {
            last_statusAgent = response.data[0].id;
          });
        dispatch(editmultiplesatd(atendimento.idatendimento, 3));
        dispatch(editatd(3));
      } else {
        axios.get(
          `${connection_platform.type_connect}://${pathname}:${port}/conn/updateattendantactivity?idact=${last_statusAgent}&idfunc=3`,
        );
        dispatch(editmultiplesatd(atendimento.idatendimento, 0));
        dispatch(editatd(0));
      }
    }
  };
};

export const MuteStatusSimult = (statusmute, atendimento) => {
  return (dispatch, getState) => {
    // const { atendimento } = getState();
    webphone_api.setline(parseInt(atendimento.line));
    if (webphone_api.isonhold()) webphone_api.hold(false);
    webphone_api.mute(statusmute, 2);
    if (atendimento.statusatd === 0) {
      axios
        .get(
          `${connection_platform.type_connect}://${pathname}:${port}/conn/insertattendantactivity?idatt=${atendimento.serviceatd}&idfunc=3`,
        )
        .then((response) => {
          last_statusAgent = response.data[0].id;
        });
      dispatch(editmultiplesatd(atendimento.idatendimento, 3));
      // dispatch(editatd(3));
    } else {
      if (atendimento.statusatd !== 3) {
        axios.get(
          `${connection_platform.type_connect}://${pathname}:${port}/conn/updateattendantactivity?idact=${last_statusAgent}&idfunc=2`,
        );
        axios
          .get(
            `${connection_platform.type_connect}://${pathname}:${port}/conn/insertattendantactivity?idatt=${atendimento.serviceatd}&idfunc=3`,
          )
          .then((response) => {
            last_statusAgent = response.data[0].id;
          });
        dispatch(editmultiplesatd(atendimento.idatendimento, 3));
        // dispatch(editatd(3));
      } else {
        axios.get(
          `${connection_platform.type_connect}://${pathname}:${port}/conn/updateattendantactivity?idact=${last_statusAgent}&idfunc=3`,
        );
        dispatch(editmultiplesatd(atendimento.idatendimento, 0));
        // dispatch(editatd(0));
      }
    }
  };
};

export const PauseStatus = (statuspause) => {
  return (dispatch, getState) => {
    const { atendimento, chatsimult } = getState();

    if (atendimento.statusatd === 0) {
      axios
        .get(
          `${connection_platform.type_connect}://${pathname}:${port}/conn/insertattendantactivity?idatt=${atendimento.serviceatd}&idfunc=2`,
        )
        .then((response) => {
          last_statusAgent = response.data[0].id;
        });
      dispatch(editmultiplesatd(atendimento.idatendimento, 2));
      dispatch(editatd(2));
      setTimeout(function () {
        let valorLineInternal = chatsimult.filter((chat) => chat.voz === true);

        if (valorLineInternal && valorLineInternal.length !== 0) {
          webphone_api.setline(parseInt(valorLineInternal[0].line));
          if (webphone_api.isonhold()) webphone_api.hold(false);
        }
      }, 1000);
    } else {
      if (atendimento.statusatd !== 2) {
        axios.get(
          `${connection_platform.type_connect}://${pathname}:${port}/conn/updateattendantactivity?idact=${last_statusAgent}&idfunc=3`,
        );
        axios
          .get(
            `${connection_platform.type_connect}://${pathname}:${port}/conn/insertattendantactivity?idatt=${atendimento.serviceatd}&idfunc=2`,
          )
          .then((response) => {
            last_statusAgent = response.data[0].id;
          });
        dispatch(editmultiplesatd(atendimento.idatendimento, 2));
        dispatch(editatd(2));
        setTimeout(function () {
          let valorLineInternal = chatsimult.filter(
            (chat) => chat.voz === true,
          );

          if (valorLineInternal && valorLineInternal.length !== 0) {
            webphone_api.setline(parseInt(valorLineInternal[0].line));
            if (webphone_api.isonhold()) webphone_api.hold(false);
          }
        }, 1000);
      } else {
        axios.get(
          `${connection_platform.type_connect}://${pathname}:${port}/conn/updateattendantactivity?idact=${last_statusAgent}&idfunc=2`,
        );
        dispatch(editmultiplesatd(atendimento.idatendimento, 0));
        dispatch(editatd(0));

        setTimeout(function () {
          let valorLineInternal = chatsimult.filter(
            (chat) => chat.voz === true,
          );

          if (valorLineInternal && valorLineInternal.length !== 0) {
            webphone_api.setline(parseInt(valorLineInternal[0].line));
            if (!webphone_api.isonhold()) webphone_api.hold(true);
          }
        }, 1000);
      }
    }

    webphone_api.setline(parseInt(atendimento.line));
    if (webphone_api.isonhold() !== statuspause) webphone_api.hold(statuspause);
  };
};

export const DelContact = (contactid, iduser) => {
  return (dispatch) => {
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/deletecontact?id=${contactid}&iduser=${iduser}`,
      )
      .then((response) => {
        if (response.data) {
          dispatch(DeleteContact(contactid));
        }
      })
      .catch((error) => {
        dispatch(
          ConnectionsAPI(
            true,
            false,
            true,
            "Conexão com banco de dados foi perdida :" + error,
          ),
        );
      });
  };
};

export const InitialInteractionMail = (email) => {
  return async (dispatch, getState) => {
    const { ipcurrent, outservices, informationusers, atendimento, status } =
      getState();
    let outband = outservices;
    let infouser = informationusers;
    return axios
      .get(
        `${
          connection_platform.type_connect
        }://${pathname}:${port}/conn/insertactivecall?idtrunk=4&servicecode=${
          outband.idservice
        }&idmidia=3&caller=${infouser.ramal}&called='${"email"}'&idcustomer=${
          outband.idcustomer
        }&iddirection=${outband.iddirection}`,
      )
      .then((response) => {
        let retorno = response.data.id;
        var valorDiferenca = parseInt(Math.abs(Math.round(ipcurrent.difftime)));
        var datacorreta = "";
        if (parseInt(ipcurrent.difftime) < 0) {
          datacorreta = Moment()
            .subtract(valorDiferenca, "seconds")
            .format("DD/MM/YYYY HH:mm:ss");
        } else {
          datacorreta = Moment()
            .add(valorDiferenca, "seconds")
            .format("DD/MM/YYYY HH:mm:ss");
        }
        // let cdr = Math.floor(Math.random() * 512)
        let cdr = retorno;
        let datetimeBR = Moment().format("DD/MM/YYYY HH:mm:ss");

        console.log("INGENIUM_SERVICEOUT : ", informationusers);

        axios
          .get(
            `${
              connection_platform.type_connect
            }://${pathname}:${port}/conn/insertserviceattendantv2?idcdr=${retorno}&iduser=${
              infouser.id
            }&telefone=${"email"}&descricao=Saida&serviceinid=&statususer=${
              status.status
            }`,
          )
          .then((response) => {
            let retornoatt = response.data.id;
            dispatch(
              createStatusAgent(
                "Atendimento",
                "Atendimento",
                Moment().format("DD/MM/YYYY HH:mm:ss"),
                -3,
              ),
            );
            dispatch(
              addAtendimento(
                cdr,
                "Assunto",
                email, // "9999"
                "Assunto",
                Moment().format("DD/MM/YYYY HH:mm:ss"),
                "",
                "",
                "",
                retornoatt,
                "",
                datacorreta,
                "2",
                "3",
                "",
                "",
                "0",
                "",
                "",
                "",
                "",
                "",
              ),
            );
            dispatch(
              addAtdSimult(
                cdr,
                "Assunto",
                email, // "9999"
                "Assunto",
                Moment().format("DD/MM/YYYY HH:mm:ss"),
                "",
                "",
                "",
                retornoatt,
                "",
                datacorreta,
                "2",
                "3",
                "",
                "",
                "0",
                "",
                "",
                "",
                "",
                "",
              ),
            );
          })
          .catch((error) => {
            dispatch(
              ConnectionsAPI(
                true,
                false,
                true,
                "Conexão com banco de dados foi perdida :" + error,
              ),
            );
          });
      })
      .catch((error) => {
        dispatch(
          ConnectionsAPI(
            true,
            false,
            true,
            "Conexão com banco de dados foi perdida :" + error,
          ),
        );
      });
  };
};

export const InsertACW = (idatd) => {
  console.log("INGENIUM_CHECANDO_ACW : ", idatd);
  return (dispatch) => {
    console.log("INGENIUM_CHECANDO_ACW : ", idatd);
    return axios.get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/insert-acw?atdid=${idatd}`,
    );
  };
};

export const UpdateACW = (idatd, idreason) => {
  return (dispatch) => {
    return axios.get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/update-acw?atdid=${idatd}&idreason=${idreason}`,
    );
  };
};

export const DelCompany = (companyid, iduser) => {
  return (dispatch) => {
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/deletecompany?id=${companyid}&iduser=${iduser}`,
      )
      .then((response) => {
        if (response.data) {
          dispatch(DeleteCompany(companyid));
        }
      })
      .catch((error) => {
        dispatch(
          ConnectionsAPI(
            true,
            false,
            true,
            "Conexão com banco de dados foi perdida :" + error,
          ),
        );
      });
  };
};

export const GetChatUser = (userin, userout, datainit) => {
  return (dispatch) => {
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/carregarmessagechat?userin=${userin}&userout=${userout}&datainit=${datainit}`,
      )
      .then((response) => {
        let resposta = response.data;
        resposta.map((obj) => {
          let dia = obj.diaenvio;
          let mes = obj.mesenvio;
          let ano = Moment().format("YYYY");
          mes = meses.indexOf(mes);
          dia = dia + " de " + meses[mes - 1];
          if (ano < obj.anoenvio || ano > obj.anoenvio)
            dia = dia + " de " + obj.anoenvio;
          let msg = obj.msg.replace(/(?:\r\n|\r|\n)/gm, "\\n");
          dispatch(
            addMessage(
              obj.id,
              h2p(msg),
              obj.usuarioorigem,
              obj.horaenvio,
              userout,
              "0",
              "visto",
              true,
              dia,
            ),
          );
        });
      })
      .catch((error) => {
        dispatch(
          ConnectionsAPI(
            true,
            false,
            true,
            "Conexão com banco de dados foi perdida :" + error,
          ),
        );
      });
  };
};

export const GetChatGroupUser = (userin, datainit) => {
  return (dispatch) => {
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/carregarmessagechatgroup?userin=${userin}&datainit=${datainit}`,
      )
      .then((response) => {
        let resposta = response.data;
        resposta.forEach(function (obj) {
          let dia = obj.diaenvio;
          let mes = obj.mesenvio;
          //let ano = Moment().format('YYYY');
          mes = meses.indexOf(mes);
          dia = dia + " de " + meses[mes - 1];
          let msg = obj.msg.replace(/(?:\r\n|\r|\n)/gm, "\\n");
          dispatch(
            addMessage(
              obj.id,
              h2p(msg),
              obj.usuarioorigem,
              obj.horaenvio,
              -333,
              "0",
              "visto",
              true,
              obj.username + " (" + obj.grupodousuariodeorigem + ") em " + dia,
            ),
          );
        });
      })
      .catch((error) => {
        dispatch(
          ConnectionsAPI(
            true,
            false,
            true,
            "Conexão com banco de dados foi perdida :" + error,
          ),
        );
      });
  };
};

export const registerInteractionOnIngDesk = (cdr, data) => {
  return async (dispatch, getState) => {
    const { informationusers } = getState();
    const baseUrl = informationusers.backendingdesk;
    const token = data.token;

    const payload = {
      cdrid: cdr,
      id_contato: data.idContato,
      id_usuario: data.idUsuario,
      id_canal: data.channelId,
    };

    try {
      const response = await ingDeskService.insertInteractionContact(
        payload,
        baseUrl,
        token,
      );

      // se quiser disparar algo depois
      // dispatch({ type: "REGISTER_INTERACTION_SUCCESS", payload: response });

      return response;
    } catch (error) {
      // dispatch({ type: "REGISTER_INTERACTION_ERROR", error });
      throw error;
    }
  };
};

export const RequestActiveCallSocketVoz = (
  outband,
  infouser,
  trunk,
  mediaid,
  chamado,
  addtech,
  scriptrunk,
  operator,
  returning,
  queueid,
  recvcount,
  callback_count,
  tech,
  idgrupo_rota,
  idgrupo_transb,
  ipcurrent,
  cdrid,
  rotaencontrada,
  cdrFather,
  dataToRegisterInteractionOnIngDesk = null,
) => {
  return (dispatch, getState) => {
    const { atdsimult } = getState();

    setHoldCall(webphone_api.getline());

    setTimeout(function () {
      const { status, atendimento } = getState();

      dispatch(
        UpdatePauseFutureRV(
          infouser,
          "RV",
          atendimento,
          status.afterReason,
          status.afterIdReason,
        ),
      );
    }, 5000);

    dispatch(
      incrementInfoUsers(
        infouser.email,
        infouser.password,
        infouser.id,
        infouser.displayname,
        infouser.grupo,
        infouser.ramal,
        infouser.idgroup,
        infouser.username,
        infouser.idsupervisao,
        infouser.sipid,
        infouser.acessofila,
        infouser.semdefinicao,
        infouser.supervisor,
        infouser.inanscount,
        infouser.incallcount,
        infouser.intmans,
        parseInt(infouser.outanscount) + 1,
        parseInt(infouser.outcallcount) + 1,
        infouser.outtmans,
        infouser.psdcount,
        infouser.psdtma,
        infouser.tmlogin,
        infouser.atdauto,
        infouser.idin,
        infouser.idout,
      ),
    );
    ActiveCallSocketVoz(
      outband,
      infouser,
      trunk,
      mediaid,
      chamado,
      addtech,
      scriptrunk,
      operator,
      returning,
      queueid,
      recvcount,
      callback_count,
      tech,
      idgrupo_rota,
      idgrupo_transb,
      dispatch,
      ipcurrent,
      cdrid,
      rotaencontrada,
      atdsimult,
      cdrFather,
      dataToRegisterInteractionOnIngDesk,
    );
  };
};

export const RequestActiveConfSocketVoz = (
  outband,
  infouser,
  trunk,
  mediaid,
  chamado,
  addtech,
  scriptrunk,
  operator,
  returning,
  queueid,
  recvcount,
  callback_count,
  tech,
  idgrupo_rota,
  idgrupo_transb,
  ipcurrent,
  cdrid,
  rotaencontrada,
  ContactId,
) => {
  return (dispatch, getState) => {
    const { atdsimult } = getState();
    //webphone_api.setparameter('autohold', 0);
    dispatch(UpdatePauseFutureRV(infouser, "RV"));
    dispatch(
      incrementInfoUsers(
        infouser.email,
        infouser.password,
        infouser.id,
        infouser.displayname,
        infouser.grupo,
        infouser.ramal,
        infouser.idgroup,
        infouser.username,
        infouser.idsupervisao,
        infouser.sipid,
        infouser.acessofila,
        infouser.semdefinicao,
        infouser.supervisor,
        infouser.inanscount,
        infouser.incallcount,
        infouser.intmans,
        parseInt(infouser.outanscount) + 1,
        parseInt(infouser.outcallcount) + 1,
        infouser.outtmans,
        infouser.psdcount,
        infouser.psdtma,
        infouser.tmlogin,
        infouser.atdauto,
        infouser.idin,
        infouser.idout,
      ),
    );
    ActiveConfSocketVoz(
      outband,
      infouser,
      trunk,
      mediaid,
      chamado,
      addtech,
      scriptrunk,
      operator,
      returning,
      queueid,
      recvcount,
      callback_count,
      tech,
      idgrupo_rota,
      idgrupo_transb,
      dispatch,
      ipcurrent,
      cdrid,
      rotaencontrada,
      ContactId,
      atdsimult,
    );
  };
};

export const gerarProtocolosaida = (cdrid) => {
  return (dispatch, getState) => {
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/gerarprocotolosaida?cdrid=${cdrid}`,
      )
      .then((response) => {
        setTimeout(function () {
          const { atdsimult } = getState();
          let checkatdprot = false;
          atdsimult.map((atend) => {
            if (parseInt(atend.idatendimento) === parseInt(cdrid))
              checkatdprot = true;
          });
          if (checkatdprot === true) {
            dispatch(changeProtocol(cdrid, response.data[0].protocolo));
          }
        }, 6000);
      })
      .catch((error) => {
        dispatch(
          ConnectionsAPI(
            true,
            false,
            true,
            "Conexão com banco de dados foi perdida :" + error,
          ),
        );
      });
  };
};

// export const getDataTachado = (cdrid,datatachado) => {
//   return (dispatch,getState) => {
//       setTimeout(function() {
//         const {atdsimult} = getState();
//         let checkdttach = false;
//         atdsimult.map(atend => {
//           if(parseInt(atend.idatendimento)===parseInt(cdrid))
//           checkdttach = true;
//         })
//         if(checkdttach===true){
//           dispatch(changeAtachData(cdrid,datatachado));
//         }
//       }, 3000);
//   };
// }

export const getDataTachadowebrtc = (cdrid) => {
  return (dispatch, getState) => {
    setTimeout(function () {
      const { atdsimult } = getState();
      let checkdttach = false;
      atdsimult.map((atend) => {
        if (parseInt(atend.idatendimento) === parseInt(cdrid))
          checkdttach = true;
      });
      if (checkdttach === true) {
        return (
          axios
            .get(
              `${connection_platform.type_connect}://${pathname}:${port}/conn/getdatatachado?cdrid=${cdrid}`,
            )
            // return axios.get(`${connection_platform.type_connect}://${pathname}:${port}/conn/getdatatachado?cdrid=154817`)

            .then((response) => {
              let jsonAtachData = "{";
              for (var i = 0; i < response.data.length; i++) {
                //if(response.data[i].reportname!=="Protocolo" && response.data[i].description!=="Protocolo"){
                let msg = response.data[i].value.replace(
                  /(?:\r\n|\r|\n)/gm,
                  "\\n",
                );
                jsonAtachData +=
                  '"' + response.data[i].description + '":"' + msg + '"';
                if (
                  response.data[i + 1] !== "" &&
                  response.data[i + 1] !== undefined
                ) {
                  jsonAtachData += ",";
                }
                //}
              }
              jsonAtachData += "}";
              dispatch(changeAtachData(cdrid, JSON.parse(jsonAtachData)));
            })
        );
      }
    }, 3000);
  };
};

export const getPesquisaSatisfacao = (numcliente, idcdr) => {
  return (dispatch, getState) => {
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/latestsurvey?numcliente=${numcliente}`,
      )
      .then((response) => {
        dispatch(
          changePesquisaSatisfacao(
            idcdr,
            response.data.resultado,
            response.data.nota,
            idcdr,
          ),
        );
      });
  };
};

export const getDataTachado = (cdrid) => {
  return (dispatch, getState) => {
    setTimeout(function () {
      const { atdsimult } = getState();
      let checkdttach = false;
      atdsimult.map((atend) => {
        if (parseInt(atend.idatendimento) === parseInt(cdrid))
          checkdttach = true;
      });
      if (checkdttach === true) {
        return axios
          .get(
            `${connection_platform.type_connect}://${pathname}:${port}/conn/getdatatachado?cdrid=${cdrid}`,
          )
          .then((response) => {
            let jsonAtachData = "{";
            for (var i = 0; i < response.data.length; i++) {
              if (
                response.data[i].reportname !== "Protocolo" &&
                response.data[i].description !== "Protocolo"
              ) {
                let msg = response.data[i].value.replace(
                  /(?:\r\n|\r|\n)/gm,
                  "\\n",
                );
                jsonAtachData +=
                  '"' + response.data[i].description + '":"' + msg + '"';
                if (
                  response.data[i + 1].description !== "" &&
                  response.data[i + 1].description !== undefined &&
                  response.data[i + 1].reportname !== "Protocolo"
                ) {
                  jsonAtachData += ",";
                }
              }
            }
            jsonAtachData += "}";
            dispatch(changeAtachData(cdrid, JSON.parse(jsonAtachData)));
          });
      }
    }, 3000);
  };
};

export const RequestActiveCall = (
  outband,
  infouser,
  trunk,
  mediaid,
  chamado,
  addtech,
  scriptrunk,
  operator,
  returning,
  queueid,
  recvcount,
  cbackcount,
  idgrupo_transb,
  cdrold,
  cdrFather,
  dataToRegisterInteractionOnIngDesk = null,
  rawNumber,
) => {
  //var DDD = '71';
  var DDD = "";
  var calledDigitado = chamado;
  // var rotaTransbordo = idgrupo_transb;
  if (parseInt(mediaid) === 5 && chamado.substr(0, 2) !== "00") {
    if (chamado[0] === "0") {
      chamado = chamado.substr(1, chamado.length - 1);
    }
    if (chamado.length === 12 || chamado.length === 13) {
      if (chamado.substr(0, 2) === "55") {
        chamado = chamado.substr(2, chamado.length - 1);
      }
    }
    if (chamado.length === 10 || chamado.length === 11) {
      DDD = chamado.substr(0, 2);
      chamado = chamado.substr(2, chamado.length - 1);
      if (chamado.length === 8) {
        if (parseInt(chamado[0]) >= 6 && parseInt(chamado[0]) <= 9)
          chamado = "9" + chamado;
      }
      chamado = DDD + chamado;
    } else if (chamado.length === 8 || chamado.length === 9) {
      if (chamado.length === 8) {
        if (parseInt(chamado[0]) >= 6 && parseInt(chamado[0]) <= 9)
          chamado = "9" + chamado;
      }
      chamado = DDD + chamado;
      calledDigitado = DDD + chamado;
    }
  }

  return (dispatch, getState) => {
    const { status, ipcurrent, informationusers, atendimento } = getState();
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/${
          cdrFather ? "insertactivecallfather" : "insertactivecall"
        }?idtrunk=${trunk}&servicecode=${
          outband.idservice
        }&idmidia=${mediaid}&caller=${
          infouser.ramal
        }&called='${chamado}'&idcustomer=${outband.idcustomer}&iddirection=${
          outband.iddirection
        }&idfather=${cdrFather}`,
      )
      .then((response) => {
        // let queueidfila = queueid;
        let retorno = response.data.id;
        dispatch(
          createStatusAgent(
            "ChamandoChat",
            status.reason,
            Moment().format("DD/MM/YYYY HH:mm:ss"),
            -3,
          ),
        );
        if (
          infouser.blockfuture === false &&
          status.afterStatus !== "Pausado"
        ) {
          // InsertPausaRV(infouser.sipid, infouser.id, dispatch);
          dispatch(InsertPausaRVV2(infouser.sipid, infouser.id));
        }
        if (retorno) {
          console.log("INGENIUM_SERVICEOUT : ", informationusers.serviceout);

          axios
            .get(
              `${connection_platform.type_connect}://${pathname}:${port}/conn/insertserviceattendantv2?idcdr=${retorno}&iduser=${infouser.id}&telefone=${chamado}&descricao=Saida&serviceinid=${informationusers.serviceout}&statususer=${status.status}`,
            )
            .then((response) => {
              let retornoatt = response.data.id;

              if (outband.hasprotocol === true) {
                dispatch(gerarProtocolosaida(retorno));
              }

              if (mediaid === 1) {
              } else if (retornoatt && mediaid !== 1) {
                var valorDiferenca = parseInt(
                  Math.abs(Math.round(ipcurrent.difftime)),
                );
                var datacorreta = "";
                if (parseInt(ipcurrent.difftime) < 0) {
                  datacorreta = Moment()
                    .subtract(valorDiferenca, "seconds")
                    .format("DD/MM/YYYY HH:mm:ss");
                } else {
                  datacorreta = Moment()
                    .add(valorDiferenca, "seconds")
                    .format("DD/MM/YYYY HH:mm:ss");
                }
                dispatch(
                  addAtendimento(
                    retorno,
                    calledDigitado,
                    calledDigitado,
                    "DISCANDO",
                    Moment().format("DD/MM/YYYY HH:mm:ss"),
                    "",
                    "",
                    "",
                    "",
                    "",
                    datacorreta,
                    "2",
                    mediaid,
                    "",
                    "",
                    "0",
                    queueid,
                    "",
                    "",
                    "",
                    "",
                  ),
                );
                dispatch(UpdateRgBlockReturn(informationusers));
                InteracoesContactNumberPeer(chamado);
                dispatch(
                  addAtdSimult(
                    retorno,
                    calledDigitado,
                    calledDigitado,
                    "DISCANDO",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    datacorreta,
                    "",
                    mediaid,
                    "",
                    "",
                    "0",
                    queueid,
                    "",
                    "",
                    "",
                    "",
                  ),
                );
                ActiveCallSocket(
                  retorno,
                  mediaid,
                  retornoatt,
                  chamado,
                  outband.idservice,
                  trunk,
                  infouser.id,
                  infouser.username,
                  addtech,
                  scriptrunk,
                  operator,
                  returning,
                  infouser,
                  queueid,
                  recvcount,
                  cbackcount,
                  calledDigitado,
                  cdrold,
                  rawNumber,
                );
                dispatch(RefreshQueueid(retorno, queueid));
                // if (Boolean(dataToRegisterInteractionOnIngDesk)) {
                //   dispatch(
                //     registerInteractionOnIngDesk(
                //       retorno,
                //       dataToRegisterInteractionOnIngDesk
                //     )
                //   );
                // }
              }
            });
        }
      });
  };
};

export const RequestHiddenCall = (
  outband,
  infouser,
  trunk,
  mediaid,
  chamado,
  addtech,
  scriptrunk,
  operator,
  returning,
  queueid,
  recvcount,
  cbackcount,
  idgrupo_transb,
  cdrold,
  cdrFather,
) => {
  //var DDD = '71';
  var DDD = "";
  var calledDigitado = chamado;
  // var rotaTransbordo = idgrupo_transb;
  if (parseInt(mediaid) === 5 && chamado.substr(0, 2) !== "00") {
    if (chamado[0] === "0") {
      chamado = chamado.substr(1, chamado.length - 1);
    }
    if (chamado.length === 12 || chamado.length === 13) {
      if (chamado.substr(0, 2) === "55") {
        chamado = chamado.substr(2, chamado.length - 1);
      }
    }
    if (chamado.length === 10 || chamado.length === 11) {
      DDD = chamado.substr(0, 2);
      chamado = chamado.substr(2, chamado.length - 1);
      if (chamado.length === 8) {
        if (parseInt(chamado[0]) >= 6 && parseInt(chamado[0]) <= 9)
          chamado = "9" + chamado;
      }
      chamado = DDD + chamado;
    } else if (chamado.length === 8 || chamado.length === 9) {
      if (chamado.length === 8) {
        if (parseInt(chamado[0]) >= 6 && parseInt(chamado[0]) <= 9)
          chamado = "9" + chamado;
      }
      chamado = DDD + chamado;
      calledDigitado = DDD + chamado;
    }
  }

  return (dispatch, getState) => {
    const { status, ipcurrent, informationusers, atendimento } = getState();
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/${
          cdrFather ? "insertactivecallfather" : "insertactivecall"
        }?idtrunk=${trunk}&servicecode=${
          outband.idservice
        }&idmidia=${mediaid}&caller=${
          infouser.ramal
        }&called='${chamado}'&idcustomer=${outband.idcustomer}&iddirection=${
          outband.iddirection
        }&idfather=${cdrFather}`,
      )
      .then((response) => {
        // let queueidfila = queueid;
        let retorno = response.data.id;

        if (retorno) {
          console.log("INGENIUM_SERVICEOUT : ", informationusers);

          axios
            .get(
              `${connection_platform.type_connect}://${pathname}:${port}/conn/insertserviceattendantv2?idcdr=${retorno}&iduser=${infouser.id}&telefone=${chamado}&descricao=Saida&serviceinid=${informationusers.serviceout}&statususer=${status.status}`,
            )
            .then((response) => {
              let retornoatt = response.data.id;

              if (outband.hasprotocol === true) {
                dispatch(gerarProtocolosaida(retorno));
              }

              if (mediaid === 1) {
              } else if (retornoatt && mediaid !== 1) {
                var valorDiferenca = parseInt(
                  Math.abs(Math.round(ipcurrent.difftime)),
                );
                var datacorreta = "";
                if (parseInt(ipcurrent.difftime) < 0) {
                  datacorreta = Moment()
                    .subtract(valorDiferenca, "seconds")
                    .format("DD/MM/YYYY HH:mm:ss");
                } else {
                  datacorreta = Moment()
                    .add(valorDiferenca, "seconds")
                    .format("DD/MM/YYYY HH:mm:ss");
                }
                ActiveCallSocket(
                  retorno,
                  mediaid,
                  retornoatt,
                  chamado,
                  outband.idservice,
                  trunk,
                  infouser.id,
                  infouser.username,
                  addtech,
                  scriptrunk,
                  operator,
                  returning,
                  infouser,
                  queueid,
                  recvcount,
                  cbackcount,
                  calledDigitado,
                  cdrold,
                );
                dispatch(RefreshQueueid(retorno, queueid));
              }
            });
        }
      });
  };
};

export const SolicitarChamada = (
  InfoUsers,
  scriptid,
  cdrid,
  mediaid,
  status2,
) => {
  return (dispatch, getState) => {
    const { status } = getState();
    dispatch(CallParkCapture(false));

    setTimeout(() => {
      dispatch(CallParkCapture(true));
    }, 10000);

    RequestCallParkSocket(
      InfoUsers,
      scriptid,
      cdrid,
      mediaid,
      status,
      dispatch,
    );
  };
};

export const TransferirChamadaEmFila = (
  agent,
  scriptid,
  cdrid,
  mediaid,
  iduser,
) => {
  return (dispatch) => {
    RequestCallParkTransferSocket(
      agent,
      scriptid,
      cdrid,
      mediaid,
      iduser,
      dispatch,
    );
  };
};

export const EfectBlockUser = (userout, act, reason) => {
  return (dispatch, getState) => {
    const { informationusers, agents } = getState();
    EfectBlockUserSocket(
      informationusers,
      userout,
      act,
      reason,
      agents,
      dispatch,
    );
  };
};

export const CarregarChatNotRead = (iduser) => {
  return (dispatch, getState) => {
    const { chatsimult, informationusers, currentscreen, atdsimult } =
      getState();
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/loginchat?iduser=${iduser}`,
      )
      .then((response) => {
        let resposta = response.data;
        CarregarChatSocket(
          resposta,
          dispatch,
          informationusers,
          currentscreen,
          chatsimult,
          atdsimult,
        );
      })
      .catch((error) => {
        console.log("LOGINGENIUM_ERROR_BACKEND_LOGIN_CHAT: ", error);
        // dispatch(ConnectionsAPI(true,false,true,'Conexão com banco de dados foi perdida :'+error))
      });
  };
};

export const getmiddlewarecrm = () => {
  return axios
    .get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/getmiddlewarecrm`,
    )
    .then((response) => {
      console.log("INGDESK_IDCASO_IDMIDDLEWARE_INDEX: ", response.data.id);
      return response.data.id;
    });
};

export const insertProtocolCRM = (cdrid, idmiddleware, caseid) => {
  return axios
    .get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/insertprotocolcrm?cdrid=${cdrid}&idmiddleware=${idmiddleware}&caseid=${caseid}`,
    )
    .then((response) => {
      console.log("INGDESK_IDCASO_IDMIDDLEWARE_INDEX INSERIDO COM SUCESSO");
    });
};

export const ProximoChatSimult = (simult, Chat, ChatSimult) => {
  return (dispatch) => {
    let iduserout = Chat.iduserout;
    if (ChatSimult.length > 1 && simult.iduserout === iduserout) {
      let i = 0;
      if (ChatSimult[i].iduserout === simult.iduserout) i = 1;
      dispatch(addChat(ChatSimult[i].iduserout, ChatSimult[i].agent));
      //dispatch(addChat(ChatSimult[i].iduserout, ChatSimult[i].agent,ChatSimult[i].active,ChatSimult[i].voz,0,datatime));
    } else if (ChatSimult.length <= 1) {
      dispatch(removeChatUnique());
    }
  };
};

export const UpdatePauseFutureRV = (
  infousers,
  status2,
  atendimento,
  descpausa,
  idpausa,
) => {
  return (dispatch, getState) => {
    const { ipcurrent, status } = getState();
    if (parseInt(idpausa) > 0) {
      if (status2 === "RV") {
        axios
          .get(
            `${connection_platform.type_connect}://${pathname}:${port}/conn/updatetogglefuturebreak?iduser=${infousers.id}`,
          )
          .then((response) => {
            if (response.data === true) {
              console.log(
                "INGENIUMPAUSEFUTURE_ENDPOINT_INDEX : ",
                "UPDATE EFETUADO COM SUCESSO",
              );
            }
          });

        return axios
          .get(
            `${connection_platform.type_connect}://${pathname}:${port}/conn/updatepausefuture?id=${infousers.sipid}&status=${status2}`,
          )
          .then((response) => {
            sendPauseFuture(
              infousers,
              status,
              atendimento,
              descpausa,
              idpausa,
              ipcurrent,
              dispatch,
              0,
            );
          })
          .catch((error) => {
            dispatch(
              InterationNotifier(
                "Erro ao alterar a pausa futura. Tente novamente ou contacte o administrador do sistema!",
                "errordb",
              ),
            );
            dispatch(BlockFuture(false));
          });
      } else {
        return axios
          .get(
            `${connection_platform.type_connect}://${pathname}:${port}/conn/updatepausefuture?id=${infousers.sipid}&status=${status2}`,
          )
          .then((response) => {
            sendPauseFuture(
              infousers,
              status,
              atendimento,
              descpausa,
              idpausa,
              ipcurrent,
              dispatch,
              0,
            );
          })
          .catch((error) => {
            dispatch(
              InterationNotifier(
                "Erro ao inserir a pausa futura. Tente novamente ou contacte o administrador do sistema!",
                "errordb",
              ),
            );
            dispatch(BlockFuture(false));
          });
      }
    } else if (idpausa !== -1) {
      sendPauseFuture(
        infousers,
        status,
        atendimento,
        descpausa,
        idpausa,
        ipcurrent,
        dispatch,
        1,
      );
    }
  };
};

// export const UpdatePauseFutureRV = (id,status) => {
//   return (dispatch) => {
//     return axios.get(`${connection_platform.type_connect}://${pathname}:${port}/conn/updatepausefuture?id=${id}&status=${status}`)
//       .then(response => {
//         return response.data
//       })
//   };
// }

export const ChangeStatusCallback = (queueid, username) => {
  return axios
    .get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/changestatuscallback?queueid=` +
        queueid +
        `&username=` +
        username,
    )
    .then((response) => {
      return response.data;
    });
};

export const UserSupDesbloqInable = (
  reason,
  idblockdescription,
  idblocksupervision,
) => {
  return (dispatch, getState) => {
    const { informationusers } = getState();
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/updateblockuser?idblockdescription=${idblockdescription}&idblocksupervision=${idblocksupervision}&supreason=${reason}&supid=${informationusers.id}`,
      )
      .then((response) => {
        return response.data;
      });
  };
};

export const AddConference = (
  ContactId,
  atendimento,
  line,
  contactatd,
  serviceatd,
) => {
  return (dispatch) => {
    // webphone_api.setparameter('autohold', 0);

    webphone_api.setline(parseInt(line));
    if (webphone_api.isonhold()) webphone_api.hold(false);
    webphone_api.conference(line, true);

    axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/insertattendantactivity?idatt=${contactatd}&idfunc=6`,
      )
      .then((response) => {
        confatendimento[contactatd] = response.data[0].id;
      });

    axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/insertattendantactivity?idatt=${serviceatd}&idfunc=6`,
      )
      .then((response) => {
        confatendimento[serviceatd] = response.data[0].id;
      });

    dispatch(AddConferenceExt(ContactId, atendimento));
  };
};

export const clearConferenceExt = (atendimento) => {
  return (dispatch) => {
    if (atendimento !== undefined && atendimento !== "undefined") {
      if (atendimento.line !== undefined && atendimento.idmidia !== undefined) {
        if (
          parseInt(atendimento.line) !== 0 &&
          parseInt(atendimento.idmidia) === 1
        ) {
          // webphone_api.setparameter('autohold', 3);
          webphone_api.conference("", false);
          //webphone_api.setline(atendimento.line);
          dispatch(ClearAddConferenceExt());
        }
      }
    }
  };
};

export const startInteractions = (mediaid, numberreceived, payload) => {
  return (dispatch, getState) => {
    const {
      routergroups,
      outservices,
      informationusers,
      listcallqueue,
      atdsimult,
      status,
      ipcurrent,
      connectionsapi,
      serviceurl,
      atendimento,
    } = getState();

    let url_iframe = "";
    let permrouter = routergroups;
    let outband = outservices;
    let infouser = informationusers;
    let queue = listcallqueue;
    let AtdSimult = atdsimult;
    let statusAgent = status;
    let statusQueue = 0;

    if (atendimento.length !== 0) {
      localStorage.setItem("current-service", atendimento.idatendimento);
    }

    if (serviceurl.length !== 0) {
      let ArrayServiceURL = "";
      if (informationusers.nameauth === "IngDesk") {
        ArrayServiceURL = serviceurl.filter(
          (url) => url.typeofcrm === "IngDesk",
        );
        if (ArrayServiceURL.length !== 0) {
          url_iframe = ArrayServiceURL[0].param;
        }
      }
    }

    if (infouser.user_midias) {
      let permission = false;
      for (var i = 0; i < infouser.user_midias.length; i++) {
        if (parseInt(infouser.user_midias[i]) === parseInt(mediaid))
          permission = true;
      }

      if (!permission) {
        sendIngDeskMessage(
          "Sem permissão",
          connectionsapi,
          dispatch,
          url_iframe,
        );
        if (url_iframe === "")
          dispatch(InterationNotifier("Sem permissão", "permission"));

        return true;
      }
    }

    if (statusAgent.allowCall === false) {
      sendIngDeskMessage(
        "Pausa não permite ativo",
        connectionsapi,
        dispatch,
        url_iframe,
      );
      if (url_iframe === "")
        dispatch(InterationNotifier("Pausa não permite ativo", "permission"));

      return true;
    }

    if (permrouter !== "undefined" && permrouter !== "") {
      var existeRota = false;
      var rotaencontrada = false;
      var checkRota = false;
      // var rotaDefault = false;
      // var rotaAlternativa = false;
      var trunk = "";
      var addtech = "";
      var scriptrunk = "";
      var operator = "";
      // var trunkDef = "";
      // var addtechDef = "";
      // var scriptrunkDef = "";
      // var operatorDef = "";
      var tech = "";
      // var techDef = "";
      var idgrupo_rota = "";
      // var idgrupo_rotaDef = "";
      var idgrupo_transb = "";
      // var idgrupo_transbDef = "";
      var chamado = numberreceived;
      var retorno = 0;
      var checkAtd = false;
      var tipochamada = 0;
      var caracterAdicional = "";

      if (mediaid === 5 || mediaid === 1 || mediaid === 8) {
        chamado = chamado.replace(/\D/g, "");
      }

      if (
        permrouter[0].areacodeid !== "undefined" &&
        permrouter[0].areacodeid !== ""
      ) {
        var DDD = permrouter[0].areacodeid;
        var DDDPadrao = permrouter[0].areacodeid;
      } else {
        var DDD = "71";
        var DDDPadrao = "71";
      }

      var calledDigitado = chamado;
      var valorfixo = [1, 2, 3, 4];
      var valormovel = [5, 6, 7, 8, 9];
      if (connection_platform.remove_digits || parseInt(mediaid) !== 1) {
        if (
          chamado[0] === "0" &&
          chamado.substr(0, 2) !== "00" &&
          chamado.substr(0, 4) !== "0800"
        ) {
          caracterAdicional = chamado.substr(0, 1);
          chamado = chamado.substr(1, chamado.length - 1);
        }
      }
      if (
        (chamado.length === 12 || chamado.length === 13) &&
        chamado.substr(0, 2) !== "00"
      ) {
        if (chamado.substr(0, 2) === "55") {
          chamado = chamado.substr(2, chamado.length - 1);
          calledDigitado = calledDigitado.substr(2, calledDigitado.length - 1);
        }
        if (parseInt(chamado.substr(2, 2)) !== parseInt(DDDPadrao)) {
          if (valorfixo.indexOf(parseInt(chamado[4])) > -1) {
            if (mediaid === 1) tipochamada = 3;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
          } else if (valormovel.indexOf(parseInt(chamado[4])) > -1) {
            if (mediaid === 1) tipochamada = 2;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
          }
        } else if (parseInt(chamado.substr(2, 2)) === parseInt(DDDPadrao)) {
          if (valorfixo.indexOf(parseInt(chamado[4])) > -1) {
            if (mediaid === 1) tipochamada = 1;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
          } else if (valormovel.indexOf(parseInt(chamado[4])) > -1) {
            if (mediaid === 1) tipochamada = 2;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
          }
        }
      }

      if (
        (chamado.length === 10 || chamado.length === 11) &&
        chamado.substr(0, 4) !== "0800" &&
        chamado.substr(0, 2) !== "00"
      ) {
        DDD = chamado.substr(0, 2);
        chamado = chamado.substr(2, chamado.length - 1);
        if (chamado.length === 8 && parseInt(chamado.substr(0, 1)) >= 6) {
          if (parseInt(chamado[0]) >= 6 && parseInt(chamado[0]) <= 9) {
            chamado = "9" + chamado;
          }
        }

        if (
          parseInt(parseInt(DDD)) !== parseInt(DDDPadrao) &&
          chamado.substr(0, 2) !== "00"
        ) {
          if (valorfixo.indexOf(parseInt(chamado[0])) > -1) {
            if (mediaid === 1) tipochamada = 3;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
          } else if (valormovel.indexOf(parseInt(chamado[0])) > -1) {
            if (mediaid === 1) tipochamada = 4;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
          }
        } else if (parseInt(DDD) === parseInt(DDDPadrao)) {
          if (valorfixo.indexOf(parseInt(chamado[0])) > -1) {
            if (mediaid === 1) tipochamada = 1;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
          } else if (valormovel.indexOf(parseInt(chamado[0])) > -1) {
            if (mediaid === 1) tipochamada = 2;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
          }
        }
        if (mediaid !== 8) {
          chamado = DDD + chamado;
          calledDigitado = DDD + calledDigitado;
        }
      } else if (chamado.length === 8 || chamado.length === 9) {
        if (chamado.length === 8 && parseInt(chamado.substr(0, 1)) >= 6) {
          if (parseInt(chamado[0]) >= 6 && parseInt(chamado[0]) <= 9) {
            chamado = "9" + chamado;
          }
        }

        if (valorfixo.indexOf(parseInt(chamado[0])) > -1) {
          if (mediaid === 1) tipochamada = 1;
          else if (mediaid === 5) tipochamada = 17;
          else if (mediaid === 8) tipochamada = 19;
          else if (mediaid === 4) tipochamada = 18;
          else if (mediaid === 6) tipochamada = 20;
          else if (mediaid === 9) tipochamada = 21;
          else if (mediaid === 10) tipochamada = 23;
          else if (mediaid === 3) tipochamada = 22;
          else if (mediaid === 2) tipochamada = 24;
        } else if (valormovel.indexOf(parseInt(chamado[0])) > -1) {
          if (mediaid === 1) tipochamada = 2;
          else if (mediaid === 5) tipochamada = 17;
          else if (mediaid === 8) tipochamada = 19;
          else if (mediaid === 4) tipochamada = 18;
          else if (mediaid === 6) tipochamada = 20;
          else if (mediaid === 9) tipochamada = 21;
          else if (mediaid === 10) tipochamada = 23;
          else if (mediaid === 3) tipochamada = 22;
          else if (mediaid === 2) tipochamada = 24;
        }
        if (mediaid !== 1 && mediaid !== 8) {
          chamado = DDD + chamado;
          calledDigitado = DDD + calledDigitado;
        }
      } else if (chamado.substr(0, 4) === "0800") {
        // chamado = '0'+chamado;
        tipochamada = 8;
      } else if (chamado.substr(0, 2) === "00") {
        if (mediaid === 1) tipochamada = 5;
        else if (mediaid === 5) tipochamada = 17;
        else if (mediaid === 8) tipochamada = 19;
        else if (mediaid === 4) tipochamada = 18;
        else if (mediaid === 6) tipochamada = 20;
        else if (mediaid === 9) tipochamada = 21;
        else if (mediaid === 10) tipochamada = 23;
        else if (mediaid === 3) tipochamada = 22;
        else if (mediaid === 2) tipochamada = 24;
      } else {
        permrouter.map((result) => {
          if (result.calltypeid === 11) {
            if (
              parseInt(chamado) >= parseInt(result.partialnumber) &&
              parseInt(chamado) <= parseInt(result.partialnumber_end)
            ) {
              tipochamada = 11;
            }
          } else if (result.calltypeid === 6) {
            if (parseInt(chamado) === parseInt(result.partialnumber)) {
              tipochamada = 6;
            }
          }
        });
      }

      AtdSimult.map((atend) => {
        if (
          String(atend.telefone) === String(chamado) &&
          parseInt(mediaid) === parseInt(atend.idmidia)
        )
          checkAtd = true;
      });

      if (mediaid === 4) tipochamada = 18;
      else if (mediaid === 6) tipochamada = 20;
      else if (mediaid === 9) tipochamada = 21;
      else if (mediaid === 10) tipochamada = 23;
      else if (mediaid === 3) tipochamada = 22;
      else if (mediaid === 2) tipochamada = 24;

      if (checkAtd === false) {
        if (chamado !== "") {
          if (!isNaN(chamado)) {
            permrouter.map((result) => {
              if (parseInt(result.idmidia) === parseInt(mediaid)) {
                if (parseInt(tipochamada) === result.calltypeid) {
                  if (parseInt(tipochamada) === 1) {
                    if (
                      (parseInt(chamado) >=
                        parseInt(result.areacode + result.partialnumber) &&
                        chamado <=
                          parseInt(
                            result.areacode + result.partialnumber_end,
                          )) ||
                      parseInt(chamado) ===
                        parseInt(result.areacode + result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      (parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) >= parseInt(result.partialnumber) &&
                        chamado.substr(parseInt(chamado.length) - 8, 4) <=
                          parseInt(result.partialnumber_end)) ||
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) === parseInt(result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      result.operator !== null &&
                      result.operator !== "" &&
                      result.areacode ===
                        parseInt(
                          chamado.substr(parseInt(chamado.length) - 10, 2),
                        )
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                      checkRota = true;
                    } else if (rotaencontrada === false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (parseInt(tipochamada) === 2) {
                    if (
                      (parseInt(chamado) >=
                        parseInt(result.areacode + result.partialnumber) &&
                        chamado <=
                          parseInt(
                            result.areacode + result.partialnumber_end,
                          )) ||
                      parseInt(chamado) ===
                        parseInt(result.areacode + result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      (parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) >= parseInt(result.partialnumber) &&
                        chamado.substr(parseInt(chamado.length) - 8, 4) <=
                          parseInt(result.partialnumber_end)) ||
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) === parseInt(result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      result.operator !== null &&
                      result.operator !== "" &&
                      result.areacode ===
                        parseInt(
                          chamado.substr(parseInt(chamado.length) - 11, 2),
                        )
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                      checkRota = true;
                    } else if (rotaencontrada === false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (parseInt(tipochamada) === 3) {
                    if (
                      (parseInt(chamado) >=
                        parseInt(result.areacode + result.partialnumber) &&
                        chamado <=
                          parseInt(
                            result.areacode + result.partialnumber_end,
                          )) ||
                      parseInt(chamado) ===
                        parseInt(result.areacode + result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      (parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) >= parseInt(result.partialnumber) &&
                        chamado.substr(parseInt(chamado.length) - 8, 4) <=
                          parseInt(result.partialnumber_end)) ||
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) === parseInt(result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 10, 2),
                      ) === parseInt(result.areacode)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (rotaencontrada === false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (parseInt(tipochamada) === 4) {
                    if (
                      (parseInt(chamado) >=
                        parseInt(result.areacode + result.partialnumber) &&
                        chamado <=
                          parseInt(
                            result.areacode + result.partialnumber_end,
                          )) ||
                      parseInt(chamado) ===
                        parseInt(result.areacode + result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                      checkRota = true;
                    } else if (
                      (parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) >= parseInt(result.partialnumber) &&
                        chamado.substr(parseInt(chamado.length) - 8, 4) <=
                          parseInt(result.partialnumber_end)) ||
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) === parseInt(result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 11, 2),
                      ) === parseInt(result.areacode)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (rotaencontrada === false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (parseInt(tipochamada) === 5) {
                    if (rotaencontrada === false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (parseInt(tipochamada) === 8) {
                    if (rotaencontrada === false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (
                    parseInt(tipochamada) !== 5 &&
                    chamado.substr(0, 2) === "00" &&
                    parseInt(result.operator) === parseInt(chamado.substr(0, 2))
                  ) {
                    trunk = result.idtrunk;
                    addtech = result.addtech;
                    scriptrunk = result.scripttrunk;
                    operator = "";
                    tech = result.tech;
                    idgrupo_rota = result.idgrupo_rota;
                    idgrupo_transb = result.idgrupo_transb;
                    rotaencontrada = true;
                    existeRota = true;
                    checkRota = true;
                  } else if (parseInt(tipochamada) === 11) {
                    permrouter.map((result) => {
                      if (result.calltypeid === 11) {
                        if (
                          parseInt(chamado) >= parseInt(result.partialnumber) &&
                          parseInt(chamado) <=
                            parseInt(result.partialnumber_end)
                        ) {
                          trunk = result.idtrunk;
                          addtech = result.addtech;
                          scriptrunk = result.scripttrunk;
                          operator = "";
                          tech = result.tech;
                          idgrupo_rota = result.idgrupo_rota;
                          idgrupo_transb = result.idgrupo_transb;
                          rotaencontrada = true;
                          existeRota = true;
                          checkRota = true;
                        }
                      }
                    });
                  } else if (parseInt(tipochamada) === 6) {
                    permrouter.map((result) => {
                      if (result.calltypeid === 6) {
                        if (
                          parseInt(chamado) === parseInt(result.partialnumber)
                        ) {
                          trunk = result.idtrunk;
                          addtech = result.addtech;
                          scriptrunk = result.scripttrunk;
                          operator = "";
                          tech = result.tech;
                          idgrupo_rota = result.idgrupo_rota;
                          idgrupo_transb = result.idgrupo_transb;
                          rotaencontrada = true;
                          existeRota = true;
                          checkRota = true;
                        }
                      }
                    });
                  } else {
                    if (rotaencontrada === false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                    }
                  }
                }
              }
            });
            if (existeRota === true) {
              for (let i = 0; i < queue.length; i++) {
                var numberqueue = queue[i].caller;

                //if(chamado === numberqueue){
                if (numberqueue.search(chamado) !== -1) {
                  retorno = 1;
                  var queueid = queue[i].queueid;
                  var recvcount = queue[i].recv_count;
                  var cdrid = queue[i].cdrid;
                  var srvin = queue[i].serviceinid;
                  var caller = queue[i].caller;
                  var called = queue[i].called;
                  var cbackcount = queue[i].callback_count;
                  statusQueue = queue[i].status;
                }
              }

              if (mediaid === 5) {
                chamado = chamado.toString();
                chamado = chamado.trim();
                calledDigitado = calledDigitado.toString();
                calledDigitado = calledDigitado.trim();
              } else if (mediaid === 8) {
                chamado = chamado.toString();
                chamado = chamado.trim();
                calledDigitado = calledDigitado.toString();
                calledDigitado = calledDigitado.trim();
              }

              if (mediaid === 1) {
                if (retorno === 1) {
                  dispatch(
                    RequestActiveCallSocketVoz(
                      outband,
                      infouser,
                      trunk,
                      mediaid,
                      caracterAdicional + chamado,
                      addtech,
                      scriptrunk,
                      operator,
                      true,
                      queueid,
                      recvcount,
                      null,
                      tech,
                      idgrupo_rota,
                      idgrupo_transb,
                      ipcurrent,
                      cdrid,
                      checkRota,
                    ),
                  );
                  dispatch(
                    ReturningCallback(
                      queueid,
                      true,
                      recvcount,
                      cdrid,
                      mediaid,
                      srvin,
                      caller,
                      called,
                    ),
                  );
                  if (statusQueue !== "2") {
                    dispatch(
                      returnListCallQueue(
                        "",
                        queueid,
                        "2",
                        parseInt(cbackcount + 1),
                        "você",
                      ),
                    );
                  }
                  dispatch(ShowInfoDisplay("Clientes"));
                } else {
                  dispatch(
                    RequestActiveCallSocketVoz(
                      outband,
                      infouser,
                      trunk,
                      mediaid,
                      caracterAdicional + chamado,
                      addtech,
                      scriptrunk,
                      operator,
                      false,
                      queueid,
                      recvcount,
                      null,
                      tech,
                      idgrupo_rota,
                      idgrupo_transb,
                      ipcurrent,
                      cdrid,
                      checkRota,
                    ),
                  );
                  dispatch(
                    ReturningCallback(
                      queueid,
                      true,
                      recvcount,
                      cdrid,
                      mediaid,
                      srvin,
                      caller,
                      called,
                    ),
                  );
                  if (statusQueue !== "2") {
                    dispatch(
                      returnListCallQueue(
                        "",
                        queueid,
                        "2",
                        parseInt(cbackcount + 1),
                        "você",
                      ),
                    );
                  }
                  dispatch(ShowInfoDisplay("Clientes"));
                }
              } else {
                if (retorno === 1) {
                  dispatch(
                    RequestActiveCall(
                      outband,
                      infouser,
                      trunk,
                      mediaid,
                      chamado,
                      addtech,
                      scriptrunk,
                      operator,
                      true,
                      queueid,
                      recvcount,
                      cbackcount,
                      idgrupo_transb,
                      cdrid,
                    ),
                  );
                  dispatch(
                    ReturningCallback(
                      queueid,
                      true,
                      recvcount,
                      cdrid,
                      mediaid,
                      srvin,
                      caller,
                      called,
                    ),
                  );
                  if (statusQueue !== "2") {
                    dispatch(
                      returnListCallQueue(
                        "",
                        queueid,
                        "2",
                        parseInt(cbackcount + 1),
                        "você",
                      ),
                    );
                  }
                  dispatch(ShowInfoDisplay("Clientes"));
                } else {
                  dispatch(
                    RequestActiveCall(
                      outband,
                      infouser,
                      trunk,
                      mediaid,
                      chamado,
                      addtech,
                      scriptrunk,
                      operator,
                      false,
                      queueid,
                      recvcount,
                      cbackcount,
                      idgrupo_transb,
                    ),
                  );
                  dispatch(ShowInfoDisplay("Clientes"));
                }
              }
              dispatch(ShowActiveCall(""));
              sucessInteractionIngDesk(payload, dispatch);
            } else {
              sendIngDeskMessage(
                "Sem rota de saída",
                connectionsapi,
                dispatch,
                url_iframe,
              );
              if (url_iframe === "")
                dispatch(InterationNotifier("Sem rota de saída", "call"));
            }
          } else {
            sendIngDeskMessage(
              "Apenas números!",
              connectionsapi,
              dispatch,
              url_iframe,
            );
            if (url_iframe === "")
              dispatch(InterationNotifier("Apenas números!", "call"));
          }
        } else {
          sendIngDeskMessage(
            "Informe o número!",
            connectionsapi,
            dispatch,
            url_iframe,
          );
          if (url_iframe === "")
            dispatch(InterationNotifier("Informe o número!", "call"));
        }
      } else {
        dispatch(
          InterationNotifier(
            "Este cliente já está sendo atendido por você",
            "call",
          ),
        );
        sendIngDeskMessage(
          "Este cliente já está sendo atendido por você",
          connectionsapi,
          dispatch,
        );
      }
    }
  };
};

function sucessInteractionIngDeskFromClientWallet(payload, dispatch) {
  setTimeout(() => {
    dispatch(ShowInfoDisplay("Clientes"));
    // dispatch(
    //   changeAtdIngDeskSuccess(payload.destination, "", "", payload.caseId)
    // );
  }, 1000);
  dispatch(AlterScreen("Clientes"));
  // dispatch(ShowVisibleNextAtd("ocultar", true));
}

export const startInteractionsFromClientWallet = (
  mediaid,
  numberreceived,
  payload,
) => {
  return (dispatch, getState) => {
    const {
      routergroups,
      outservices,
      informationusers,
      listcallqueue,
      atdsimult,
      status,
      ipcurrent,
      connectionsapi,
      serviceurl,
      atendimento,
    } = getState();

    let url_iframe = "";
    let permrouter = routergroups;
    let outband = outservices;
    let infouser = informationusers;
    let queue = listcallqueue;
    let AtdSimult = atdsimult;
    let statusAgent = status;
    let statusQueue = 0;

    if (atendimento.length !== 0) {
      localStorage.setItem("current-service", atendimento.idatendimento);
    }

    if (serviceurl.length !== 0) {
      let ArrayServiceURL = "";
      if (informationusers.nameauth === "IngDesk") {
        ArrayServiceURL = serviceurl.filter(
          (url) => url.typeofcrm === "IngDesk",
        );
        if (ArrayServiceURL.length !== 0) {
          url_iframe = ArrayServiceURL[0].param;
        }
      }
    }

    if (infouser.user_midias) {
      let permission = false;
      for (var i = 0; i < infouser.user_midias.length; i++) {
        if (parseInt(infouser.user_midias[i]) === parseInt(mediaid))
          permission = true;
      }

      if (!permission) {
        sendIngDeskMessage(
          "Sem permissão",
          connectionsapi,
          dispatch,
          url_iframe,
        );
        if (url_iframe === "")
          dispatch(InterationNotifier("Sem permissão", "permission"));

        return true;
      }
    }

    if (statusAgent.allowCall === false) {
      sendIngDeskMessage(
        "Pausa não permite ativo",
        connectionsapi,
        dispatch,
        url_iframe,
      );
      if (url_iframe === "")
        dispatch(InterationNotifier("Pausa não permite ativo", "permission"));

      return true;
    }

    if (permrouter !== "undefined" && permrouter !== "") {
      var existeRota = false;
      var rotaencontrada = false;
      var checkRota = false;
      // var rotaDefault = false;
      // var rotaAlternativa = false;
      var trunk = "";
      var addtech = "";
      var scriptrunk = "";
      var operator = "";
      // var trunkDef = "";
      // var addtechDef = "";
      // var scriptrunkDef = "";
      // var operatorDef = "";
      var tech = "";
      // var techDef = "";
      var idgrupo_rota = "";
      // var idgrupo_rotaDef = "";
      var idgrupo_transb = "";
      // var idgrupo_transbDef = "";
      var chamado = numberreceived;
      var retorno = 0;
      var checkAtd = false;
      var tipochamada = 0;
      var caracterAdicional = "";

      if (mediaid === 5 || mediaid === 1 || mediaid === 8) {
        chamado = chamado.replace(/\D/g, "");
      }

      if (
        permrouter[0].areacodeid !== "undefined" &&
        permrouter[0].areacodeid !== ""
      ) {
        var DDD = permrouter[0].areacodeid;
        var DDDPadrao = permrouter[0].areacodeid;
      } else {
        var DDD = "71";
        var DDDPadrao = "71";
      }

      var calledDigitado = chamado;
      var valorfixo = [1, 2, 3, 4];
      var valormovel = [5, 6, 7, 8, 9];
      if (connection_platform.remove_digits || parseInt(mediaid) !== 1) {
        if (
          chamado[0] === "0" &&
          chamado.substr(0, 2) !== "00" &&
          chamado.substr(0, 4) !== "0800"
        ) {
          caracterAdicional = chamado.substr(0, 1);
          chamado = chamado.substr(1, chamado.length - 1);
        }
      }
      if (
        (chamado.length === 12 || chamado.length === 13) &&
        chamado.substr(0, 2) !== "00"
      ) {
        if (chamado.substr(0, 2) === "55") {
          chamado = chamado.substr(2, chamado.length - 1);
          calledDigitado = calledDigitado.substr(2, calledDigitado.length - 1);
        }
        if (parseInt(chamado.substr(2, 2)) !== parseInt(DDDPadrao)) {
          if (valorfixo.indexOf(parseInt(chamado[4])) > -1) {
            if (mediaid === 1) tipochamada = 3;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
          } else if (valormovel.indexOf(parseInt(chamado[4])) > -1) {
            if (mediaid === 1) tipochamada = 2;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
          }
        } else if (parseInt(chamado.substr(2, 2)) === parseInt(DDDPadrao)) {
          if (valorfixo.indexOf(parseInt(chamado[4])) > -1) {
            if (mediaid === 1) tipochamada = 1;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
          } else if (valormovel.indexOf(parseInt(chamado[4])) > -1) {
            if (mediaid === 1) tipochamada = 2;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
          }
        }
      }

      if (
        (chamado.length === 10 || chamado.length === 11) &&
        chamado.substr(0, 4) !== "0800" &&
        chamado.substr(0, 2) !== "00"
      ) {
        DDD = chamado.substr(0, 2);
        chamado = chamado.substr(2, chamado.length - 1);
        if (chamado.length === 8 && parseInt(chamado.substr(0, 1)) >= 6) {
          if (parseInt(chamado[0]) >= 6 && parseInt(chamado[0]) <= 9) {
            chamado = "9" + chamado;
          }
        }

        if (
          parseInt(parseInt(DDD)) !== parseInt(DDDPadrao) &&
          chamado.substr(0, 2) !== "00"
        ) {
          if (valorfixo.indexOf(parseInt(chamado[0])) > -1) {
            if (mediaid === 1) tipochamada = 3;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
          } else if (valormovel.indexOf(parseInt(chamado[0])) > -1) {
            if (mediaid === 1) tipochamada = 4;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
          }
        } else if (parseInt(DDD) === parseInt(DDDPadrao)) {
          if (valorfixo.indexOf(parseInt(chamado[0])) > -1) {
            if (mediaid === 1) tipochamada = 1;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
          } else if (valormovel.indexOf(parseInt(chamado[0])) > -1) {
            if (mediaid === 1) tipochamada = 2;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
          }
        }
        if (mediaid !== 8) {
          chamado = DDD + chamado;
          calledDigitado = DDD + calledDigitado;
        }
      } else if (chamado.length === 8 || chamado.length === 9) {
        if (chamado.length === 8 && parseInt(chamado.substr(0, 1)) >= 6) {
          if (parseInt(chamado[0]) >= 6 && parseInt(chamado[0]) <= 9) {
            chamado = "9" + chamado;
          }
        }

        if (valorfixo.indexOf(parseInt(chamado[0])) > -1) {
          if (mediaid === 1) tipochamada = 1;
          else if (mediaid === 5) tipochamada = 17;
          else if (mediaid === 8) tipochamada = 19;
          else if (mediaid === 4) tipochamada = 18;
          else if (mediaid === 6) tipochamada = 20;
          else if (mediaid === 9) tipochamada = 21;
          else if (mediaid === 10) tipochamada = 23;
          else if (mediaid === 3) tipochamada = 22;
          else if (mediaid === 2) tipochamada = 24;
        } else if (valormovel.indexOf(parseInt(chamado[0])) > -1) {
          if (mediaid === 1) tipochamada = 2;
          else if (mediaid === 5) tipochamada = 17;
          else if (mediaid === 8) tipochamada = 19;
          else if (mediaid === 4) tipochamada = 18;
          else if (mediaid === 6) tipochamada = 20;
          else if (mediaid === 9) tipochamada = 21;
          else if (mediaid === 10) tipochamada = 23;
          else if (mediaid === 3) tipochamada = 22;
          else if (mediaid === 2) tipochamada = 24;
        }
        if (mediaid !== 1 && mediaid !== 8) {
          chamado = DDD + chamado;
          calledDigitado = DDD + calledDigitado;
        }
      } else if (chamado.substr(0, 4) === "0800") {
        // chamado = '0'+chamado;
        tipochamada = 8;
      } else if (chamado.substr(0, 2) === "00") {
        if (mediaid === 1) tipochamada = 5;
        else if (mediaid === 5) tipochamada = 17;
        else if (mediaid === 8) tipochamada = 19;
        else if (mediaid === 4) tipochamada = 18;
        else if (mediaid === 6) tipochamada = 20;
        else if (mediaid === 9) tipochamada = 21;
        else if (mediaid === 10) tipochamada = 23;
        else if (mediaid === 3) tipochamada = 22;
        else if (mediaid === 2) tipochamada = 24;
      } else {
        permrouter.map((result) => {
          if (result.calltypeid === 11) {
            if (
              parseInt(chamado) >= parseInt(result.partialnumber) &&
              parseInt(chamado) <= parseInt(result.partialnumber_end)
            ) {
              tipochamada = 11;
            }
          } else if (result.calltypeid === 6) {
            if (parseInt(chamado) === parseInt(result.partialnumber)) {
              tipochamada = 6;
            }
          }
        });
      }

      AtdSimult.map((atend) => {
        if (
          String(atend.telefone) === String(chamado) &&
          parseInt(mediaid) === parseInt(atend.idmidia)
        )
          checkAtd = true;
      });

      if (mediaid === 4) tipochamada = 18;
      else if (mediaid === 6) tipochamada = 20;
      else if (mediaid === 9) tipochamada = 21;
      else if (mediaid === 10) tipochamada = 23;
      else if (mediaid === 3) tipochamada = 22;
      else if (mediaid === 2) tipochamada = 24;

      if (checkAtd === false) {
        if (chamado !== "") {
          if (!isNaN(chamado)) {
            permrouter.map((result) => {
              if (parseInt(result.idmidia) === parseInt(mediaid)) {
                if (parseInt(tipochamada) === result.calltypeid) {
                  if (parseInt(tipochamada) === 1) {
                    if (
                      (parseInt(chamado) >=
                        parseInt(result.areacode + result.partialnumber) &&
                        chamado <=
                          parseInt(
                            result.areacode + result.partialnumber_end,
                          )) ||
                      parseInt(chamado) ===
                        parseInt(result.areacode + result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      (parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) >= parseInt(result.partialnumber) &&
                        chamado.substr(parseInt(chamado.length) - 8, 4) <=
                          parseInt(result.partialnumber_end)) ||
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) === parseInt(result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      result.operator !== null &&
                      result.operator !== "" &&
                      result.areacode ===
                        parseInt(
                          chamado.substr(parseInt(chamado.length) - 10, 2),
                        )
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                      checkRota = true;
                    } else if (rotaencontrada === false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (parseInt(tipochamada) === 2) {
                    if (
                      (parseInt(chamado) >=
                        parseInt(result.areacode + result.partialnumber) &&
                        chamado <=
                          parseInt(
                            result.areacode + result.partialnumber_end,
                          )) ||
                      parseInt(chamado) ===
                        parseInt(result.areacode + result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      (parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) >= parseInt(result.partialnumber) &&
                        chamado.substr(parseInt(chamado.length) - 8, 4) <=
                          parseInt(result.partialnumber_end)) ||
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) === parseInt(result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      result.operator !== null &&
                      result.operator !== "" &&
                      result.areacode ===
                        parseInt(
                          chamado.substr(parseInt(chamado.length) - 11, 2),
                        )
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                      checkRota = true;
                    } else if (rotaencontrada === false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (parseInt(tipochamada) === 3) {
                    if (
                      (parseInt(chamado) >=
                        parseInt(result.areacode + result.partialnumber) &&
                        chamado <=
                          parseInt(
                            result.areacode + result.partialnumber_end,
                          )) ||
                      parseInt(chamado) ===
                        parseInt(result.areacode + result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      (parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) >= parseInt(result.partialnumber) &&
                        chamado.substr(parseInt(chamado.length) - 8, 4) <=
                          parseInt(result.partialnumber_end)) ||
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) === parseInt(result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 10, 2),
                      ) === parseInt(result.areacode)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (rotaencontrada === false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (parseInt(tipochamada) === 4) {
                    if (
                      (parseInt(chamado) >=
                        parseInt(result.areacode + result.partialnumber) &&
                        chamado <=
                          parseInt(
                            result.areacode + result.partialnumber_end,
                          )) ||
                      parseInt(chamado) ===
                        parseInt(result.areacode + result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                      checkRota = true;
                    } else if (
                      (parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) >= parseInt(result.partialnumber) &&
                        chamado.substr(parseInt(chamado.length) - 8, 4) <=
                          parseInt(result.partialnumber_end)) ||
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) === parseInt(result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 11, 2),
                      ) === parseInt(result.areacode)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (rotaencontrada === false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (parseInt(tipochamada) === 5) {
                    if (rotaencontrada === false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (parseInt(tipochamada) === 8) {
                    if (rotaencontrada === false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (
                    parseInt(tipochamada) !== 5 &&
                    chamado.substr(0, 2) === "00" &&
                    parseInt(result.operator) === parseInt(chamado.substr(0, 2))
                  ) {
                    trunk = result.idtrunk;
                    addtech = result.addtech;
                    scriptrunk = result.scripttrunk;
                    operator = "";
                    tech = result.tech;
                    idgrupo_rota = result.idgrupo_rota;
                    idgrupo_transb = result.idgrupo_transb;
                    rotaencontrada = true;
                    existeRota = true;
                    checkRota = true;
                  } else if (parseInt(tipochamada) === 11) {
                    permrouter.map((result) => {
                      if (result.calltypeid === 11) {
                        if (
                          parseInt(chamado) >= parseInt(result.partialnumber) &&
                          parseInt(chamado) <=
                            parseInt(result.partialnumber_end)
                        ) {
                          trunk = result.idtrunk;
                          addtech = result.addtech;
                          scriptrunk = result.scripttrunk;
                          operator = "";
                          tech = result.tech;
                          idgrupo_rota = result.idgrupo_rota;
                          idgrupo_transb = result.idgrupo_transb;
                          rotaencontrada = true;
                          existeRota = true;
                          checkRota = true;
                        }
                      }
                    });
                  } else if (parseInt(tipochamada) === 6) {
                    permrouter.map((result) => {
                      if (result.calltypeid === 6) {
                        if (
                          parseInt(chamado) === parseInt(result.partialnumber)
                        ) {
                          trunk = result.idtrunk;
                          addtech = result.addtech;
                          scriptrunk = result.scripttrunk;
                          operator = "";
                          tech = result.tech;
                          idgrupo_rota = result.idgrupo_rota;
                          idgrupo_transb = result.idgrupo_transb;
                          rotaencontrada = true;
                          existeRota = true;
                          checkRota = true;
                        }
                      }
                    });
                  } else {
                    if (rotaencontrada === false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                    }
                  }
                }
              }
            });
            if (existeRota === true) {
              for (let i = 0; i < queue.length; i++) {
                var numberqueue = queue[i].caller;

                //if(chamado === numberqueue){
                if (numberqueue.search(chamado) !== -1) {
                  retorno = 1;
                  var queueid = queue[i].queueid;
                  var recvcount = queue[i].recv_count;
                  var cdrid = queue[i].cdrid;
                  var srvin = queue[i].serviceinid;
                  var caller = queue[i].caller;
                  var called = queue[i].called;
                  var cbackcount = queue[i].callback_count;
                  statusQueue = queue[i].status;
                }
              }

              if (mediaid === 5) {
                chamado = chamado.toString();
                chamado = chamado.trim();
                calledDigitado = calledDigitado.toString();
                calledDigitado = calledDigitado.trim();
              } else if (mediaid === 8) {
                chamado = chamado.toString();
                chamado = chamado.trim();
                calledDigitado = calledDigitado.toString();
                calledDigitado = calledDigitado.trim();
              }

              if (mediaid === 1) {
                if (retorno === 1) {
                  dispatch(
                    RequestActiveCallSocketVoz(
                      outband,
                      infouser,
                      trunk,
                      mediaid,
                      caracterAdicional + chamado,
                      addtech,
                      scriptrunk,
                      operator,
                      true,
                      queueid,
                      recvcount,
                      null,
                      tech,
                      idgrupo_rota,
                      idgrupo_transb,
                      ipcurrent,
                      cdrid,
                      checkRota,
                      undefined,
                      payload,
                    ),
                  );
                  dispatch(
                    ReturningCallback(
                      queueid,
                      true,
                      recvcount,
                      cdrid,
                      mediaid,
                      srvin,
                      caller,
                      called,
                    ),
                  );
                  if (statusQueue !== "2") {
                    dispatch(
                      returnListCallQueue(
                        "",
                        queueid,
                        "2",
                        parseInt(cbackcount + 1),
                        "você",
                      ),
                    );
                  }
                  dispatch(ShowInfoDisplay("Clientes"));
                } else {
                  dispatch(
                    RequestActiveCallSocketVoz(
                      outband,
                      infouser,
                      trunk,
                      mediaid,
                      caracterAdicional + chamado,
                      addtech,
                      scriptrunk,
                      operator,
                      false,
                      queueid,
                      recvcount,
                      null,
                      tech,
                      idgrupo_rota,
                      idgrupo_transb,
                      ipcurrent,
                      cdrid,
                      checkRota,
                      undefined,
                      payload,
                    ),
                  );
                  dispatch(
                    ReturningCallback(
                      queueid,
                      true,
                      recvcount,
                      cdrid,
                      mediaid,
                      srvin,
                      caller,
                      called,
                    ),
                  );
                  if (statusQueue !== "2") {
                    dispatch(
                      returnListCallQueue(
                        "",
                        queueid,
                        "2",
                        parseInt(cbackcount + 1),
                        "você",
                      ),
                    );
                  }
                  dispatch(ShowInfoDisplay("Clientes"));
                }
              } else {
                if (retorno === 1) {
                  dispatch(
                    RequestActiveCall(
                      outband,
                      infouser,
                      trunk,
                      mediaid,
                      chamado,
                      addtech,
                      scriptrunk,
                      operator,
                      true,
                      queueid,
                      recvcount,
                      cbackcount,
                      idgrupo_transb,
                      cdrid,
                      undefined,
                      payload,
                    ),
                  );
                  dispatch(
                    ReturningCallback(
                      queueid,
                      true,
                      recvcount,
                      cdrid,
                      mediaid,
                      srvin,
                      caller,
                      called,
                    ),
                  );
                  if (statusQueue !== "2") {
                    dispatch(
                      returnListCallQueue(
                        "",
                        queueid,
                        "2",
                        parseInt(cbackcount + 1),
                        "você",
                      ),
                    );
                  }
                  dispatch(ShowInfoDisplay("Clientes"));
                } else {
                  dispatch(
                    RequestActiveCall(
                      outband,
                      infouser,
                      trunk,
                      mediaid,
                      chamado,
                      addtech,
                      scriptrunk,
                      operator,
                      false,
                      queueid,
                      recvcount,
                      cbackcount,
                      idgrupo_transb,
                      undefined,
                      undefined,
                      payload,
                    ),
                  );
                  dispatch(ShowInfoDisplay("Clientes"));
                }
              }
              dispatch(ShowActiveCall(""));
              // console.log("raimundo_neto 7744", { cdrid });
              sucessInteractionIngDeskFromClientWallet(payload, dispatch);
            } else {
              sendIngDeskMessage(
                "Sem rota de saída",
                connectionsapi,
                dispatch,
                url_iframe,
              );
              if (url_iframe === "")
                dispatch(InterationNotifier("Sem rota de saída", "call"));
            }
          } else {
            sendIngDeskMessage(
              "Apenas números!",
              connectionsapi,
              dispatch,
              url_iframe,
            );
            if (url_iframe === "")
              dispatch(InterationNotifier("Apenas números!", "call"));
          }
        } else {
          sendIngDeskMessage(
            "Informe o número!",
            connectionsapi,
            dispatch,
            url_iframe,
          );
          if (url_iframe === "")
            dispatch(InterationNotifier("Informe o número!", "call"));
        }
      } else {
        dispatch(
          InterationNotifier(
            "Este cliente já está sendo atendido por você",
            "call",
          ),
        );
        sendIngDeskMessage(
          "Este cliente já está sendo atendido por você",
          connectionsapi,
          dispatch,
        );
      }
    }
  };
};

export const startCallActive = (mediaid, numberreceived, cdrFather) => {
  return (dispatch, getState) => {
    const {
      routergroups,
      outservices,
      informationusers,
      listcallqueue,
      atdsimult,
      status,
      ipcurrent,
      connectionsapi,
      serviceurl,
    } = getState();

    localStorage.setItem("NUMBERNPS", numberreceived);

    let url_iframe = "";
    let permrouter = routergroups;
    let outband = outservices;
    let infouser = informationusers;
    let queue = listcallqueue;
    let AtdSimult = atdsimult;
    let statusAgent = status;
    let statusQueue = 0;

    if (serviceurl.length !== 0) {
      let ArrayServiceURL = "";
    }

    if (infouser.user_midias) {
      let permission = false;
      for (var i = 0; i < infouser.user_midias.length; i++) {
        if (parseInt(infouser.user_midias[i]) === parseInt(mediaid))
          permission = true;
      }

      if (!permission) {
        if (url_iframe === "")
          dispatch(InterationNotifier("Sem permissão", "permission"));

        return true;
      }
    }

    if (statusAgent.allowCall === false) {
      if (url_iframe === "")
        dispatch(InterationNotifier("Pausa não permite ativo", "permission"));

      return true;
    }

    if (permrouter !== "undefined" && permrouter !== "") {
      var existeRota = false;
      var rotaencontrada = false;
      var checkRota = false;
      // var rotaDefault = false;
      // var rotaAlternativa = false;
      var trunk = "";
      var addtech = "";
      var scriptrunk = "";
      var operator = "";
      // var trunkDef = "";
      // var addtechDef = "";
      // var scriptrunkDef = "";
      // var operatorDef = "";
      var tech = "";
      // var techDef = "";
      var idgrupo_rota = "";
      // var idgrupo_rotaDef = "";
      var idgrupo_transb = "";
      // var idgrupo_transbDef = "";
      var chamado = numberreceived;
      var retorno = 0;
      var checkAtd = false;
      var tipochamada = 0;
      var caracterAdicional = "";

      if (mediaid === 5 || mediaid === 1 || mediaid === 8) {
        chamado = chamado.replace(/\D/g, "");
      }

      if (
        permrouter[0].areacodeid !== "undefined" &&
        permrouter[0].areacodeid !== ""
      ) {
        var DDD = permrouter[0].areacodeid;
        var DDDPadrao = permrouter[0].areacodeid;
      } else {
        var DDD = "71";
        var DDDPadrao = "71";
      }

      var calledDigitado = chamado;
      var valorfixo = [1, 2, 3, 4];
      var valormovel = [5, 6, 7, 8, 9];
      if (connection_platform.remove_digits || parseInt(mediaid) !== 1) {
        if (
          chamado[0] === "0" &&
          chamado.substr(0, 2) !== "00" &&
          chamado.substr(0, 4) !== "0800"
        ) {
          caracterAdicional = chamado.substr(0, 1);
          chamado = chamado.substr(1, chamado.length - 1);
        }
      }
      if (
        (chamado.length === 12 || chamado.length === 13) &&
        chamado.substr(0, 2) !== "00"
      ) {
        if (chamado.substr(0, 2) === "55") {
          chamado = chamado.substr(2, chamado.length - 1);
          calledDigitado = calledDigitado.substr(2, calledDigitado.length - 1);
        }
        if (parseInt(chamado.substr(2, 2)) !== parseInt(DDDPadrao)) {
          if (valorfixo.indexOf(parseInt(chamado[4])) > -1) {
            if (mediaid === 1) tipochamada = 3;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
          } else if (valormovel.indexOf(parseInt(chamado[4])) > -1) {
            if (mediaid === 1) tipochamada = 2;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
          }
        } else if (parseInt(chamado.substr(2, 2)) === parseInt(DDDPadrao)) {
          if (valorfixo.indexOf(parseInt(chamado[4])) > -1) {
            if (mediaid === 1) tipochamada = 1;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
          } else if (valormovel.indexOf(parseInt(chamado[4])) > -1) {
            if (mediaid === 1) tipochamada = 2;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
          }
        }
      }

      if (
        (chamado.length === 10 || chamado.length === 11) &&
        chamado.substr(0, 4) !== "0800" &&
        chamado.substr(0, 2) !== "00"
      ) {
        DDD = chamado.substr(0, 2);
        chamado = chamado.substr(2, chamado.length - 1);
        if (chamado.length === 8 && parseInt(chamado.substr(0, 1)) >= 6) {
          if (parseInt(chamado[0]) >= 6 && parseInt(chamado[0]) <= 9) {
            chamado = "9" + chamado;
          }
        }

        if (
          parseInt(parseInt(DDD)) !== parseInt(DDDPadrao) &&
          chamado.substr(0, 2) !== "00"
        ) {
          if (valorfixo.indexOf(parseInt(chamado[0])) > -1) {
            if (mediaid === 1) tipochamada = 3;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
          } else if (valormovel.indexOf(parseInt(chamado[0])) > -1) {
            if (mediaid === 1) tipochamada = 4;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
          }
        } else if (parseInt(DDD) === parseInt(DDDPadrao)) {
          if (valorfixo.indexOf(parseInt(chamado[0])) > -1) {
            if (mediaid === 1) tipochamada = 1;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
          } else if (valormovel.indexOf(parseInt(chamado[0])) > -1) {
            if (mediaid === 1) tipochamada = 2;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
          }
        }
        if (mediaid !== 8) {
          chamado = DDD + chamado;
          calledDigitado = DDD + calledDigitado;
        }
      } else if (chamado.length === 8 || chamado.length === 9) {
        if (chamado.length === 8 && parseInt(chamado.substr(0, 1)) >= 6) {
          if (parseInt(chamado[0]) >= 6 && parseInt(chamado[0]) <= 9) {
            chamado = "9" + chamado;
          }
        }

        if (valorfixo.indexOf(parseInt(chamado[0])) > -1) {
          if (mediaid === 1) tipochamada = 1;
          else if (mediaid === 5) tipochamada = 17;
          else if (mediaid === 8) tipochamada = 19;
          else if (mediaid === 4) tipochamada = 18;
          else if (mediaid === 6) tipochamada = 20;
          else if (mediaid === 9) tipochamada = 21;
          else if (mediaid === 10) tipochamada = 23;
          else if (mediaid === 3) tipochamada = 22;
          else if (mediaid === 2) tipochamada = 24;
        } else if (valormovel.indexOf(parseInt(chamado[0])) > -1) {
          if (mediaid === 1) tipochamada = 2;
          else if (mediaid === 5) tipochamada = 17;
          else if (mediaid === 8) tipochamada = 19;
          else if (mediaid === 4) tipochamada = 18;
          else if (mediaid === 6) tipochamada = 20;
          else if (mediaid === 9) tipochamada = 21;
          else if (mediaid === 10) tipochamada = 23;
          else if (mediaid === 3) tipochamada = 22;
          else if (mediaid === 2) tipochamada = 24;
        }
        if (mediaid !== 1 && mediaid !== 8) {
          chamado = DDD + chamado;
          calledDigitado = DDD + calledDigitado;
        }
      } else if (chamado.substr(0, 4) === "0800") {
        // chamado = '0'+chamado;
        tipochamada = 8;
      } else if (chamado.substr(0, 2) === "00") {
        if (mediaid === 1) tipochamada = 5;
        else if (mediaid === 5) tipochamada = 17;
        else if (mediaid === 8) tipochamada = 19;
        else if (mediaid === 4) tipochamada = 18;
        else if (mediaid === 6) tipochamada = 20;
        else if (mediaid === 9) tipochamada = 21;
        else if (mediaid === 10) tipochamada = 23;
        else if (mediaid === 3) tipochamada = 22;
        else if (mediaid === 2) tipochamada = 24;
      } else {
        permrouter.map((result) => {
          if (result.calltypeid === 11) {
            if (
              parseInt(chamado) >= parseInt(result.partialnumber) &&
              parseInt(chamado) <= parseInt(result.partialnumber_end)
            ) {
              tipochamada = 11;
            }
          } else if (result.calltypeid === 6) {
            if (parseInt(chamado) === parseInt(result.partialnumber)) {
              tipochamada = 6;
            }
          }
        });
      }

      AtdSimult.map((atend) => {
        if (
          String(atend.telefone) === String(chamado) &&
          parseInt(mediaid) === parseInt(atend.idmidia)
        )
          checkAtd = true;
      });

      if (mediaid === 4) tipochamada = 18;
      else if (mediaid === 6) tipochamada = 20;
      else if (mediaid === 9) tipochamada = 21;
      else if (mediaid === 10) tipochamada = 23;
      else if (mediaid === 3) tipochamada = 22;
      else if (mediaid === 2) tipochamada = 24;

      if (checkAtd === false) {
        if (chamado !== "") {
          if (!isNaN(chamado)) {
            permrouter.map((result) => {
              if (parseInt(result.idmidia) === parseInt(mediaid)) {
                if (parseInt(tipochamada) === result.calltypeid) {
                  if (parseInt(tipochamada) === 1) {
                    if (
                      (parseInt(chamado) >=
                        parseInt(result.areacode + result.partialnumber) &&
                        chamado <=
                          parseInt(
                            result.areacode + result.partialnumber_end,
                          )) ||
                      parseInt(chamado) ===
                        parseInt(result.areacode + result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      (parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) >= parseInt(result.partialnumber) &&
                        chamado.substr(parseInt(chamado.length) - 8, 4) <=
                          parseInt(result.partialnumber_end)) ||
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) === parseInt(result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      result.operator !== null &&
                      result.operator !== "" &&
                      result.areacode ===
                        parseInt(
                          chamado.substr(parseInt(chamado.length) - 10, 2),
                        )
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                      checkRota = true;
                    } else if (rotaencontrada === false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (parseInt(tipochamada) === 2) {
                    if (
                      (parseInt(chamado) >=
                        parseInt(result.areacode + result.partialnumber) &&
                        chamado <=
                          parseInt(
                            result.areacode + result.partialnumber_end,
                          )) ||
                      parseInt(chamado) ===
                        parseInt(result.areacode + result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      (parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) >= parseInt(result.partialnumber) &&
                        chamado.substr(parseInt(chamado.length) - 8, 4) <=
                          parseInt(result.partialnumber_end)) ||
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) === parseInt(result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      result.operator !== null &&
                      result.operator !== "" &&
                      result.areacode ===
                        parseInt(
                          chamado.substr(parseInt(chamado.length) - 11, 2),
                        )
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                      checkRota = true;
                    } else if (rotaencontrada === false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (parseInt(tipochamada) === 3) {
                    if (
                      (parseInt(chamado) >=
                        parseInt(result.areacode + result.partialnumber) &&
                        chamado <=
                          parseInt(
                            result.areacode + result.partialnumber_end,
                          )) ||
                      parseInt(chamado) ===
                        parseInt(result.areacode + result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      (parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) >= parseInt(result.partialnumber) &&
                        chamado.substr(parseInt(chamado.length) - 8, 4) <=
                          parseInt(result.partialnumber_end)) ||
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) === parseInt(result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 10, 2),
                      ) === parseInt(result.areacode)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (rotaencontrada === false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (parseInt(tipochamada) === 4) {
                    if (
                      (parseInt(chamado) >=
                        parseInt(result.areacode + result.partialnumber) &&
                        chamado <=
                          parseInt(
                            result.areacode + result.partialnumber_end,
                          )) ||
                      parseInt(chamado) ===
                        parseInt(result.areacode + result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                      checkRota = true;
                    } else if (
                      (parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) >= parseInt(result.partialnumber) &&
                        chamado.substr(parseInt(chamado.length) - 8, 4) <=
                          parseInt(result.partialnumber_end)) ||
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) === parseInt(result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 11, 2),
                      ) === parseInt(result.areacode)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (rotaencontrada === false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (parseInt(tipochamada) === 5) {
                    if (rotaencontrada === false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (parseInt(tipochamada) === 8) {
                    if (rotaencontrada === false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (
                    parseInt(tipochamada) !== 5 &&
                    chamado.substr(0, 2) === "00" &&
                    parseInt(result.operator) === parseInt(chamado.substr(0, 2))
                  ) {
                    trunk = result.idtrunk;
                    addtech = result.addtech;
                    scriptrunk = result.scripttrunk;
                    operator = "";
                    tech = result.tech;
                    idgrupo_rota = result.idgrupo_rota;
                    idgrupo_transb = result.idgrupo_transb;
                    rotaencontrada = true;
                    existeRota = true;
                    checkRota = true;
                  } else if (parseInt(tipochamada) === 11) {
                    permrouter.map((result) => {
                      if (result.calltypeid === 11) {
                        if (
                          parseInt(chamado) >= parseInt(result.partialnumber) &&
                          parseInt(chamado) <=
                            parseInt(result.partialnumber_end)
                        ) {
                          trunk = result.idtrunk;
                          addtech = result.addtech;
                          scriptrunk = result.scripttrunk;
                          operator = "";
                          tech = result.tech;
                          idgrupo_rota = result.idgrupo_rota;
                          idgrupo_transb = result.idgrupo_transb;
                          rotaencontrada = true;
                          existeRota = true;
                          checkRota = true;
                        }
                      }
                    });
                  } else if (parseInt(tipochamada) === 6) {
                    permrouter.map((result) => {
                      if (result.calltypeid === 6) {
                        if (
                          parseInt(chamado) === parseInt(result.partialnumber)
                        ) {
                          trunk = result.idtrunk;
                          addtech = result.addtech;
                          scriptrunk = result.scripttrunk;
                          operator = "";
                          tech = result.tech;
                          idgrupo_rota = result.idgrupo_rota;
                          idgrupo_transb = result.idgrupo_transb;
                          rotaencontrada = true;
                          existeRota = true;
                          checkRota = true;
                        }
                      }
                    });
                  } else {
                    if (rotaencontrada === false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                    }
                  }
                }
              }
            });
            if (existeRota === true) {
              for (let i = 0; i < queue.length; i++) {
                var numberqueue = queue[i].caller;

                //if(chamado === numberqueue){
                if (numberqueue.search(chamado) !== -1) {
                  retorno = 1;
                  var queueid = queue[i].queueid;
                  var recvcount = queue[i].recv_count;
                  var cdrid = queue[i].cdrid;
                  var srvin = queue[i].serviceinid;
                  var caller = queue[i].caller;
                  var called = queue[i].called;
                  var cbackcount = queue[i].callback_count;
                  statusQueue = queue[i].status;
                }
              }

              if (mediaid === 5) {
                chamado = chamado.toString();
                chamado = chamado.trim();
                calledDigitado = calledDigitado.toString();
                calledDigitado = calledDigitado.trim();
              } else if (mediaid === 8) {
                chamado = chamado.toString();
                chamado = chamado.trim();
                calledDigitado = calledDigitado.toString();
                calledDigitado = calledDigitado.trim();
              }

              if (mediaid === 1) {
                if (retorno === 1) {
                  dispatch(
                    RequestActiveCallSocketVoz(
                      outband,
                      infouser,
                      trunk,
                      mediaid,
                      caracterAdicional + chamado,
                      addtech,
                      scriptrunk,
                      operator,
                      true,
                      queueid,
                      recvcount,
                      null,
                      tech,
                      idgrupo_rota,
                      idgrupo_transb,
                      ipcurrent,
                      cdrid,
                      checkRota,
                      cdrFather,
                    ),
                  );
                  dispatch(
                    ReturningCallback(
                      queueid,
                      true,
                      recvcount,
                      cdrid,
                      mediaid,
                      srvin,
                      caller,
                      called,
                    ),
                  );
                  if (statusQueue !== "2") {
                    dispatch(
                      returnListCallQueue(
                        "",
                        queueid,
                        "2",
                        parseInt(cbackcount + 1),
                        "você",
                      ),
                    );
                  }
                  dispatch(ShowInfoDisplay("Clientes"));
                } else {
                  dispatch(
                    RequestActiveCallSocketVoz(
                      outband,
                      infouser,
                      trunk,
                      mediaid,
                      caracterAdicional + chamado,
                      addtech,
                      scriptrunk,
                      operator,
                      false,
                      queueid,
                      recvcount,
                      null,
                      tech,
                      idgrupo_rota,
                      idgrupo_transb,
                      ipcurrent,
                      cdrid,
                      checkRota,
                      cdrFather,
                    ),
                  );
                  dispatch(
                    ReturningCallback(
                      queueid,
                      true,
                      recvcount,
                      cdrid,
                      mediaid,
                      srvin,
                      caller,
                      called,
                    ),
                  );
                  if (statusQueue !== "2") {
                    dispatch(
                      returnListCallQueue(
                        "",
                        queueid,
                        "2",
                        parseInt(cbackcount + 1),
                        "você",
                      ),
                    );
                  }
                  dispatch(ShowInfoDisplay("Clientes"));
                }
              } else {
                if (retorno === 1) {
                  dispatch(
                    RequestActiveCall(
                      outband,
                      infouser,
                      trunk,
                      mediaid,
                      chamado,
                      addtech,
                      scriptrunk,
                      operator,
                      true,
                      queueid,
                      recvcount,
                      cbackcount,
                      idgrupo_transb,
                      cdrid,
                      cdrFather,
                    ),
                  );
                  dispatch(
                    ReturningCallback(
                      queueid,
                      true,
                      recvcount,
                      cdrid,
                      mediaid,
                      srvin,
                      caller,
                      called,
                    ),
                  );
                  if (statusQueue !== "2") {
                    dispatch(
                      returnListCallQueue(
                        "",
                        queueid,
                        "2",
                        parseInt(cbackcount + 1),
                        "você",
                      ),
                    );
                  }
                  dispatch(ShowInfoDisplay("Clientes"));
                } else {
                  dispatch(
                    RequestActiveCall(
                      outband,
                      infouser,
                      trunk,
                      mediaid,
                      chamado,
                      addtech,
                      scriptrunk,
                      operator,
                      false,
                      queueid,
                      recvcount,
                      cbackcount,
                      idgrupo_transb,
                      cdrid,
                      cdrFather,
                    ),
                  );
                  dispatch(ShowInfoDisplay("Clientes"));
                }
              }
              dispatch(ShowActiveCall(""));
            } else {
              if (url_iframe === "")
                dispatch(InterationNotifier("Sem rota de saída", "50"));
            }
          } else {
            if (url_iframe === "")
              dispatch(InterationNotifier("Apenas números!", "50"));
          }
        } else {
          if (url_iframe === "")
            dispatch(InterationNotifier("Informe o número!", "50"));
        }
      } else {
        dispatch(
          InterationNotifier(
            "Este cliente já está sendo atendido por você",
            "50",
          ),
        );
      }
    }
  };
};

export const startCallHidden = (mediaid, numberreceived, cdrFather) => {
  return (dispatch, getState) => {
    const {
      routergroups,
      outservices,
      informationusers,
      listcallqueue,
      atdsimult,
      status,
      ipcurrent,
      connectionsapi,
      serviceurl,
    } = getState();

    localStorage.setItem("ACTIVEHIDDEN", numberreceived);

    let url_iframe = "";
    let permrouter = routergroups;
    let outband = outservices;
    let infouser = informationusers;
    let queue = listcallqueue;
    let AtdSimult = atdsimult;
    let statusAgent = status;
    let statusQueue = 0;

    if (serviceurl.length !== 0) {
      let ArrayServiceURL = "";
    }

    if (infouser.user_midias) {
      let permission = false;
      for (var i = 0; i < infouser.user_midias.length; i++) {
        if (parseInt(infouser.user_midias[i]) === parseInt(mediaid))
          permission = true;
      }

      if (!permission) {
        if (url_iframe === "")
          dispatch(InterationNotifier("Sem permissão", "permission"));

        return true;
      }
    }

    if (statusAgent.allowCall === false) {
      if (url_iframe === "")
        dispatch(InterationNotifier("Pausa não permite ativo", "permission"));

      return true;
    }

    if (permrouter !== "undefined" && permrouter !== "") {
      var existeRota = false;
      var rotaencontrada = false;
      var checkRota = false;
      // var rotaDefault = false;
      // var rotaAlternativa = false;
      var trunk = "";
      var addtech = "";
      var scriptrunk = "";
      var operator = "";
      // var trunkDef = "";
      // var addtechDef = "";
      // var scriptrunkDef = "";
      // var operatorDef = "";
      var tech = "";
      // var techDef = "";
      var idgrupo_rota = "";
      // var idgrupo_rotaDef = "";
      var idgrupo_transb = "";
      // var idgrupo_transbDef = "";
      var chamado = numberreceived;
      var retorno = 0;
      var checkAtd = false;
      var tipochamada = 0;
      var caracterAdicional = "";

      if (mediaid === 5 || mediaid === 1 || mediaid === 8 || mediaid === 12) {
        chamado = chamado.replace(/\D/g, "");
      }

      if (
        permrouter[0].areacodeid !== "undefined" &&
        permrouter[0].areacodeid !== ""
      ) {
        var DDD = permrouter[0].areacodeid;
        var DDDPadrao = permrouter[0].areacodeid;
      } else {
        var DDD = "71";
        var DDDPadrao = "71";
      }

      var calledDigitado = chamado;
      var valorfixo = [1, 2, 3, 4];
      var valormovel = [5, 6, 7, 8, 9];
      if (connection_platform.remove_digits || parseInt(mediaid) !== 1) {
        if (
          chamado[0] === "0" &&
          chamado.substr(0, 2) !== "00" &&
          chamado.substr(0, 4) !== "0800"
        ) {
          caracterAdicional = chamado.substr(0, 1);
          chamado = chamado.substr(1, chamado.length - 1);
        }
      }
      if (
        (chamado.length === 12 || chamado.length === 13) &&
        chamado.substr(0, 2) !== "00"
      ) {
        if (chamado.substr(0, 2) === "55") {
          chamado = chamado.substr(2, chamado.length - 1);
          calledDigitado = calledDigitado.substr(2, calledDigitado.length - 1);
        }
        if (parseInt(chamado.substr(2, 2)) !== parseInt(DDDPadrao)) {
          if (valorfixo.indexOf(parseInt(chamado[4])) > -1) {
            if (mediaid === 1) tipochamada = 3;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
          } else if (valormovel.indexOf(parseInt(chamado[4])) > -1) {
            if (mediaid === 1) tipochamada = 2;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
          }
        } else if (parseInt(chamado.substr(2, 2)) === parseInt(DDDPadrao)) {
          if (valorfixo.indexOf(parseInt(chamado[4])) > -1) {
            if (mediaid === 1) tipochamada = 1;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
          } else if (valormovel.indexOf(parseInt(chamado[4])) > -1) {
            if (mediaid === 1) tipochamada = 2;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
          }
        }
      }

      if (
        (chamado.length === 10 || chamado.length === 11) &&
        chamado.substr(0, 4) !== "0800" &&
        chamado.substr(0, 2) !== "00"
      ) {
        DDD = chamado.substr(0, 2);
        chamado = chamado.substr(2, chamado.length - 1);
        if (chamado.length === 8 && parseInt(chamado.substr(0, 1)) >= 6) {
          if (parseInt(chamado[0]) >= 6 && parseInt(chamado[0]) <= 9) {
            chamado = "9" + chamado;
          }
        }

        if (
          parseInt(parseInt(DDD)) !== parseInt(DDDPadrao) &&
          chamado.substr(0, 2) !== "00"
        ) {
          if (valorfixo.indexOf(parseInt(chamado[0])) > -1) {
            if (mediaid === 1) tipochamada = 3;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
          } else if (valormovel.indexOf(parseInt(chamado[0])) > -1) {
            if (mediaid === 1) tipochamada = 4;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
          }
        } else if (parseInt(DDD) === parseInt(DDDPadrao)) {
          if (valorfixo.indexOf(parseInt(chamado[0])) > -1) {
            if (mediaid === 1) tipochamada = 1;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
          } else if (valormovel.indexOf(parseInt(chamado[0])) > -1) {
            if (mediaid === 1) tipochamada = 2;
            else if (mediaid === 5) tipochamada = 17;
            else if (mediaid === 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
          }
        }
        if (mediaid !== 8) {
          chamado = DDD + chamado;
          calledDigitado = DDD + calledDigitado;
        }
      } else if (chamado.length === 8 || chamado.length === 9) {
        if (chamado.length === 8 && parseInt(chamado.substr(0, 1)) >= 6) {
          if (parseInt(chamado[0]) >= 6 && parseInt(chamado[0]) <= 9) {
            chamado = "9" + chamado;
          }
        }

        if (valorfixo.indexOf(parseInt(chamado[0])) > -1) {
          if (mediaid === 1) tipochamada = 1;
          else if (mediaid === 5) tipochamada = 17;
          else if (mediaid === 8) tipochamada = 19;
          else if (mediaid === 4) tipochamada = 18;
          else if (mediaid === 6) tipochamada = 20;
          else if (mediaid === 9) tipochamada = 21;
          else if (mediaid === 10) tipochamada = 23;
          else if (mediaid === 3) tipochamada = 22;
          else if (mediaid === 2) tipochamada = 24;
        } else if (valormovel.indexOf(parseInt(chamado[0])) > -1) {
          if (mediaid === 1) tipochamada = 2;
          else if (mediaid === 5) tipochamada = 17;
          else if (mediaid === 8) tipochamada = 19;
          else if (mediaid === 4) tipochamada = 18;
          else if (mediaid === 6) tipochamada = 20;
          else if (mediaid === 9) tipochamada = 21;
          else if (mediaid === 10) tipochamada = 23;
          else if (mediaid === 3) tipochamada = 22;
          else if (mediaid === 2) tipochamada = 24;
        }
        if (mediaid !== 1 && mediaid !== 8) {
          chamado = DDD + chamado;
          calledDigitado = DDD + calledDigitado;
        }
      } else if (chamado.substr(0, 4) === "0800") {
        // chamado = '0'+chamado;
        tipochamada = 8;
      } else if (chamado.substr(0, 2) === "00") {
        if (mediaid === 1) tipochamada = 5;
        else if (mediaid === 5) tipochamada = 17;
        else if (mediaid === 8) tipochamada = 19;
        else if (mediaid === 4) tipochamada = 18;
        else if (mediaid === 6) tipochamada = 20;
        else if (mediaid === 9) tipochamada = 21;
        else if (mediaid === 10) tipochamada = 23;
        else if (mediaid === 3) tipochamada = 22;
        else if (mediaid === 2) tipochamada = 24;
      } else {
        permrouter.map((result) => {
          if (result.calltypeid === 11) {
            if (
              parseInt(chamado) >= parseInt(result.partialnumber) &&
              parseInt(chamado) <= parseInt(result.partialnumber_end)
            ) {
              tipochamada = 11;
            }
          } else if (result.calltypeid === 6) {
            if (parseInt(chamado) === parseInt(result.partialnumber)) {
              tipochamada = 6;
            }
          }
        });
      }

      AtdSimult.map((atend) => {
        if (
          String(atend.telefone) === String(chamado) &&
          parseInt(mediaid) === parseInt(atend.idmidia)
        )
          checkAtd = true;
      });

      if (mediaid === 4) tipochamada = 18;
      else if (mediaid === 6) tipochamada = 20;
      else if (mediaid === 9) tipochamada = 21;
      else if (mediaid === 10) tipochamada = 23;
      else if (mediaid === 12) tipochamada = 13;
      else if (mediaid === 3) tipochamada = 22;
      else if (mediaid === 2) tipochamada = 24;

      if (checkAtd === false) {
        if (chamado !== "") {
          if (!isNaN(chamado)) {
            permrouter.map((result) => {
              if (parseInt(result.idmidia) === parseInt(mediaid)) {
                if (parseInt(tipochamada) === result.calltypeid) {
                  if (parseInt(tipochamada) === 1) {
                    if (
                      (parseInt(chamado) >=
                        parseInt(result.areacode + result.partialnumber) &&
                        chamado <=
                          parseInt(
                            result.areacode + result.partialnumber_end,
                          )) ||
                      parseInt(chamado) ===
                        parseInt(result.areacode + result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      (parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) >= parseInt(result.partialnumber) &&
                        chamado.substr(parseInt(chamado.length) - 8, 4) <=
                          parseInt(result.partialnumber_end)) ||
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) === parseInt(result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      result.operator !== null &&
                      result.operator !== "" &&
                      result.areacode ===
                        parseInt(
                          chamado.substr(parseInt(chamado.length) - 10, 2),
                        )
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                      checkRota = true;
                    } else if (rotaencontrada === false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (parseInt(tipochamada) === 2) {
                    if (
                      (parseInt(chamado) >=
                        parseInt(result.areacode + result.partialnumber) &&
                        chamado <=
                          parseInt(
                            result.areacode + result.partialnumber_end,
                          )) ||
                      parseInt(chamado) ===
                        parseInt(result.areacode + result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      (parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) >= parseInt(result.partialnumber) &&
                        chamado.substr(parseInt(chamado.length) - 8, 4) <=
                          parseInt(result.partialnumber_end)) ||
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) === parseInt(result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      result.operator !== null &&
                      result.operator !== "" &&
                      result.areacode ===
                        parseInt(
                          chamado.substr(parseInt(chamado.length) - 11, 2),
                        )
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                      checkRota = true;
                    } else if (rotaencontrada === false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (parseInt(tipochamada) === 3) {
                    if (
                      (parseInt(chamado) >=
                        parseInt(result.areacode + result.partialnumber) &&
                        chamado <=
                          parseInt(
                            result.areacode + result.partialnumber_end,
                          )) ||
                      parseInt(chamado) ===
                        parseInt(result.areacode + result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      (parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) >= parseInt(result.partialnumber) &&
                        chamado.substr(parseInt(chamado.length) - 8, 4) <=
                          parseInt(result.partialnumber_end)) ||
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) === parseInt(result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 10, 2),
                      ) === parseInt(result.areacode)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (rotaencontrada === false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (parseInt(tipochamada) === 4) {
                    if (
                      (parseInt(chamado) >=
                        parseInt(result.areacode + result.partialnumber) &&
                        chamado <=
                          parseInt(
                            result.areacode + result.partialnumber_end,
                          )) ||
                      parseInt(chamado) ===
                        parseInt(result.areacode + result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                      checkRota = true;
                    } else if (
                      (parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) >= parseInt(result.partialnumber) &&
                        chamado.substr(parseInt(chamado.length) - 8, 4) <=
                          parseInt(result.partialnumber_end)) ||
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) === parseInt(result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 11, 2),
                      ) === parseInt(result.areacode)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (rotaencontrada === false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (parseInt(tipochamada) === 5) {
                    if (rotaencontrada === false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (parseInt(tipochamada) === 8) {
                    if (rotaencontrada === false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (
                    parseInt(tipochamada) !== 5 &&
                    chamado.substr(0, 2) === "00" &&
                    parseInt(result.operator) === parseInt(chamado.substr(0, 2))
                  ) {
                    trunk = result.idtrunk;
                    addtech = result.addtech;
                    scriptrunk = result.scripttrunk;
                    operator = "";
                    tech = result.tech;
                    idgrupo_rota = result.idgrupo_rota;
                    idgrupo_transb = result.idgrupo_transb;
                    rotaencontrada = true;
                    existeRota = true;
                    checkRota = true;
                  } else if (parseInt(tipochamada) === 11) {
                    permrouter.map((result) => {
                      if (result.calltypeid === 11) {
                        if (
                          parseInt(chamado) >= parseInt(result.partialnumber) &&
                          parseInt(chamado) <=
                            parseInt(result.partialnumber_end)
                        ) {
                          trunk = result.idtrunk;
                          addtech = result.addtech;
                          scriptrunk = result.scripttrunk;
                          operator = "";
                          tech = result.tech;
                          idgrupo_rota = result.idgrupo_rota;
                          idgrupo_transb = result.idgrupo_transb;
                          rotaencontrada = true;
                          existeRota = true;
                          checkRota = true;
                        }
                      }
                    });
                  } else if (parseInt(tipochamada) === 6) {
                    permrouter.map((result) => {
                      if (result.calltypeid === 6) {
                        if (
                          parseInt(chamado) === parseInt(result.partialnumber)
                        ) {
                          trunk = result.idtrunk;
                          addtech = result.addtech;
                          scriptrunk = result.scripttrunk;
                          operator = "";
                          tech = result.tech;
                          idgrupo_rota = result.idgrupo_rota;
                          idgrupo_transb = result.idgrupo_transb;
                          rotaencontrada = true;
                          existeRota = true;
                          checkRota = true;
                        }
                      }
                    });
                  } else {
                    if (rotaencontrada === false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                    }
                  }
                }
              }
            });

            if (existeRota === true) {
              for (let i = 0; i < queue.length; i++) {
                var numberqueue = queue[i].caller;

                //if(chamado === numberqueue){
                if (numberqueue.search(chamado) !== -1) {
                  retorno = 1;
                  var queueid = queue[i].queueid;
                  var recvcount = queue[i].recv_count;
                  var cdrid = queue[i].cdrid;
                  var srvin = queue[i].serviceinid;
                  var caller = queue[i].caller;
                  var called = queue[i].called;
                  var cbackcount = queue[i].callback_count;
                  statusQueue = queue[i].status;
                }
              }

              if (mediaid === 5) {
                chamado = chamado.toString();
                chamado = chamado.trim();
                calledDigitado = calledDigitado.toString();
                calledDigitado = calledDigitado.trim();
              } else if (mediaid === 8) {
                chamado = chamado.toString();
                chamado = chamado.trim();
                calledDigitado = calledDigitado.toString();
                calledDigitado = calledDigitado.trim();
              }

              if (mediaid === 1) {
                console.log("DESATIVADO VOZ");
              } else {
                if (retorno === 1) {
                  dispatch(
                    RequestHiddenCall(
                      outband,
                      infouser,
                      trunk,
                      mediaid,
                      chamado,
                      addtech,
                      scriptrunk,
                      operator,
                      true,
                      queueid,
                      recvcount,
                      cbackcount,
                      idgrupo_transb,
                      cdrid,
                      cdrFather,
                    ),
                  );
                  dispatch(
                    ReturningCallback(
                      queueid,
                      true,
                      recvcount,
                      cdrid,
                      mediaid,
                      srvin,
                      caller,
                      called,
                    ),
                  );
                  if (statusQueue !== "2") {
                    dispatch(
                      returnListCallQueue(
                        "",
                        queueid,
                        "2",
                        parseInt(cbackcount + 1),
                        "você",
                      ),
                    );
                  }
                  // dispatch(ShowInfoDisplay("Clientes"));
                } else {
                  dispatch(
                    RequestHiddenCall(
                      outband,
                      infouser,
                      trunk,
                      mediaid,
                      chamado,
                      addtech,
                      scriptrunk,
                      operator,
                      false,
                      queueid,
                      recvcount,
                      cbackcount,
                      idgrupo_transb,
                      cdrid,
                      cdrFather,
                    ),
                  );
                }
              }
            } else {
              if (url_iframe === "")
                dispatch(InterationNotifier("Sem rota de saída", "call"));
            }
          } else {
            if (url_iframe === "")
              dispatch(InterationNotifier("Apenas números!", "call"));
          }
        } else {
          if (url_iframe === "")
            dispatch(InterationNotifier("Informe o número!", "call"));
        }
      } else {
        dispatch(
          InterationNotifier(
            "Este cliente já está sendo atendido por você",
            "call",
          ),
        );
      }
    }
  };
};

function sucessInteractionIngDesk(payload, dispatch) {
  setTimeout(() => {
    dispatch(ShowInfoDisplay("Clientes", "casos/" + payload.caseId));
    dispatch(
      changeAtdIngDeskSuccess(payload.destination, "", "", payload.caseId),
    );
  }, 1000);
  dispatch(AlterScreen("Clientes"));
  dispatch(ShowVisibleNextAtd("ocultar", true));
}

function sendIngDeskMessage(mensagem, connectionsapi, dispatch, url_iframe) {
  let jsonIngDesk = {
    origin: "ingweb",
    id: "interactionFailed",
    payload: {
      errorId: 1,
      errorMessage: mensagem,
    },
  };
  setTimeout(() => {
    dispatch(ShowVisibleNextAtd(true, true));
  }, 500);
  connectionsapi.iframe_ref.current.contentWindow.postMessage(
    jsonIngDesk,
    url_iframe,
  );
}

export const RemoveConference = (
  ContactId,
  atendimento,
  line,
  contactatd,
  serviceatd,
) => {
  return (dispatch) => {
    // webphone_api.setparameter('autohold', 3);
    webphone_api.setline(parseInt(line));
    webphone_api.mute(true, 2);
    webphone_api.conference(line, false);

    if (
      confatendimento[contactatd] !== undefined &&
      confatendimento[serviceatd] !== undefined
    ) {
      axios.get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/updateattendantactivity?idact=${confatendimento[contactatd]}&idfunc=6`,
      );

      axios.get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/updateattendantactivity?idact=${confatendimento[serviceatd]}&idfunc=6`,
      );
    }

    dispatch(RemoveConferenceExt(ContactId, atendimento));
  };
};

export async function getAttendanceType(iduser, type, cdrid) {
  try {
    const response = await axios.get(
      `${
        connection_platform.type_connect
      }://${pathname}:${port}/conn/get-attendance-type?iduser=${iduser}&type=${type}&cdrid=${
        cdrid ? cdrid : ""
      }`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export const InsertRegisterMail = (params) => {
  return (dispatch, getState) => {
    const { informationusers, atendimento, mimetypes } = getState();

    const JsonAttendant = {
      serviceattendantid: atendimento.serviceatd,
      userid: informationusers.id,
      message: params.body_msg,
      is_from_agent: true,
      cdrid: atendimento.idatendimento,
      mimetypeid: 45,
      menuid: null,
      srv_wait_id: null,
      thumbnail_path: "",
      caption: params.caption,
      externalcode: `<${atendimento.idatendimento}@mx.google.com>`,
      favorite: false,
      user_favorite: null,
      filesize: 0,
      mon_type_id: 0,
      error_description: "",
      replyid: null,
      start: true,
      file_id: null,
    };

    // const email_to = params.recipients.filter(recipient => recipient.type === 1).map(recipient => recipient.label).join();
    // const email_cc = params.recipients.filter(recipient => recipient.type === 2).map(recipient => recipient.label).join();
    // const email_cco = params.recipients.filter(recipient => recipient.type === 3).map(recipient => recipient.label).join();
    const email_to = params.recipients
      .filter((recipient) => recipient.type === 1 || recipient.type === 0)
      .map((recipient) => recipient.label);
    const email_cc = params.recipients
      .filter((recipient) => recipient.type === 2)
      .map((recipient) => recipient.label);
    const email_cco = params.recipients
      .filter((recipient) => recipient.type === 3)
      .map((recipient) => recipient.label);

    return axios
      .post(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/register-sending-mail`,
        JsonAttendant,
      )
      .then((response) => {
        if (response.data.length !== 0) {
          const serviceattmediaid = response.data[0].id;
          dispatch(
            changeExternalCodeMail(params.externalcode, serviceattmediaid),
          );

          if (params.attachments.length !== 0) {
            params.attachments.map((attachment) => {
              let mimetypeid = mimetypes.filter(
                (mimetype) =>
                  mimetype.fileextension ===
                  "." + attachment.url.split(".").pop(),
              );
              const JsonFiles = {
                serviceattmediaid: serviceattmediaid,
                path: attachment.url,
                mimetypeid: mimetypeid.length !== 0 ? mimetypeid[0].id : 1,
              };
              axios.post(
                `${connection_platform.type_connect}://${pathname}:${port}/conn/register-mail-files`,
                JsonFiles,
              );
            });
          }

          email_to.map((email) => {
            const JsonSubject = {
              serviceattmediaid: serviceattmediaid,
              email_from: "ingenium@ingenium-systems.com.br",
              email: email,
              id_email_header_type: 1,
            };
            axios.post(
              `${connection_platform.type_connect}://${pathname}:${port}/conn/register-mail-infos`,
              JsonSubject,
            );
          });
          email_cc.map((email) => {
            const JsonSubject = {
              serviceattmediaid: serviceattmediaid,
              email_from: "ingenium@ingenium-systems.com.br",
              email: email,
              id_email_header_type: 2,
            };
            axios.post(
              `${connection_platform.type_connect}://${pathname}:${port}/conn/register-mail-infos`,
              JsonSubject,
            );
          });
          email_cco.map((email) => {
            const JsonSubject = {
              serviceattmediaid: serviceattmediaid,
              email_from: "desenvolvimento@ingenium-systems.com.br",
              email: email,
              id_email_header_type: 3,
            };
            axios.post(
              `${connection_platform.type_connect}://${pathname}:${port}/conn/register-mail-infos`,
              JsonSubject,
            );
          });
        }
      });
  };
};

export const byeAcwCall = (cdrid) => {
  return (dispatch, getState) => {
    const { atendimento, atdsimult, informationusers } = getState();
    const messages = "";

    let checkAtd = atdsimult.filter(
      (atd) => parseInt(atd.idatendimento) === parseInt(cdrid),
    );
    if (checkAtd.length !== 0) {
      //dispatch(InterationNotifier('AfterCallWork Encerrado','50'))
      dispatch(RemoveAtd(cdrid));
      dispatch(removeConversation(cdrid));

      if (atdsimult.length > 1) {
        if (atendimento.direction === "2") {
          dispatch(
            createStatusAgent(
              "Atendimento",
              "S.(" + atendimento.telefone + ")",
              Moment().format("DD/MM/YYYY HH:mm:ss"),
            ),
          );
        } else {
          dispatch(
            createStatusAgent(
              "Atendimento",
              "E.(" + atendimento.telefone + ")",
              Moment().format("DD/MM/YYYY HH:mm:ss"),
            ),
          );
        }
      } else if (atdsimult.length <= 1) {
        dispatch(removeAtdUnique());
        dispatch(
          createStatusAgent(
            "Encerrou",
            cdrid,
            Moment().format("DD/MM/YYYY HH:mm:ss"),
          ),
        );
        dispatch(ShowVisibleNextAtd(true, true));
      }

      if (
        atdsimult.length > 1 &&
        parseInt(atendimento.idatendimento) === parseInt(cdrid)
      ) {
        let i = 0;
        if (atdsimult[0].idatendimento === atendimento.idatendimento) i = 1;
        //ProximoAtdSimult(atdsimult[i], messages, atendimento, informationusers, dispatch, ipcurrent, atdsimult)
        const storageAtdActually = localStorage.getItem("current-service");
        if (
          storageAtdActually &&
          parseInt(atendimento.idatendimento) !== parseInt(storageAtdActually)
        ) {
          const indice = atdsimult.findIndex(
            (item) =>
              parseInt(item.idatendimento) === parseInt(storageAtdActually),
          );
          if (indice !== -1) {
            i = indice;
            localStorage.removeItem("current-service");
          }
        }
        SendAttendant(
          atdsimult[i],
          messages,
          atendimento,
          informationusers,
          dispatch,
          ipcurrent,
          undefined,
          atdsimult,
        );
      } else if (atdsimult.length > 1) {
        // if(atendimento.direction === '2' || atendimento.direction === 1){
        if (atendimento.direction === "2") {
          dispatch(
            createStatusAgent(
              "Atendimento",
              "S.(" + atendimento.telefone + ")",
              Moment().format("DD/MM/YYYY HH:mm:ss"),
            ),
          );
        } else {
          dispatch(
            createStatusAgent(
              "Atendimento",
              "E.(" + atendimento.telefone + ")",
              Moment().format("DD/MM/YYYY HH:mm:ss"),
            ),
          );
        }
        let i = 0;
        if (atdsimult[0].idatendimento === atendimento.idatendimento) {
          i = 0;
        } else {
          if (cdrid === atendimento.idatendimento) {
            i = 1;
          }
          // comentado após o problema, onde a primeira chamada era de whatsapp e receptivo
          //e o cliente dava # sendo que o operador estava com outra chamada
          // }else{
          // 	i = 0;
          // }
        }
        const storageAtdActually = localStorage.getItem("current-service");
        if (
          storageAtdActually &&
          parseInt(atendimento.idatendimento) !== parseInt(storageAtdActually)
        ) {
          const indice = atdsimult.findIndex(
            (item) =>
              parseInt(item.idatendimento) === parseInt(storageAtdActually),
          );
          if (indice !== -1) {
            i = indice;
            localStorage.removeItem("current-service");
          }
        }
        //ALTERADO POIS ACHAMOS QUE NÃO PRECISA DESTA LINHA QUANDO O CLIENTE DESCONECTA E NÃO É ELE O ATENDIMENTO ATUAL
        if (parseInt(cdrid) !== parseInt(atdsimult[i].idatendimento)) {
          // ProximoAtdSimult(atdsimult[i], messages, atendimento, informationusers, dispatch, ipcurrent, atdsimult)
          const { atendimento: atendimentoAtual } = getState();
          const ehParaMudarOAtendimentoAtual =
            Boolean(atendimentoAtual) &&
            (Boolean(parseInt(atendimentoAtual.idatendimento)) ||
              parseInt(atendimentoAtual.idatendimento) === 0) &&
            parseInt(cdrid) === parseInt(atendimentoAtual.idatendimento);
          if (ehParaMudarOAtendimentoAtual) {
            SendAttendant(
              atdsimult[i],
              messages,
              atendimento,
              informationusers,
              dispatch,
              ipcurrent,
              undefined,
              atdsimult,
            );
          }
        }
      }
    }
  };
};

export const registerFavoriteMail = (id, favorite) => {
  return (dispatch, getState) => {
    const { informationusers } = getState();
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/registerfavoritemail?id=${id}&iduser=${informationusers.id}&favorite=${favorite}`,
      )
      .then((response) => {
        console.log("LOGINGENIUM SUCESS BACKEND: ", response);
      })
      .catch((error) => {
        dispatch(
          ConnectionsAPI(
            true,
            false,
            true,
            "Conexão com banco de dados foi perdida :" + error,
          ),
        );
      });
  };
};

export async function getServicesFilter() {
  try {
    const response = await axios.get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/get-servicein-group`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getRowGroupFilter() {
  try {
    const response = await axios.get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/get-servicein-queue`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getCampaignsActive() {
  try {
    const response = await axios.get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/get-campaign-active`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getCampaigns() {
  try {
    const response = await axios.get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/get-campaigns`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export const menuToggle = (active) => {
  return { type: types.MENU, active: active.active };
};
export const createPasswordSuccess = (text) => ({ type: types.PASSWORD, text });
export const DeleteContact = (contactid) => ({
  type: types.DELCONTACT,
  contactid: contactid,
});
export const DeleteCompany = (companyid) => ({
  type: types.DELCOMPANY,
  companyid: companyid,
});
export const createReasonBlock = (reasons) => ({
  type: types.BLOCK,
  reasons: reasons,
});
export const createReasonBlockSup = (reasons) => ({
  type: types.SUPBLOCK,
  reasons: reasons,
});
export const GetHistory = (history) => ({
  type: types.HISTORY,
  history: history,
});
export const getCompanys = (companys) => ({
  type: types.COMPANYS,
  companys: companys,
});
export const GetContacts = (contacts) => ({
  type: types.CONTACTS,
  contacts: contacts,
});
export const ClearContacts = (contacts) => ({
  type: types.CLEARCONTACTS,
  contacts: contacts,
});
export const GetInteractionsContact = (interactions) => ({
  type: types.INTERACTIONS_NUMBER,
  interactions: interactions,
});
export const getTypeNumbers = (typenumbers) => ({
  type: types.TYPENUMBERS,
  typenumbers: typenumbers,
});
export const GetCep = (cep) => ({ type: types.GETCEP, cep: cep });
export const GetNumbersContact = (numberscontact) => ({
  type: types.NUMBERSCONTACT,
  numberscontact: numberscontact,
});
export const GetPhoneMidia = (phonemidia) => ({
  type: types.PHONEMIDIA,
  phonemidia: phonemidia,
});
export const getGroups = (groups) => ({ type: types.GROUP, groups: groups });
export const refreshGroups = (id, name) => ({
  type: types.EDIT_GROUP,
  id: id,
  name: name,
});
export const typingadd = (idatendimento, typing) => ({
  type: types.TYPING_ADD,
  idatendimento: idatendimento,
  typing: typing,
});
export const typingedit = (idatendimento, typing) => ({
  type: types.TYPING_EDIT,
  idatendimento: idatendimento,
  typing: typing,
});
export const createServiceIdLogin = (servicesid) => ({
  type: types.SERVICELOGINID,
  servicesid: servicesid,
});
// export const createQueuePermission = (queuepermission) => ({
//   type: types.QUEUEPERMISSION,
//   queuepermission: queuepermission,
// });
export const createQueuePermissionEfective = (queuepermission) => ({
  type: types.QUEUEPERMISSION,
  queuepermission: queuepermission,
});

const createSubserviceObj = (queuepermission, filtrosDeFila) => {
  let subservice = {};
  const hasFiltrosDeFila = Boolean(filtrosDeFila);
  const hasQueuepermission = Array.isArray(queuepermission);
  if (!hasFiltrosDeFila || !hasQueuepermission) return subservice;
  const hasServicoInFiltrosDeFila =
    Boolean(filtrosDeFila.subservico) &&
    typeof filtrosDeFila.subservico === "object";
  if (!hasServicoInFiltrosDeFila) return subservice;
  subservice = filtrosDeFila.subservico;
  const isToBlockEdition = filtrosDeFila && filtrosDeFila.isToBlockEdition;
  if (isToBlockEdition) {
    queuepermission.forEach((service) => {
      subservice[`${service.serviceinid}`] = true;
    });

    return subservice;
  }
  queuepermission.forEach((service) => {
    const hasThisServiceInFilters =
      subservice[`${service.serviceinid}`] !== undefined;
    if (!hasThisServiceInFilters) {
      subservice[`${service.serviceinid}`] = true;
    }
  });

  return subservice;
};

const updateSubservicoInFiltrosDeFila = (queuepermission) => {
  return (dispatch, getState) => {
    try {
      const { filtrosDeFila } = getState();
      const newFiltrosDeFila = {
        canais: filtrosDeFila.canais,
        status: filtrosDeFila.status,
        subservico: filtrosDeFila.subservico,
      };
      const hasQueuepermission = Array.isArray(queuepermission);
      if (!hasQueuepermission) {
        dispatch(
          AdicionarValoresIniciaisDoFiltroDeFila(
            newFiltrosDeFila,
            null,
            filtrosDeFila.isToBlockEdition,
          ),
        );
        return;
      }
      const subserviceObj = createSubserviceObj(queuepermission, filtrosDeFila);
      newFiltrosDeFila.subservico = subserviceObj;
      dispatch(
        AdicionarValoresIniciaisDoFiltroDeFila(
          newFiltrosDeFila,
          null,
          filtrosDeFila.isToBlockEdition,
        ),
      );
    } catch (error) {}
  };
};
export const createQueuePermission = (queuepermission) => {
  return (dispatch, getState) => {
    dispatch(updateSubservicoInFiltrosDeFila(queuepermission));
    dispatch(createQueuePermissionEfective(queuepermission));
  };
};
export const createLoginSuccess = (
  email,
  id,
  user_midias,
  ad,
  jobin_autoblocking,
  nameauth,
  backendingdesk,
  link_webchat,
  force_password_change,
  tokenLogin = null,
) => ({
  type: types.INFOUSER,
  email: email,
  id: id,
  user_midias: user_midias,
  ad: ad,
  jobin_autoblocking: jobin_autoblocking,
  nameauth: nameauth,
  backendingdesk: backendingdesk,
  link_webchat: link_webchat,
  force_password_change: force_password_change,
  tokenLogin: tokenLogin,
});
export const createInfoUsers = (
  email,
  password,
  id,
  displayname,
  grupo,
  ramal,
  idgroup,
  username,
  idsupervisao,
  sipid,
  acessofila,
  semdefinicao,
  supervisor,
  inanscount,
  incallcount,
  intmans,
  outanscount,
  outcallcount,
  outtmans,
  psdcount,
  psdtma,
  tmlogin,
  atdauto,
  idin,
  idout,
  user_midias,
  blockscreen,
  idblockdescription,
  timeexceed,
  idblocksupervision,
  typeblock,
  allowcallpickup,
  tmoutacw,
  permdownload,
  permreproduce,
  tmcallback,
  qtdecallback,
  nameauth,
  skill,
  relatorio,
  backendingdesk,
  link_webchat,
  usedmodule,
  datalogin,
  view_queue_interaction,
  gerente,
  psdfbreak,
  variables_integration,
  cadastros,
  portal,
  suporte,
  serviceout,
  force_password_change,
  qualidade,
  tokenLogin = null,
  evaluation_feedback,
  classificationcount,
  tmnoreply,
  tmsdashboard,
  sending_audio,
  callback_midias,
  standby_permission,
  attach_sender_name,
  confirm_before_close,
  max_agents_on_pause,
  checkpausa,
) => ({
  type: types.INFOUSER,
  email: email,
  password: password,
  id: id,
  displayname: displayname,
  grupo: grupo,
  ramal: ramal,
  idgroup: idgroup,
  username: username,
  idsupervisao: idsupervisao,
  sipid: sipid,
  acessofila: acessofila,
  semdefinicao: semdefinicao,
  supervisor: supervisor,
  inanscount: inanscount,
  incallcount: incallcount,
  intmans: intmans,
  outanscount: outanscount,
  outcallcount: outcallcount,
  outtmans: outtmans,
  psdcount: psdcount,
  psdtma: psdtma,
  tmlogin: tmlogin,
  atdauto: atdauto,
  idin: idin,
  idout: idout,
  user_midias,
  blockscreen: blockscreen,
  idblockdescription: idblockdescription,
  timeexceed: timeexceed,
  idblocksupervision: idblocksupervision,
  typeblock: typeblock,
  allowcallpickup: allowcallpickup,
  tmoutacw: tmoutacw,
  permdownload: permdownload,
  permreproduce: permreproduce,
  tmcallback: tmcallback,
  qtdecallback: qtdecallback,
  nameauth: nameauth,
  skill: skill,
  relatorio: relatorio,
  backendingdesk: backendingdesk,
  link_webchat: link_webchat,
  usedmodule: usedmodule,
  datalogin: datalogin,
  view_queue_interaction: view_queue_interaction,
  gerente: gerente,
  psdfbreak: psdfbreak,
  variables_integration: variables_integration,
  cadastros: cadastros,
  portal: portal,
  suporte: suporte,
  serviceout: serviceout,
  force_password_change: force_password_change,
  qualidade: qualidade,
  tokenLogin: tokenLogin,
  evaluation_feedback,
  classificationcount,
  tmnoreply,
  tmsdashboard,
  sending_audio,
  callback_midias,
  standby_permission,
  attach_sender_name,
  confirm_before_close,
  max_agents_on_pause,
  checkpausa,
});

export const incrementInfoUsers = (
  email,
  password,
  id,
  displayname,
  grupo,
  ramal,
  idgroup,
  username,
  idsupervisao,
  sipid,
  acessofila,
  semdefinicao,
  supervisor,
  inanscount,
  incallcount,
  intmans,
  outanscount,
  outcallcount,
  outtmans,
  psdcount,
  psdtma,
  tmlogin,
  atdauto,
  idin,
  idout,
  dtl,
) => ({
  type: types.EDITUSER,
  email: email,
  password: password,
  id: id,
  displayname: displayname,
  grupo: grupo,
  ramal: ramal,
  idgroup: idgroup,
  username: username,
  idsupervisao: idsupervisao,
  sipid: sipid,
  acessofila: acessofila,
  semdefinicao: semdefinicao,
  supervisor: supervisor,
  inanscount: inanscount,
  incallcount: incallcount,
  intmans: intmans,
  outanscount: outanscount,
  outcallcount: outcallcount,
  outtmans: outtmans,
  psdcount: psdcount,
  psdtma: psdtma,
  tmlogin: tmlogin,
  atdauto: atdauto,
  idin: idin,
  idout: idout,
  dtl: dtl,
});
export const statusFile = (load) => {
  return { type: types.UPLOADPROGRESS, load: load };
};
export const createIvrCallTransfer = (transfers) => ({
  type: types.IVR,
  transfers: transfers,
});
export const createClientDetails = (details) => ({
  type: types.DETAILS,
  details: details,
});
export const errorLogin = (email, id, server) => ({
  type: types.ERRORLOGIN,
  email: email,
  id: id,
  server,
});
export const errorSenha = (email, id) => ({
  type: types.ERRORSENHA,
  email: email,
  id: id,
});
export const errorHour = (id) => ({ type: types.ERRORHOUR, id: id });
export const InterationNotifier = (
  texto,
  status,
  idnotifier,
  screen,
  remote,
) => ({
  type: types.SHOWNOTIFIER,
  texto: texto,
  status: status,
  idnotifier: idnotifier,
  screen: screen,
  remote: remote,
});
export const authSucess = (email, id) => ({
  type: types.AUTHSUCESS,
  email: email,
  id: id,
});
export const ShowVisibleNextAtd = (displaynextatd, displaynextatdtemp) => ({
  type: types.TOGGLE_VISIBLE,
  displaynextatd: displaynextatd,
  displaynextatdtemp: displaynextatdtemp,
});
export const ShowVisibleNextGroup = (
  displaynextgroup,
  displaynextgrouptemp,
) => ({
  type: types.GROUP_VISIBLE,
  displaynextgroup: displaynextgroup,
  displaynextgrouptemp: displaynextgrouptemp,
});
export const ShowVisibleDetailsAtd = (displaydetailsatd) => ({
  type: types.TOGGLE_VISIBLE_DT,
  displaydetailsatd: displaydetailsatd,
});
export const ShowInfoDisplay = (infodisplay, ingdesk) => ({
  type: types.TOGGLE_DISPLAY,
  infodisplay: infodisplay,
  ingdesk: ingdesk,
});
export const ShowActiveCall = (showactivecall) => ({
  type: types.ADD_ACTIVECALL,
  showactivecall: showactivecall,
});
export const GetIpCurrent = (
  ip,
  audio,
  difftime,
  audiomessage,
  audiocall,
  midias,
  idlogin,
) => ({
  type: types.ADD_IPCURRENT,
  ip,
  audio,
  difftime,
  audiomessage,
  audiocall,
  midias,
  idlogin,
});
export const addMessage = (
  messageid,
  message,
  author,
  datatime,
  contactid,
  typemsg,
  statusmsg,
  favorite,
  dia,
  username,
  monuser,
  destiny,
  typemon,
  replyid,
  options,
  title,
  anoenvio,
  dataenvio,
) => ({
  type: types.ADD_MESSAGE,
  id: nextMessageId++,
  messageid,
  message,
  author,
  datatime,
  contactid,
  typemsg,
  statusmsg,
  favorite,
  dia,
  username: username,
  monuser: monuser,
  destiny: destiny,
  typemon: typemon,
  replyid: replyid,
  options: options,
  title: title,
  anoenvio,
  dataenvio,
});
export const addMessageHeader = (contactid, header, monuser) => ({
  type: types.ADD_MESSAGEHEADER,
  contactid,
  header,
  monuser: monuser,
});
export const deleteMessageHeader = (contactid) => ({
  type: types.CLEAR_MESSAGEHEADER,
  contactid,
});
export const changeActiveHeader = (contactid, status) => ({
  type: types.CHANGE_ACTIVEHEADER,
  contactid,
  status,
});
export const addValuesHeader = (contactid, values) => ({
  type: types.ADD_VALUESHEADER,
  contactid,
  values,
});
export const createStatusAgent = (status, reason, datestatus, idreason) => ({
  type: types.ADD_STATUS,
  status,
  reason,
  datestatus,
  idreason,
});
export const initiatingReturn = (
  id,
  queueid,
  recvcount,
  cdrid,
  respclient,
  media,
  srvin,
  caller,
  called,
  callback_count,
  respatendente,
) => ({
  type: types.ADD_CALLBACK,
  id,
  queueid,
  recvcount,
  cdrid,
  respclient,
  media,
  srvin,
  caller,
  called,
  callback_count,
  respatendente,
});
export const clearReturnClient = (caller, status) => ({
  type: types.CLEAR_RETURN,
  caller,
  status,
});
export const refreshReturnClient = (respclient, caller) => ({
  type: types.EDIT_CALLBACK,
  respclient: respclient,
  caller: caller,
});
export const refreshReturnAtd = (respatendente, caller) => ({
  type: types.RESP_ATD,
  respatendente: respatendente,
  caller: caller,
});
export const createTimeStatusAgent = (timestatus) => ({
  type: types.ADD_TIME,
  timestatus,
});
export const removeConversation = (contactid) => ({
  type: types.CLEAR_MESSAGE,
  id: contactid,
});
export const removeConversationMon = (monuser) => ({
  type: types.CLEAR_MESSAGE_MON,
  monuser: monuser,
});
export const deleteNumber = (number) => ({
  type: types.DELNUMBERCONTACT,
  number: number,
});
export const editTypeNumber = (idphone, typenumber, description, midiaid) => ({
  type: types.EDITTYPENUMBERCONTACT,
  idphone: idphone,
  typenumber: typenumber,
  description: description,
  midiaid: midiaid,
});
export const editNumber = (idphone, number) => ({
  type: types.EDITNUMBERCONTACT,
  idphone: idphone,
  number: number,
});
export const removeAtdUnique = () => ({ type: types.REMOVE_ATDUNIQUE });
export const removeChatUnique = () => ({ type: types.REMOVE_CHATUNIQUE });
export const hstListCallQueue = (callqueue) => ({
  type: types.LIST_QUEUE,
  callqueue: callqueue,
});
export const addListCallQueue = (
  tipo,
  callqueueid,
  serviceinid,
  chamado,
  chamador,
  datahora,
  contrech,
  status,
  mediaid,
  cdrid,
  scriptid,
  callback_count,
  customerwait,
  contactname,
  pathfile,
  score_class,
  score_value,
  unreadMessages,
) => ({
  type: types.ADD_QUEUE,
  callqueueid: callqueueid,
  serviceinid: serviceinid,
  chamado: chamado,
  chamador: chamador,
  datahora: datahora,
  contrech: contrech,
  status: status,
  mediaid: mediaid,
  cdrid: cdrid,
  scriptid: scriptid,
  callback_count: callback_count,
  customerwait: customerwait,
  contactname: contactname,
  pathfile: pathfile,
  score_class: score_class,
  score_value: score_value,
  unreadMessages,
});
export const deleteListCallQueue = (callqueueid) => ({
  type: types.DELETE_QUEUE,
  callqueueid: callqueueid,
});
export const editListCallQueue = (
  tipo,
  callqueueid,
  serviceinid,
  chamado,
  chamador,
  datahora,
  contrech,
  status,
  mediaid,
  cdrid,
  customerwait,
  respcliente,
  respatendente,
  pathfile,
  anyreturn,
  score_class,
  score_value,
) => ({
  type: types.EDIT_QUEUE,
  callqueueid: callqueueid,
  serviceinid: serviceinid,
  chamado: chamado,
  chamador: chamador,
  datahora: datahora,
  contrech: contrech,
  status: status,
  mediaid: mediaid,
  cdrid: cdrid,
  customerwait: customerwait,
  respclient: respcliente,
  respatendente: respatendente,
  pathfile: pathfile,
  anyreturn: anyreturn,
  score_class: score_class,
  score_value: score_value,
});
export const returnListCallQueue = (
  tipo,
  callqueueid,
  status,
  callback_count,
  username,
) => ({
  type: types.RETURN_QUEUE,
  callqueueid: callqueueid,
  status: status,
  callback_count: callback_count,
  username: username,
});
export const returnListCallQueueObs = (
  tipo,
  callqueueid,
  status,
  anyreturn,
) => ({
  type: types.RETURN_QUEUEOBS,
  callqueueid: callqueueid,
  status: status,
  anyreturn: anyreturn,
});
//correção crm inicio
const sendInformationForIngDeskWhenAddAtendimento = (ContactId) => {
  return (dispatch, getState) => {
    try {
      const {
        connectionsapi: Connectionsapi,
        informationusers: InfoUsers,
        serviceurl: ServiceURL,
        displaynextatd: DisplayNextAtd,
      } = getState();
      if (DisplayNextAtd.displaynextatd !== "ocultar") return;
      let url_iframe = "";

      if (ServiceURL.length !== 0) {
        let ArrayServiceURL = "";
        if (InfoUsers.nameauth === "IngDesk") {
          ArrayServiceURL = ServiceURL.filter(
            (url) => url.typeofcrm === "IngDesk",
          );
          if (ArrayServiceURL.length !== 0) {
            url_iframe = ArrayServiceURL[0].param;
          }
        }
      }

      if (url_iframe !== "") {
        let channel = "0";

        if (parseInt(ContactId.idmidia) === 1) channel = "Voz";
        else if (parseInt(ContactId.idmidia) === 5) channel = "Whatsapp";
        else if (parseInt(ContactId.idmidia) === 8) channel = "Telegram";

        let jsonIngDesk = {
          origin: "ingweb",
          id: "currentInteraction",
          payload: {
            clientId: null,
            clientName: ContactId.cliente,
            channelId: ContactId.idmidia,
            channelName: channel,
            destination: ContactId.telefone,
            protocol: ContactId.protocolo,
          },
        };

        Connectionsapi.iframe_ref.current.contentWindow.postMessage(
          jsonIngDesk,
          url_iframe,
        );
      }
    } catch (error) {}
  };
};

export const addAtendimentoEffective = (
  idatendimento,
  cliente,
  telefone,
  servico,
  datatimeatd,
  criticidade,
  menubot,
  subservico,
  serviceatd,
  recuperation,
  recuperationtime,
  direction,
  idmidia,
  timecomplete,
  statusagent,
  line,
  queueid,
  serverid,
  qtdmessage,
  pathfile,
  mcdu,
  nomesubservico,
  infoinitcall,
  nomecliente,
  protocolo,
  idsubservico,
  acw,
  isDialNc2,
  arrayChannels,
  caseId,
  statusatd,
  score_class,
  score_value,
  nps_call,
  isTabulation,
  enterpriseAdditionalInfos,
  contactAdditionalInfos,
  lastCdrClicked,
) => ({
  type: types.ADD_ATENDIMENTO,
  id: nextAttId++,
  idatendimento: idatendimento,
  cliente: cliente,
  telefone: telefone,
  servico: servico,
  datatimeatd: datatimeatd,
  criticidade: criticidade,
  menubot,
  subservico,
  serviceatd,
  recuperation,
  recuperationtime: recuperationtime,
  respatendente: false,
  respclient: false,
  direction: direction,
  idmidia: idmidia,
  timecomplete: timecomplete,
  statusagent: statusagent,
  line: line,
  queueid: queueid,
  serverid: serverid,
  qtdmessage: qtdmessage,
  pathfile: pathfile,
  mcdu: mcdu,
  nomesubservico: nomesubservico,
  infoinitcall: infoinitcall,
  nomecliente: nomecliente,
  protocolo: protocolo,
  idsubservico,
  acw,
  isDialNc2,
  arrayChannels,
  caseId,
  statusatd,
  score_class,
  score_value,
  nps_call,
  isTabulation,
  enterpriseAdditionalInfos,
  contactAdditionalInfos,
  lastCdrClicked,
});

export const addAtendimento = (
  idatendimento,
  cliente,
  telefone,
  servico,
  datatimeatd,
  criticidade,
  menubot,
  subservico,
  serviceatd,
  recuperation,
  recuperationtime,
  direction,
  idmidia,
  timecomplete,
  statusagent,
  line,
  queueid,
  serverid,
  qtdmessage,
  pathfile,
  mcdu,
  nomesubservico,
  infoinitcall,
  nomecliente,
  protocolo,
  idsubservico,
  acw,
  isDialNc2,
  arrayChannels,
  caseId,
  statusatd,
  score_class,
  score_value,
  nps_call,
  isTabulation,
  enterpriseAdditionalInfos,
  contactAdditionalInfos,
  lastCdrClicked,
) => {
  return (dispatch, getState) => {
    dispatch(
      addAtendimentoEffective(
        idatendimento,
        cliente,
        telefone,
        servico,
        datatimeatd,
        criticidade,
        menubot,
        subservico,
        serviceatd,
        recuperation,
        recuperationtime,
        direction,
        idmidia,
        timecomplete,
        statusagent,
        line,
        queueid,
        serverid,
        qtdmessage,
        pathfile,
        mcdu,
        nomesubservico,
        infoinitcall,
        nomecliente,
        protocolo,
        idsubservico,
        acw,
        isDialNc2,
        arrayChannels,
        caseId,
        statusatd,
        score_class,
        score_value,
        nps_call,
        isTabulation,
        enterpriseAdditionalInfos,
        contactAdditionalInfos,
        lastCdrClicked,
      ),
    );

    const ContactId = {
      idatendimento,
      cliente,
      telefone,
      servico,
      datatimeatd,
      criticidade,
      menubot,
      subservico,
      serviceatd,
      recuperation,
      recuperationtime,
      direction,
      idmidia,
      timecomplete,
      statusagent,
      line,
      queueid,
      serverid,
      qtdmessage,
      pathfile,
      mcdu,
      nomesubservico,
      infoinitcall,
      nomecliente,
      protocolo,
      idsubservico,
      acw,
      isDialNc2,
      arrayChannels,
      caseId,
      statusatd,
      score_class,
      score_value,
      nps_call,
      isTabulation,
      enterpriseAdditionalInfos,
      contactAdditionalInfos,
      lastCdrClicked,
    };

    dispatch(sendInformationForIngDeskWhenAddAtendimento(ContactId));
  };
};
//correção crm fim

// export const addAtendimento = (
//   idatendimento,
//   cliente,
//   telefone,
//   servico,
//   datatimeatd,
//   criticidade,
//   menubot,
//   subservico,
//   serviceatd,
//   recuperation,
//   recuperationtime,
//   direction,
//   idmidia,
//   timecomplete,
//   statusagent,
//   line,
//   queueid,
//   serverid,
//   qtdmessage,
//   pathfile,
//   mcdu,
//   nomesubservico,
//   infoinitcall,
//   nomecliente,
//   protocolo,
//   idsubservico,
//   acw,
//   isDialNc2,
//   arrayChannels,
//   caseId,
//   statusatd,
//   score_class,
//   score_value,
//   nps_call,
//   isTabulation,
//   enterpriseAdditionalInfos,
//   contactAdditionalInfos,
//   lastCdrClicked
// ) => ({
//   type: types.ADD_ATENDIMENTO,
//   id: nextAttId++,
//   idatendimento: idatendimento,
//   cliente: cliente,
//   telefone: telefone,
//   servico: servico,
//   datatimeatd: datatimeatd,
//   criticidade: criticidade,
//   menubot,
//   subservico,
//   serviceatd,
//   recuperation,
//   recuperationtime: recuperationtime,
//   respatendente: false,
//   respclient: false,
//   direction: direction,
//   idmidia: idmidia,
//   timecomplete: timecomplete,
//   statusagent: statusagent,
//   line: line,
//   queueid: queueid,
//   serverid: serverid,
//   qtdmessage: qtdmessage,
//   pathfile: pathfile,
//   mcdu: mcdu,
//   nomesubservico: nomesubservico,
//   infoinitcall: infoinitcall,
//   nomecliente: nomecliente,
//   protocolo: protocolo,
//   idsubservico,
//   acw,
//   isDialNc2,
//   arrayChannels,
//   caseId,
//   statusatd,
//   score_class,
//   score_value,
//   nps_call,
//   isTabulation,
//   enterpriseAdditionalInfos,
//   contactAdditionalInfos,
//   lastCdrClicked,
// });
export const editQtdMsg = (cdr) => ({ type: types.EDIT_QTD_MSG, cdr: cdr });
export const clearQtdMsg = (cdr) => ({ type: types.CLEAR_QTD_MSG, cdr: cdr });
export const editAtendimentoVoz = (idatendimento, recuperationtime) => ({
  type: types.EDIT_ATENDIMENTO_VOZ,
  id: nextAttId++,
  idatendimento: idatendimento,
  recuperationtime: recuperationtime,
});
export const editmultiplesatdVoz = (idatendimento, recuperationtime) => ({
  type: types.EDIT_MULTIPLES_VOZ,
  idatendimento: idatendimento,
  recuperationtime: recuperationtime,
});
export const consultaAtd = (respatendente) => ({
  type: types.CONSULTA_ATD,
  respatendente: respatendente,
});
export const capturaFila = (capturafila) => ({
  type: types.CAP_QUEUE,
  capturafila: capturafila,
});
export const RefreshStatusQueue = (cdrid) => ({
  type: types.REFRESH_QUEUE_STATUS,
  cdrid: cdrid,
});
export const RefreshQueueid = (cdrnew, queueid) => ({
  type: types.REFRESH_QUEUE_ID,
  cdrnew,
  queueid,
});
export const DispatchRefreshNoAnswer = (queueid) => ({
  type: types.REFRESH_NO_ANSWER,
  queueid,
});
export const editAtendimento = (
  idatendimento,
  cliente,
  telefone,
  servico,
  datatimeatd,
  criticidade,
  menubot,
  subservico,
  serviceatd,
  recuperation,
  recuperationtime,
  direction,
  idmidia,
  timecomplete,
  statusagent,
  line,
  queueid,
  serverid,
  qtdmessage,
  pathfile,
  score_class,
  score_value,
  nps_call,
) => ({
  type: types.EDIT_ATENDIMENTO_D,
  idatendimento: idatendimento,
  cliente: cliente,
  telefone: telefone,
  servico: servico,
  datatimeatd: datatimeatd,
  criticidade: criticidade,
  menubot,
  subservico,
  serviceatd,
  recuperation,
  recuperationtime: recuperationtime,
  respatendente: false,
  respclient: false,
  direction: direction,
  idmidia: idmidia,
  timecomplete: timecomplete,
  statusagent: statusagent,
  line: line,
  queueid: queueid,
  serverid: serverid,
  qtdmessage: qtdmessage,
  pathfile: pathfile,
  score_class: score_class,
  score_value: score_value,
  nps_call: nps_call,
});

export const addAtdSimultEfetive = (
  idatendimento,
  cliente,
  telefone,
  servico,
  datatimeatd,
  criticidade,
  menubot,
  subservico,
  serviceatd,
  recuperation,
  recuperationtime,
  direction,
  idmidia,
  timecomplete,
  statusagent,
  line,
  queueid,
  serverid,
  qtdmessage,
  pathfile,
  mtnow,
  mcdu,
  nomesubservico,
  infoinitcall,
  nomecliente,
  protocolo,
  idsubservico,
  acw,
  isDialNc2,
  arrayChannels,
  score_class,
  score_value,
  nps_call,
) => ({
  type: types.ATD_SIMULT,
  id: OrderAtd++,
  idatendimento: idatendimento,
  cliente: cliente,
  telefone: telefone,
  servico: servico,
  datatimeatd: datatimeatd,
  criticidade: criticidade,
  menubot,
  subservico,
  serviceatd,
  recuperation,
  recuperationtime: recuperationtime,
  respatendente: false,
  respclient: false,
  direction: direction,
  idmidia: idmidia,
  timecomplete: timecomplete,
  statusagent: statusagent,
  line: line,
  queueid: queueid,
  serverid: serverid,
  qtdmessage: qtdmessage,
  pathfile: pathfile,
  mtnow,
  mcdu: mcdu,
  nomesubservico: nomesubservico,
  infoinitcall: infoinitcall,
  nomecliente: nomecliente,
  protocolo: protocolo,
  idsubservico,
  acw,
  isDialNc2,
  arrayChannels,
  score_class,
  score_value,
  nps_call,
});

export const addAtdSimult = (
  idatendimento,
  cliente,
  telefone,
  servico,
  datatimeatd,
  criticidade,
  menubot,
  subservico,
  serviceatd,
  recuperation,
  recuperationtime,
  direction,
  idmidia,
  timecomplete,
  statusagent,
  line,
  queueid,
  serverid,
  qtdmessage,
  pathfile,
  mtnow,
  mcdu,
  nomesubservico,
  infoinitcall,
  nomecliente,
  protocolo,
  idsubservico,
  acw,
  isDialNc2,
  arrayChannels,
  score_class,
  score_value,
  nps_call,
) => {
  return (dispatch, getState) => {
    const { informationusers } = getState();

    dispatch(
      addAtdSimultEfetive(
        idatendimento,
        cliente,
        telefone,
        servico,
        datatimeatd,
        criticidade,
        menubot,
        subservico,
        serviceatd,
        recuperation,
        recuperationtime,
        direction,
        idmidia,
        timecomplete,
        statusagent,
        line,
        queueid,
        serverid,
        qtdmessage,
        pathfile,
        mtnow,
        mcdu,
        nomesubservico,
        infoinitcall,
        nomecliente,
        protocolo,
        idsubservico,
        acw,
        isDialNc2,
        arrayChannels,
        score_class,
        score_value,
        nps_call,
      ),
    );

    const isActiveCall = direction !== "1" && direction !== 1;
    if (!isActiveCall) return;

    clientWalletIntegration.insertInClientWalletInIngDesk(
      informationusers,
      idatendimento,
      telefone,
      idmidia,
    );
  };
};
// export const addAtdSimult = (
//   idatendimento,
//   cliente,
//   telefone,
//   servico,
//   datatimeatd,
//   criticidade,
//   menubot,
//   subservico,
//   serviceatd,
//   recuperation,
//   recuperationtime,
//   direction,
//   idmidia,
//   timecomplete,
//   statusagent,
//   line,
//   queueid,
//   serverid,
//   qtdmessage,
//   pathfile,
//   mtnow,
//   mcdu,
//   nomesubservico,
//   infoinitcall,
//   nomecliente,
//   protocolo,
//   idsubservico,
//   acw,
//   isDialNc2,
//   arrayChannels,
//   score_class,
//   score_value,
//   nps_call
// ) => ({
//   type: types.ATD_SIMULT,
//   id: OrderAtd++,
//   idatendimento: idatendimento,
//   cliente: cliente,
//   telefone: telefone,
//   servico: servico,
//   datatimeatd: datatimeatd,
//   criticidade: criticidade,
//   menubot,
//   subservico,
//   serviceatd,
//   recuperation,
//   recuperationtime: recuperationtime,
//   respatendente: false,
//   respclient: false,
//   direction: direction,
//   idmidia: idmidia,
//   timecomplete: timecomplete,
//   statusagent: statusagent,
//   line: line,
//   queueid: queueid,
//   serverid: serverid,
//   qtdmessage: qtdmessage,
//   pathfile: pathfile,
//   mtnow,
//   mcdu: mcdu,
//   nomesubservico: nomesubservico,
//   infoinitcall: infoinitcall,
//   nomecliente: nomecliente,
//   protocolo: protocolo,
//   idsubservico,
//   acw,
//   isDialNc2,
//   arrayChannels,
//   score_class,
//   score_value,
//   nps_call,
// });
export const editAtdSimult = (
  idatendimento,
  cliente,
  telefone,
  servico,
  datatimeatd,
  criticidade,
  menubot,
  subservico,
  serviceatd,
  recuperation,
  recuperationtime,
  direction,
  idmidia,
  timecomplete,
  statusagent,
  line,
  queueid,
  serverid,
  qtdmessage,
  pathfile,
  score_class,
  score_value,
  nps_call,
) => ({
  type: types.EDIT_ATD_SIMULT,
  idatendimento: idatendimento,
  cliente: cliente,
  telefone: telefone,
  servico: servico,
  datatimeatd: datatimeatd,
  criticidade: criticidade,
  menubot,
  subservico,
  serviceatd,
  recuperation,
  recuperationtime: recuperationtime,
  respatendente: false,
  respclient: false,
  direction: direction,
  idmidia: idmidia,
  timecomplete: timecomplete,
  statusagent: statusagent,
  line: line,
  queueid: queueid,
  serverid: serverid,
  qtdmessage: qtdmessage,
  pathfile: pathfile,
  score_class: score_class,
  score_value: score_value,
  nps_call,
});
export const editAtendimentoClient = (idatendimento) => ({
  type: types.EDIT_ATENDIMENTO_C,
  idatendimento: idatendimento,
  respclient: true,
});
export const editmultiplesatd = (idatendimento, statusatd) => ({
  type: types.EDIT_MULTIPLES,
  idatendimento: idatendimento,
  statusatd: statusatd,
});
export const editatd = (statusatd) => ({
  type: types.EDIT_TIMEATD,
  statusatd: statusatd,
});
export const MsgIdReturn = (callid, msgid, cdrid, status, title) => ({
  type: types.EDIT_MESSAGEID,
  callid: callid,
  msgid: msgid,
  cdrid: cdrid,
  status: status,
  title: title,
});
export const markstarRedux = (msgid, favorite, cdrid) => ({
  type: types.EDIT_MARKSTAR,
  msgid: msgid,
  favorite: favorite,
  cdrid: cdrid,
});
export const MsgIdReturn2 = (msgid, cdrid, status, title) => ({
  type: types.EDIT_STATUSMSG,
  msgid: msgid,
  cdrid: cdrid,
  status: status,
  title: title,
});
export const editAtendimentoAgent = (idatendimento) => ({
  type: types.EDIT_ATENDIMENTO_A,
  idatendimento: idatendimento,
  respagent: true,
});
export const GetRespostasRapidas = (respostas) => ({
  type: types.RESPOSTASRAPIDAS,
  respostas: respostas,
});
export const GetAnotations = (detailsanotations) => ({
  type: types.DETAILSANOTATIONS,
  detailsanotations: detailsanotations,
});
export const GetMarkstar = (detailsmarkstars) => ({
  type: types.DETAILSMARKSTAR,
  detailsmarkstars: detailsmarkstars,
});
export const GetHistoryCalls = (historycalls) => ({
  type: types.HISTORYCCALLS,
  historycalls: historycalls,
});
export const GetServiceGroup = (
  mss,
  srvin,
  mediaid,
  callcount,
  atdcount,
  atdslacount,
  tmatd,
  queuecount,
  queueanscount,
  tmansqueue,
  mte,
  abncount,
  abnslacount,
  tmabn,
  abncounttransfer,
  abnslacounttransfer,
  tmabntransfer,
  transfercount,
  actcall,
  nextcallqueue,
  cdrnextcallqueue,
  datemaxqueue,
) => ({
  type: types.SERVICEGROUP,
  mss: mss,
  srvin: srvin,
  mediaid: mediaid,
  callcount: callcount,
  atdcount: atdcount,
  atdslacount: atdslacount,
  tmatd: tmatd,
  queuecount: queuecount,
  queueanscount: queueanscount,
  tmansqueue: tmansqueue,
  mte: mte,
  abncount: abncount,
  abnslacount: abnslacount,
  tmabn: tmabn,
  abncounttransfer: abncounttransfer,
  abnslacounttransfer: abnslacounttransfer,
  tmabntransfer: tmabntransfer,
  transfercount: transfercount,
  actcall: actcall,
  nextcallqueue: nextcallqueue,
  cdrnextcallqueue: cdrnextcallqueue,
  datemaxqueue: datemaxqueue,
});
export const GetServiceGroupJson = (json) => ({
  type: types.DETAILSMANAGER,
  json: json,
});
export const GetFileShared = (detailsfileshared) => ({
  type: types.DETAILSFILESHARED,
  detailsfileshared: detailsfileshared,
});
export const createUsersAgents = (agents) => ({
  type: types.ADD_AGENTS,
  agents: agents,
});
export const ShowModalsMenu = (modal) => ({
  type: types.SHOW_MODAL,
  modal: modal,
});
export const refreshUsersAgents = (
  id,
  status_sip,
  status,
  razao_bloqueio,
  speaknum,
  direcao,
  time,
  psdcount,
  psdtma,
  incallcount,
  inanscount,
  intmans,
  insla,
  outcallcount,
  outanscount,
  outtmans,
  outsla,
  tmlogin,
  duration,
  mediaid,
  desc_grupo,
  id_grupo,
  username,
  label,
  ramal,
  usedmodule,
  cdremcurso,
  dtl,
  visible,
  jsoncall,
  satisfaction,
  futurepause,
  descfuturepause,
  tmfuturepause,
  countfpause,
) => ({
  type: types.EDIT_AGENTS,
  id: id,
  status_sip: status_sip,
  status: status,
  razao_bloqueio: razao_bloqueio,
  speaknum,
  direcao: direcao,
  time: time,
  psdcount: psdcount,
  psdtma: psdtma,
  incallcount: incallcount,
  inanscount: inanscount,
  intmans: intmans,
  insla: insla,
  outcallcount: outcallcount,
  outanscount: outanscount,
  outtmans: outtmans,
  outsla: outsla,
  tmlogin: tmlogin,
  duration: duration,
  mediaid: mediaid,
  desc_grupo: desc_grupo,
  id_grupo: id_grupo,
  username: username,
  label: label,
  ramal: ramal,
  usedmodule: usedmodule,
  cdremcurso: cdremcurso,
  dtl: dtl,
  visible: visible,
  jsoncall: jsoncall,
  satisfaction,
  futurepause,
  descfuturepause,
  tmfuturepause,
  countfpause,
});
//export const refreshUsersAgentsJson = (id,status_sip,status, razao_bloqueio, speaknum, duration,desc_grupo,id_grupo,username,label,ramal,usedmodule,dtl) => ({ type: types.EDIT_AGENTS_JSON, id: id, status_sip: status_sip, status: status, razao_bloqueio: razao_bloqueio, speaknum, duration: duration,desc_grupo:desc_grupo,id_grupo:id_grupo,username:username,label:label,ramal:ramal,usedmodule:usedmodule,dtl:dtl})
export const refreshUsersAgentsJsonV2 = (json) => ({
  type: types.EDIT_AGENTS_JSON,
  json: json,
});
export const getCriticality = (criticalitys) => ({
  type: types.CRITICALITY,
  criticalitys: criticalitys,
});
export const GetRouterGroup = (routergroups) => ({
  type: types.ROUTERGROUP,
  routergroups: routergroups,
});
export const GetOutService = (outservices) => ({
  type: types.OUTSERVICE,
  outservices: outservices,
});
export const RemoveAtdEfective = (idatendimento) => {
  previusMessagesService.removeLoadedCdrsByCdr(idatendimento);
  return {
    type: types.ATD_DEL,
    idatendimento: idatendimento,
  };
};

export const RemoveAtd = (idatendimento) => {
  return (dispatch, getState) => {
    const { informationusers, atdsimult } = getState();

    // const messagesOfThisAtd = getMessages(messages, idatendimento);
    const duration = clientWalletIntegration.getDurationOfCall(
      atdsimult,
      idatendimento,
    );
    const { telefone, channelId, direction } =
      clientWalletIntegration.getAtdInformation(atdsimult, idatendimento);
    dispatch(RemoveAtdEfective(idatendimento));
    const hasTelefone = Boolean(telefone) || telefone === 0;
    if (!hasTelefone) return;
    const isActiveCall = direction !== "1" && direction !== 1;
    if (!isActiveCall) return;
    clientWalletIntegration.handleActivationCompleted(
      informationusers,
      idatendimento,
      telefone,
      channelId,
      duration,
      // messagesOfThisAtd
    );
  };
};
// export const RemoveAtd = (idatendimento) => ({
//   type: types.ATD_DEL,
//   idatendimento: idatendimento,
// });
export const RemoveChat = (iduserout) => ({
  type: types.CHAT_DEL,
  iduserout: iduserout,
});
export const getListSupervisionGroup = (listsupgroup) => ({
  type: types.LISTSUPGROUP,
  listsupgroup: listsupgroup,
});
export const getListGroupsMsg = (listgroupmsg) => ({
  type: types.LISTGROUPMSG,
  listgroupmsg: listgroupmsg,
});
export const AddNumberContact = (post, number) => ({
  type: types.ADD_NUMBER_CONTACT,
  post: post,
  numberAdd: numberAdd++,
  number: number,
});
export const getMidias = (midiaid) => ({
  type: types.MIDIAS,
  midiaid: midiaid,
});
export const getServicosAgrupados = (servicoagrupado) => ({
  type: types.SERVICOAGRUPADO,
  servicoagrupado: servicoagrupado,
});
export const getChangeRecorder = (gravacaovoz) => ({
  type: types.CHANGERECORDER,
  gravacaovoz: gravacaovoz,
});
export const addChatSimultAtd = (ramal, atendimento) => ({
  type: types.EDIT_CHAT_SIMULT_ATENDIMENTO,
  ramal: ramal,
  atendimento: atendimento,
});
export const addChatSimult = (
  post,
  agent,
  active,
  opencall,
  ramal,
  dateinit,
  line,
) => ({
  type: types.CHAT_SIMULT,
  id: nextAttId,
  iduserout: post,
  agent: agent,
  active: active,
  opencall: opencall,
  ramal: ramal,
  dateinit: dateinit,
  line: line,
});
export const addChat = (post, agent, active, opencall, ramal, dateinit) => ({
  type: types.ADD_CHAT,
  id: nextAttId,
  iduserout: post,
  agent: agent,
  active: active,
  opencall: opencall,
  ramal: ramal,
  dateinit: dateinit,
});
export const editChat = (post, active, opencall, dateinit, line) => ({
  type: types.EDIT_CHAT_VOZ,
  iduserout: post,
  active: active,
  opencall: opencall,
  dateinit: dateinit,
  line: line,
});
export const editChatInternal = (post, active, opencall, line) => ({
  type: types.EDIT_VOZ_INTERNAL,
  iduserout: post,
  active: active,
  opencall: opencall,
  line: line,
});
export const endCall = (post) => ({ type: types.END_CALL, iduserout: post });
export const EditQtdMsg = (iduserout, qtdmsg, atual) => ({
  type: types.EDIT_CHAT_SIMULT,
  iduserout: iduserout,
  qtdmsg: qtdmsg,
  atual: atual,
});
export const InsertRegisterNotifier = (
  description,
  display,
  data,
  author,
  mensagem,
  task,
  msgid,
  remote,
  ingdesk_data,
) => ({
  type: types.ADD_NOTIFIER,
  id: msgid,
  description: description,
  data: data,
  author: author,
  mensagem: mensagem,
  display: display,
  task: task,
  remote: remote,
  ingdesk_data: ingdesk_data,
});
export const RemoveNotifier = (idnotifier) => ({
  type: types.DELETE_NOTIFIER,
  idnotifier: idnotifier,
});
export const RemoveRemoteNotifier = (remote) => ({
  type: types.DELETE_NOT_REMOTE,
  remote: remote,
});
export const AlterScreen = (screen, previous, id, notifier) => ({
  type: types.CURRENTSCREEN,
  screen: screen,
  id: id,
  notifier: notifier,
  previous: previous,
});
export const ConnectionsAPI = (imsdn, db, sip, mensagem) => ({
  type: types.CONNECTIONAPI,
  imsdn: imsdn,
  db: db,
  sip: sip,
  mensagem: mensagem,
});
export const addMonitoring = (userout, agent, line, ramal) => ({
  type: types.ADD_MONITORING,
  id: nextAttId,
  userout: userout,
  agent: agent,
  line: line,
  ramal: ramal,
});
export const removeMonitoring = (userout) => ({
  type: types.MONITORING_DEL,
  userout: userout,
});
export const addMonitoringSimult = (userout, agent, line, ramal) => ({
  type: types.ADD_MONITORING_SIMULT,
  id: nextAttId,
  userout: userout,
  agent: agent,
  line: line,
  ramal: ramal,
});
export const clientusermonitorsin = (
  idatendimento,
  cliente,
  telefone,
  servico,
  datatimeatd,
  criticidade,
  menubot,
  subservico,
  serviceatd,
  recuperation,
  recuperationtime,
  direction,
  idmidia,
  timecomplete,
  statusagent,
  line,
  queueid,
  monuser,
  serverid,
  pathfile,
  isFromStandby,
  qtdmessage,
  score_class,
  score_value,
  serviceAtdId,
  nomesubservico,
) => ({
  type: types.ADD_CLIENT_MONITORING,
  id: nextAttId++,
  idatendimento: idatendimento,
  cliente: cliente,
  telefone: telefone,
  servico: servico,
  datatimeatd: datatimeatd,
  criticidade: criticidade,
  menubot,
  subservico,
  serviceatd,
  recuperation,
  recuperationtime: recuperationtime,
  respatendente: false,
  respclient: false,
  direction: direction,
  idmidia: idmidia,
  timecomplete: timecomplete,
  statusagent: statusagent,
  line: line,
  queueid: queueid,
  monuser: monuser,
  serverid: serverid,
  pathfile: pathfile,
  isFromStandby,
  qtdmessage,
  score_class,
  score_value,
  serviceAtdId,
  nomesubservico,
});
export const removeUserMonitoring = (monuser) => ({
  type: types.REMOVE_USER_MONITORING,
  monuser: monuser,
});
export const ByeClientMonitoring = (cdrid) => ({
  type: types.REMOVE_CLIENT_MONITORING,
  cdrid: cdrid,
});
export const EditTypeMonitorings = (userout, line, ramal) => ({
  type: types.EDIT_MONITORING_S,
  userout: userout,
  line: line,
  ramal: ramal,
});
export const EditCursoUserMonitoringSimult = (userout, cdrid) => ({
  type: types.EDIT_MONITORING_C,
  userout: userout,
  cdrid: cdrid,
});
export const EditCursoUserMonitoring = (userout, cdrid) => ({
  type: types.EDIT_MONITORING_D,
  userout: userout,
  cdrid: cdrid,
});
export const EditTypeMonitoringm = (userout, line, ramal) => ({
  type: types.EDIT_MONITORING_M,
  userout: userout,
  line: line,
  ramal: ramal,
});
export const EnableCall = (enable, post) => ({
  type: types.ENABLECALL,
  enable,
  post,
});
export const EditBlockUser = (
  idblockdescription,
  idblocksupervision,
  typeblock,
  reasonblock,
) => ({
  type: types.EDIT_BLOCK_USER,
  idblockdescription,
  idblocksupervision,
  typeblock,
  reasonblock,
});
export const BlockFuture = (blockfuture) => ({
  type: types.BLOCKFUTURE,
  blockfuture,
});
export const CallParkCapture = (callpark) => ({
  type: types.CALLPARK,
  callpark,
});
export const BlockScreen = (blockscreen) => ({
  type: types.BLOCKSCREEN,
  blockscreen,
});
export const ErrorNumberExist = (number) => ({
  type: types.EDITERRORINSERT,
  number,
});
export const editMsg = (msg, id) => {
  return { type: types.EDITMSG, msg: msg, id: id };
};
export const StartFilters = (callback, fila, tratamento, retorno, array) => {
  return {
    type: types.START_FILTERS,
    callback,
    fila,
    tratamento,
    retorno,
    array,
  };
};
export const callbackChange = (post) => {
  return { type: types.FILTRO_CALLBACK, post };
};
export const filaChange = (post) => {
  return { type: types.FILTRO_FILA, post };
};
export const tratamentoChange = (post) => {
  return { type: types.FILTRO_TRATAMENTO, post };
};
export const retornoChange = (post) => {
  return { type: types.FILTRO_RETORNO, post };
};
export const arrayChange = (post) => {
  return { type: types.ARRAY_FILA, post };
};
export const EditReasonBlock = (reasonblock) => {
  return { type: types.REASONBLOCK, reasonblock };
};
export const infoContact = (post) => {
  return { type: types.CONTACT_INFO, post };
};
export const getAutomaticPause = (pauses) => {
  return { type: types.AUTOMATIC_PAUSE, pauses };
};
export const ChangeAudioInteraction = (post) => {
  return { type: types.CHANGE_AUDIO_INTERACTION, post };
};
export const ChangeAudioCall = (post) => {
  return { type: types.CHANGE_AUDIO_CALL, post };
};
export const ChangeAudioMessage = (post) => {
  return { type: types.CHANGE_AUDIO_MESSAGE, post };
};
export const EditReplyOp = (id) => ({ type: types.EDIT_REPLY_OP, id });
export const EditInfoCli = (id, name, arraymenubot, nomesubservico) => ({
  type: types.EDIT_INFO_CLI,
  id,
  name,
  arraymenubot,
  nomesubservico,
});
export const EditSubjectMail = (id, nomesubservico) => ({
  type: types.EDIT_SUBJECT_MAIL,
  id,
  nomesubservico,
});
export const RemoveConferenceExt = (id, idconferencia) => ({
  type: types.REMOVE_CONFERENCE_CLI,
  id,
  idconferencia,
});
export const AddConferenceExt = (id, idconferencia) => ({
  type: types.ADD_CONFERENCE_CLI,
  id,
  idconferencia,
});
export const createServiceUrl = (url) => ({
  type: types.ADD_SERVICE_URL,
  url: url,
});
export const ClearAddConferenceExt = () => ({
  type: types.CLEAR_CONFERENCE_CLI,
});
// export const EditInfoCliSimult = (id,name,arraymenubot) => ({ type: types.EDIT_INFO_CLI, id,name,arraymenubot })
export const editChatInternalLine = (line, dateinit) => ({
  type: types.EDIT_VOZ_INTERNAL_LINE,
  line: line,
  dateinit: dateinit,
});
export const endCallLine = (line, dateinit) => ({
  type: types.END_CALL_LINE,
  line: line,
  dateinit: dateinit,
});
export const editChatLine = (line, dateinit) => ({
  type: types.EDIT_CHAT_VOZ_LINE,
  line: line,
  dateinit: dateinit,
});
export const listDevice = (dispositivo, descricao) => ({
  type: types.LIST_DEVICE,
  dispositivo: dispositivo,
  descricao: descricao,
});
export const listDeviceDefault = (dispositivo, descricao) => ({
  type: types.LIST_DEVICE_DEFAULT,
  dispositivo: dispositivo,
  descricao: descricao,
});
export const EditSuperInfo = (iduser) => {
  return { type: types.EDIT_SUPERINFO, iduser: iduser };
};
export const showmodalPause = (params) => {
  return { type: types.EDIT_MODAL_PAUSE, params: params };
};

export const EditAcwContactEfective = (cdr) => {
  return { type: types.EDIT_ACW_CONTACT, cdr: cdr };
};

export const EditAcwContact = (cdr) => {
  return (dispatch, getState) => {
    const { informationusers, atdsimult } = getState();

    const duration = clientWalletIntegration.getDurationOfCall(atdsimult, cdr);
    const { telefone, channelId, direction } =
      clientWalletIntegration.getAtdInformation(atdsimult, cdr);
    dispatch(EditAcwContactEfective(cdr));
    const hasTelefone = Boolean(telefone) || telefone === 0;
    if (!hasTelefone) return;
    const isActiveCall = direction !== "1" && direction !== 1;
    if (!isActiveCall) return;
    clientWalletIntegration.handleActivationCompleted(
      informationusers,
      cdr,
      telefone,
      channelId,
      duration,
    );
  };
};
// export const EditAcwContact = (cdr) => {
//   return { type: types.EDIT_ACW_CONTACT, cdr: cdr };
// };
export const EditIsTabulatorToClassification = (cdr, isTabulation) => {
  return { type: types.EDIT_IS_TABULATION, cdr: cdr, isTabulation };
};
export const EditAcwContactDisabled = (cdr) => {
  return { type: types.EDIT_ACW_CONTACT_DISABLED, cdr: cdr };
};
export const Nc2BlockUser = (blocknc2, mensagemnc2) => ({
  type: types.BLOCKNC2,
  blocknc2,
  mensagemnc2,
});
export const EditIndicatorsUser = (outtmans, intmans) => ({
  type: types.EDIT_INDICATORS,
  outtmans,
  intmans,
});

export const EditFutureBreak = (psdfbreak) => ({
  type: types.EDIT_FUTURE_BREAK,
  psdfbreak,
});
export const nc2ScheduleReasonsUser = (reasonsnc2) => ({
  type: types.EDIT_USER_SCHEDULE_REASONS_NC2,
  reasonsnc2,
});
export const nc2ScheduleNumbersUser = (numbersnc2) => ({
  type: types.EDIT_USER_SCHEDULE_NUMBERS_NC2,
  numbersnc2,
});
export const handleConfirmEnableNc2Redux = (paramsnc2, nc2schedule) => ({
  type: types.EDIT_USER_SCHEDULE_CONFIRM_NC2,
  paramsnc2,
  nc2schedule,
});
export const handleInfoNc2Redux = (infoclinc2) => ({
  type: types.EDIT_USER_INFO_NC2,
  infoclinc2,
});
export const changeProtocol = (idatendimento, protocolo) => ({
  type: types.EDIT_MENU_BOT,
  idatendimento,
  protocolo,
});
export const changeAtachData = (idatendimento, datatachado) => ({
  type: types.EDIT_MENU_BOT_DATA,
  idatendimento,
  datatachado,
});
export const changePesquisaSatisfacao = (
  idatendimento,
  score_class,
  score_value,
) => ({
  type: types.EDIT_SURVEY,
  idatendimento,
  score_class,
  score_value,
});
export const UpdateUserLoginResponse = (loginresponse) => ({
  type: types.EDIT_USER_LOGIN_RESPONSE,
  loginresponse,
});
export const setLoginNc2 = (login_nc2) => ({
  type: types.EDIT_USER_LOGIN_NC2,
  login_nc2,
});
export const changeNumberDisponiblesChannel = (
  idatendimento,
  arrayChannels,
) => ({
  type: types.EDIT_NUMBERS_DISPONIBLES_CHANNEL,
  idatendimento,
  arrayChannels,
});
export const changeServiceAtd = (idatendimento, retornoatt) => ({
  type: types.EDIT_ID_SERVICEATD,
  idatendimento,
  retornoatt,
});
export const changeInfoMail = (idatendimento, cliente, servico) => ({
  type: types.EDIT_INFO_MAIL,
  idatendimento,
  cliente,
  servico,
});
export const changeBlockStatus = () => ({ type: types.CHANGE_BLOCK });
export const RegisterRefIframe = (iframe_ref) => ({
  type: types.REF_IFRAME_INGDESK,
  iframe_ref,
});
export const changePermissionsBlock = (allowCall, allowCapture) => ({
  type: types.CHANGE_PERMISSION,
  allowCall,
  allowCapture,
});
export const changeAtdIngDesk = (telefone, clientId, clientName, caseId) => ({
  type: types.CHANGE_IS_INGDESK,
  telefone,
  clientId,
  clientName,
  caseId: caseId,
});
export const changeAtdIngDeskSuccess = (
  telefone,
  clientId,
  clientName,
  caseId,
) => ({
  type: types.CHANGE_IS_INGDESK_SUCCESS,
  telefone,
  clientId,
  clientName,
  caseId: caseId,
});
export const addInteractionIngDesk = (payload) => ({
  type: types.ADD_INTERACTION,
  payload,
});
export const isSaveInteractionIngDesk = (payload) => ({
  type: types.IS_SAVE_INTERACTION,
  payload,
});
export const isSaveClientIdInteraction = (payload) => ({
  type: types.IS_SAVE_CLIENT_INTERACTION,
  payload,
});
export const removeInteractionIngDesk = () => ({
  type: types.REMOVE_INTERACTION,
});
export const changeTokenIngDeskEndPoint = (token_ingdesk) => ({
  type: types.CHANGE_TOKEN_INGDESK_ENDPOINT,
  token_ingdesk,
});
export const changeLinkCopied = () => ({ type: types.LINK_COPIED });
export const AddMessageMail = (
  operator,
  recipients,
  body_msg,
  attachments,
  date_sending,
  cdr,
  externalcode,
  favorite,
  id,
  caption,
  msg_id,
  isAgent,
) => ({
  type: types.ADD_MESSAGE_MAIL,
  operator,
  recipients,
  body_msg,
  attachments,
  date_sending,
  cdr,
  externalcode,
  favorite,
  id,
  caption,
  msg_id,
  isAgent,
});
export const AddAttachmentsMail = (id, attachments) => ({
  type: types.ADD_ATTACHMENTS_MAIL,
  id,
  attachments,
});
export const addMimetypes = (mimetypes) => ({
  type: "ADD_MIMETYPES",
  mimetypes,
});
export const changeExternalCodeMail = (externalcode, serviceattmediaid) => ({
  type: "CHANGE_CODE_MAIL",
  externalcode,
  serviceattmediaid,
});
export const mountTabulatorReduce = (three) => ({
  type: types.ADD_TABULATOR,
  three,
});
export const changeFavoriteMail = (externalcode, favorite) => ({
  type: "CHANGE_FAVORITE_MAIL",
  externalcode,
  favorite,
});
export const changeColumnsMail = (
  sender,
  recipient,
  copy,
  hidden_copy,
  date,
  subject,
) => ({
  type: "CHANGE_COLUMNS_MAIL",
  sender,
  recipient,
  copy,
  hidden_copy,
  date,
  subject,
});
export const changeColumnsManager = (
  service,
  channels,
  performed,
  attended,
  tma,
  queue,
  tme,
  abandoned,
  tm_a,
  transfered,
  tmr,
) => ({
  type: "CHANGE_COLUMNS_ALL_SERVICE",
  service,
  channels,
  performed,
  attended,
  tma,
  queue,
  tme,
  abandoned,
  tm_a,
  transfered,
  tmr,
});
export const changeColumnsManagerColaborators = (
  attendants,
  channels,
  future,
  status,
  group,
  tmr_email,
  nps,
  csat,
  reason,
  gda,
  inn,
  tmain,
  outt,
  tmaout,
  timepausefuture,
  timestatus,
) => ({
  type: "CHANGE_COLUMNS_ALL_COLABORATORS",
  attendants,
  channels,
  future,
  status,
  group,
  tmr_email,
  nps,
  csat,
  reason,
  gda,
  in: inn,
  tmain,
  out: outt,
  tmaout,
  timepausefuture,
  timestatus,
});
export const changeColumnsManagerOperators = (columns) => ({
  type: "CHANGE_COLUMNS_ALL_OPERATORS",
  columns,
});
export const changeColumnsManagerGroupRow = (columns) => ({
  type: "CHANGE_COLUMNS_ALL_GROUPROW",
  columns,
});
export const handleDataCsatNPS = (data) => ({
  type: "HANDLE_DATA_CSAT_NPS",
  data,
});
export const handleDataStatusOperators = (data) => ({
  type: "HANDLE_DATA_STATUS_OPERATORS",
  data,
});
export const handleDataIntentions = (data) => ({
  type: "HANDLE_DATA_INTENTIONS",
  data,
});
export const handleGroupsPermissionSupervisor = (data) => ({
  type: "HANDLE_GROUPS_PERMISSION_SUPERVISOR",
  data,
});
export const changeLoginComplete = (post) => ({
  type: "CHANGE_LOGIN_COMPLETE",
  post,
});
export const handleFilterManagerStatus = (post) => ({
  type: "FILTRO_MANAGER_STATUS",
  post,
});
export const handleFilterManagerChannel = (post) => ({
  type: "FILTRO_MANAGER_CHANNEL",
  post,
});
export const handleFilterManagerGroup = (post) => ({
  type: "FILTRO_MANAGER_GROUP",
  post,
});
export const handleFilterManagerService = (post) => ({
  type: "FILTRO_MANAGER_SERVICE",
  post,
});
export const handleFilterManagerGroupRow = (post) => ({
  type: "FILTRO_MANAGER_GROUPROW",
  post,
});
export const clearFiltersManager = () => ({
  type: "CLEAR_FILTRO_MANAGER_SERVICE",
});
export const activeFiltersManager = () => ({ type: "HANDLE_ACTIVE_FILTER" });
export const handleDataPerfomanceCompare = (post) => ({
  type: "HANDLE_DATA_PERFOMANCE_COMPARE",
  post,
});
export const handleDataPerfomance = (post) => ({
  type: "HANDLE_DATA_PERFOMANCE",
  post,
});
export const getDeviceMicrofone = (microfone) => ({
  type: "DEVICE_MICROFONE",
  microfone,
});
export const getDeviceAudio = (audio) => ({ type: "DEVICE_AUDIO", audio });
export const getDeviceRing = (ring) => ({ type: "DEVICE_RING", ring });
export const GetInteractionsModal = (cliente, telefone, contactid) => ({
  type: types.INTERACTIONS_MODAL,
  cliente: cliente,
  telefone: telefone,
  contactid: contactid,
});
export const GetDetailsContacts = (getvalue, detailscontacts, contactAdd) => ({
  type: types.DETAILSCONTACTS,
  detailsget: getvalue,
  detailscontacts: detailscontacts,
  contactAdd: contactAdd,
});

export const clearDetailsNps = (numero_cliente) => ({
  type: types.CLEAR_NPS_DETAILS,
  numero_cliente,
});
export const editDetailsNps = (numero_cliente, nota_nps) => ({
  type: types.EDIT_NPS_DETAILS,
  numero_cliente,
  nota_nps,
});
export const setDetailsNps = (nps_details) => ({
  type: types.NPS_DETAILS,
  nps_details,
});

export const addAnswerHidden = (
  idatendimento,
  cliente,
  telefone,
  servico,
  datatimeatd,
  criticidade,
  menubot,
  subservico,
  serviceatd,
  recuperation,
  recuperationtime,
  direction,
  idmidia,
  timecomplete,
  statusagent,
  line,
  queueid,
  serverid,
  qtdmessage,
  pathfile,
  mcdu,
  nomesubservico,
  infoinitcall,
  nomecliente,
  protocolo,
  idsubservico,
  acw,
  isDialNc2,
  arrayChannels,
  caseId,
  statusatd,
  score_class,
  score_value,
  nps_call,
) => ({
  type: types.ADD_ANSWER_HIDDEN,
  id: nextAttId++,
  idatendimento: idatendimento,
  cliente: cliente,
  telefone: telefone,
  servico: servico,
  datatimeatd: datatimeatd,
  criticidade: criticidade,
  menubot,
  subservico,
  serviceatd,
  recuperation,
  recuperationtime: recuperationtime,
  respatendente: false,
  respclient: false,
  direction: direction,
  idmidia: idmidia,
  timecomplete: timecomplete,
  statusagent: statusagent,
  line: line,
  queueid: queueid,
  serverid: serverid,
  qtdmessage: qtdmessage,
  pathfile: pathfile,
  mcdu: mcdu,
  nomesubservico: nomesubservico,
  infoinitcall: infoinitcall,
  nomecliente: nomecliente,
  protocolo: protocolo,
  idsubservico,
  acw,
  isDialNc2,
  arrayChannels,
  caseId,
  statusatd,
  score_class,
  score_value,
  nps_call,
});
export const removeAnswerHidden = () => ({ type: types.REMOVE_ANSWER_HIDDEN });
export const changeGroupsRow = (groupsrow) => ({
  type: "GROUPSROW",
  groupsrow: groupsrow,
});

export const DeleteMsgId = (msgid, cdrid) => ({
  type: types.DELETE_MESSAGE,
  msgid: msgid,
  cdrid: cdrid,
});

export const editClientName = (telefones, clientName) => ({
  type: "EDIT_CLIENT_NAME",
  telefones: telefones,
  clientName: clientName,
});

export const deleteEmailMsg = (cdr) => ({
  type: types.DEL_MESSAGE_MAIL,
  cdr,
});

export const editPermissionsIngdesk = (permissions) => ({
  type: types.EDIT_PERMISSIONS_INGDESK,
  permissions,
});

export const activeSearchText = (searchText) => ({
  type: "CHANGE_SEARCHTEXT",
  searchText,
});

export const sendQueueAndStandby = (queue, standby, msgsStandby) => ({
  type: "SEND_QUEUE_STANDBY",
  queue,
  standby,
  msgsStandby,
});

// *******LoginV2*******

export const checkDomainV2 = (domain, login, password) => {
  let obterUrlBackend = "";
  if (
    gethostname === "localhost" ||
    connection_platform.ip_intern === gethostname
  )
    obterUrlBackend =
      connection_platform.backendCentralIntern +
      ":" +
      connection_platform.backendCentralInternPort;
  else
    obterUrlBackend =
      connection_platform.backendCentralExtern +
      ":" +
      connection_platform.backendCentralExternPort;
  return (dispatch) => {
    return axios
      .post(`${connection_platform.type_connect}://${obterUrlBackend}/login`, {
        domain: domain,
      })
      .then((response) => {
        if (response.data !== "") {
          let retorno = response.data.Dados[0];
          if (
            gethostname === "localhost" ||
            connection_platform.ip_intern === gethostname
          ) {
            pathname = retorno.ip_backend_internal;
            port = retorno.port_backend_internal;
            localStorage.setItem("pathname", pathname);
            localStorage.setItem("port", port);
          } else {
            pathname = retorno.ip_backend_external;
            port = retorno.port_backend_external;
            localStorage.setItem("pathname", pathname);
            localStorage.setItem("port", port);
          }
          dispatch(loginDomain({ email: login, password }));
        } else {
          dispatch(errorLogin(null, null, "ON2"));
        }
      })
      .catch((error) => {
        dispatch(
          ConnectionsAPI(
            true,
            false,
            true,
            "Conexão com banco de dados foi perdida :" + error,
          ),
        );
      });
  };
};

function loginDomain(post) {
  return (dispatch) => {
    return axios
      .post(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/login2`,
        { username: post.email, password: post.password },
      )
      .then((response) => {
        if (
          response.data &&
          response.data.dados &&
          response.data.dados.length
        ) {
          if (response.data.dados[0].force_password_change) {
            const data = response.data.dados[0];
            const tokenLogin = response.data.token
              ? response.data.token.token
              : null;
            dispatch(
              createLoginSuccess(
                post.email,
                data.id,
                [],
                data.id_auth_set,
                data.jobin_autoblocking,
                data.desc_aut_meth,
                data.address_backend,
                data.link_webchat,
                data.force_password_change,
                tokenLogin,
              ),
            );
          } else {
            const priimsdn = response.data.dados[0].priimsdn;
            const secimsdn = response.data.dados[0].secimsdn;
            const data = response.data.dados[0];
            const tokenLogin = response.data.token
              ? response.data.token.token
              : null;

            if (priimsdn != null && !secimsdn != null) {
              let user_midias = [];
              try {
                const midiasJson = response.data.dados[0].midias;
                const midiasObj = JSON.parse(midiasJson);

                if (midiasObj && midiasObj.length) {
                  midiasObj.forEach((midia) => {
                    user_midias.push(midia.midiaid);
                  });
                }
              } catch (error) {
                console.log("Erro ao fazer JSON.parse: ", error);
              }
              dispatch(CallParkCapture(true));
              useridRefresh = data.id;
              dispatch(
                createLoginSuccess(
                  post.email,
                  data.id,
                  user_midias,
                  data.id_auth_set,
                  data.jobin_autoblocking,
                  data.desc_aut_meth,
                  data.address_backend,
                  data.link_webchat,
                  data.force_password_change,
                  tokenLogin,
                ),
              );

              sendIPSocket(priimsdn, secimsdn, portims);
              // parte antes destinada a senha

              dispatch(
                VerifyHourWork(
                  data.id,
                  post.password,
                  data.jobin_autoblocking,
                  data.idsystem,
                ),
              );
            } else {
              dispatch(errorLogin(null, null, "ON"));
            }
          }
        } else {
          dispatch(errorLogin(null, null, "OFF"));
        }
      })
      .catch((error) => {
        if (
          error.response &&
          error.response.status &&
          error.response.status === 400
        ) {
          dispatch(errorLogin(null, null, "OFF"));
        } else {
          dispatch(
            ConnectionsAPI(
              true,
              false,
              true,
              "Conexão com banco de dados foi perdida :" + error,
            ),
          );
        }
      });
  };
}

export const login = (post) => {
  post.setLoading(true);
  return (dispatch) => {
    return axios
      .post(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/login2`,
        { username: post.email, password: post.password },
      )
      .then((response) => {
        if (
          response.data &&
          response.data.dados &&
          response.data.dados.length
        ) {
          if (response.data.dados[0].force_password_change) {
            const data = response.data.dados[0];
            const tokenLogin = response.data.token
              ? response.data.token.token
              : null;
            dispatch(
              createLoginSuccess(
                post.email,
                data.id,
                [],
                data.id_auth_set,
                data.jobin_autoblocking,
                data.desc_aut_meth,
                data.address_backend,
                data.link_webchat,
                data.force_password_change,
                tokenLogin,
              ),
            );
          } else {
            const priimsdn = response.data.dados[0].priimsdn;
            const secimsdn = response.data.dados[0].secimsdn;
            const data = response.data.dados[0];
            const tokenLogin = response.data.token
              ? response.data.token.token
              : null;

            if (priimsdn != null && !secimsdn != null) {
              let user_midias = [];
              try {
                const midiasJson = response.data.dados[0].midias;
                const midiasObj = JSON.parse(midiasJson);

                if (midiasObj && midiasObj.length) {
                  midiasObj.forEach((midia) => {
                    user_midias.push(midia.midiaid);
                  });
                }
              } catch (error) {
                console.log("Erro ao fazer JSON.parse: ", error);
              }
              dispatch(CallParkCapture(true));
              useridRefresh = data.id;
              dispatch(
                createLoginSuccess(
                  post.email,
                  data.id,
                  user_midias,
                  data.id_auth_set,
                  data.jobin_autoblocking,
                  data.desc_aut_meth,
                  data.address_backend,
                  data.link_webchat,
                  data.force_password_change,
                  tokenLogin,
                ),
              );

              sendIPSocket(priimsdn, secimsdn, portims);
              // parte antes destinada a senha

              dispatch(
                VerifyHourWork(
                  data.id,
                  post.password,
                  data.jobin_autoblocking,
                  data.idsystem,
                ),
              );
            } else {
              dispatch(errorLogin(null, null, "ON"));
            }
          }
        } else {
          dispatch(errorLogin(null, null, "OFF"));
        }
      })
      .catch((error) => {
        if (
          error.response &&
          error.response.status &&
          error.response.status === 400
        ) {
          dispatch(errorLogin(null, null, "OFF"));
        } else {
          dispatch(
            ConnectionsAPI(
              true,
              false,
              true,
              "Conexão com banco de dados foi perdida :" + error,
            ),
          );
        }
      })
      .finally(() => {
        post.setLoading(false);
      });
  };
};

export const AuthLoginAzureV2 = (username) => {
  return (dispatch) => {
    return axios
      .post(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/loginazure`,
        { username },
      )
      .then((response) => {
        if (
          response.data &&
          response.data.dados &&
          response.data.dados.length
        ) {
          const priimsdn = response.data.dados[0].priimsdn;
          const secimsdn = response.data.dados[0].secimsdn;
          const data = response.data.dados[0];
          const tokenLogin = response.data.token
            ? response.data.token.token
            : null;

          if (priimsdn != null && !secimsdn != null) {
            let user_midias = [];
            try {
              const midiasJson = response.data.dados[0].midias;
              const midiasObj = JSON.parse(midiasJson);

              if (midiasObj && midiasObj.length) {
                midiasObj.forEach((midia) => {
                  user_midias.push(midia.midiaid);
                });
              }
            } catch (error) {
              console.log("Erro ao fazer JSON.parse: ", error);
            }
            dispatch(CallParkCapture(true));
            useridRefresh = data.id;
            dispatch(
              createLoginSuccess(
                username,
                data.id,
                user_midias,
                data.id_auth_set,
                data.jobin_autoblocking,
                data.desc_aut_meth,
                data.address_backend,
                data.link_webchat,
                data.force_password_change,
                tokenLogin,
              ),
            );

            sendIPSocket(priimsdn, secimsdn, portims);
            dispatch(
              GetInformationUsers(
                data.id,
                md5("post"),
                false,
                0,
                0,
                0,
                0,
                data.desc_aut_meth,
              ),
            );
            // parte antes destinada a senha
            /*
            dispatch(
              VerifyHourWork(
                data.id,
                post.password,
                data.jobin_autoblocking,
                data.idsystem
              )
            );
            */
          } else {
            dispatch(errorLogin(null, null, "ON"));
          }
        } else {
          dispatch(errorLogin(null, null, "OFF"));
        }
      })
      .catch((error) => {
        if (
          error.response &&
          error.response.status &&
          error.response.status === 400
        ) {
          dispatch(errorLogin(null, null, "OFF"));
        } else {
          dispatch(
            ConnectionsAPI(
              true,
              false,
              true,
              "Conexão com banco de dados foi perdida :" + error,
            ),
          );
        }
      });
  };
};

export async function getCompanysPaginated(
  page,
  title,
  limit = 5,
  cnpj = "",
  codextemp = "",
) {
  if (!connection_platform.multitenancy) {
    try {
      let formatedTitle = title;
      if (!title && title !== 0) {
        formatedTitle = "";
      }
      const response = await axios.get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/companys_v2?page=${page}&limit=${limit}&title=${formatedTitle}&cnpj=${cnpj}&codextemp=${codextemp}`,
      );
      return response.data;
    } catch (error) {
      console.log("getCompanysPaginated ERROR: ", error);
      return [];
    }
  } else {
    let portMult = connection_platform.port_backend_intern;
    const auxPort = localStorage.getItem("port");

    if (auxPort) {
      portMult = auxPort;
    }

    try {
      let formatedTitle = title;
      if (!title && title !== 0) {
        formatedTitle = "";
      }
      const response = await axios.get(
        `${connection_platform.type_connect}://${pathname}:${portMult}/conn/companys_v2?page=${page}&limit=${limit}&title=${formatedTitle}&cnpj=${cnpj}&codextemp=${codextemp}`,
      );
      return response.data;
    } catch (error) {
      console.log("getCompanysPaginated ERROR: ", error);
      return [];
    }
  }
}

export async function getCompanysPaginatedV3(page, value, limit = 5) {
  if (!connection_platform.multitenancy) {
    try {
      let formatedTitle = value;
      if (!value && value !== 0) {
        formatedTitle = "";
      }
      const response = await axios.get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/companys_v3?page=${page}&limit=${limit}&value=${formatedTitle}`,
      );
      return response.data;
    } catch (error) {
      console.log("getCompanysPaginated ERROR: ", error);
      return [];
    }
  } else {
    let portMult = connection_platform.port_backend_intern;
    const auxPort = localStorage.getItem("port");

    if (auxPort) {
      portMult = auxPort;
    }

    try {
      let formatedTitle = value;
      if (!value && value !== 0) {
        formatedTitle = "";
      }
      const response = await axios.get(
        `${connection_platform.type_connect}://${pathname}:${portMult}/conn/companys_v3?page=${page}&limit=${limit}&value=${formatedTitle}`,
      );
      return response.data;
    } catch (error) {
      console.log("getCompanysPaginated ERROR: ", error);
      return [];
    }
  }
}

export const getContactsV3 = (data, contato, empresa, codeExtEmp) => {
  if (!connection_platform.multitenancy) {
    let formatedCodeExtEmp = "";
    if (codeExtEmp || codeExtEmp === 0) {
      formatedCodeExtEmp = codeExtEmp;
    }
    if (contato === undefined) {
      contato = "";
    }
    if (empresa === undefined) {
      empresa = "";
    }

    return (dispatch) => {
      return axios
        .get(
          `${connection_platform.type_connect}://${pathname}:${port}/conn/getcontactsv3?number=${data.telefone}&nome=${data.nome}&empresa=${empresa}&contato=${contato}&codext=${data.codext}&email=${data.email}&codextemp=${formatedCodeExtEmp}`,
        )
        .then((response) => {
          if (response.data !== "") {
            dispatch(GetContacts(response.data));
          } else {
            dispatch(GetContacts([]));
          }
        })
        .catch((error) => {
          dispatch(
            ConnectionsAPI(
              true,
              false,
              true,
              "Conexão com banco de dados foi perdida :" + error,
            ),
          );
        });
    };
  } else {
    let portMult = connection_platform.port_backend_intern;
    const auxPort = localStorage.getItem("port");

    if (auxPort) {
      portMult = auxPort;
    }

    let formatedCodeExtEmp = "";
    if (codeExtEmp || codeExtEmp === 0) {
      formatedCodeExtEmp = codeExtEmp;
    }
    if (contato === undefined) {
      contato = "";
    }
    if (empresa === undefined) {
      empresa = "";
    }

    return (dispatch) => {
      return axios
        .get(
          `${connection_platform.type_connect}://${pathname}:${portMult}/conn/getcontactsv3?number=${data.telefone}&nome=${data.nome}&empresa=${empresa}&contato=${contato}&codext=${data.codext}&email=${data.email}&codextemp=${formatedCodeExtEmp}`,
        )
        .then((response) => {
          if (response.data !== "") {
            dispatch(GetContacts(response.data));
          } else {
            dispatch(GetContacts([]));
          }
        })
        .catch((error) => {
          dispatch(
            ConnectionsAPI(
              true,
              false,
              true,
              "Conexão com banco de dados foi perdida :" + error,
            ),
          );
        });
    };
  }
};

export const UpdateCompanyV2 = (
  inscricaoestadual,
  estadualmunicipal,
  site,
  emailcompany,
  cnpj,
  business,
  companyid,
  externalCode,
) => {
  if (!connection_platform.multitenancy) {
    return (dispatch) => {
      return axios
        .get(
          `${connection_platform.type_connect}://${pathname}:${port}/conn/updatecompany?companyid=` +
            companyid +
            `&inscricaoestadual=` +
            inscricaoestadual +
            `&estadualmunicipal=` +
            estadualmunicipal +
            `&site=` +
            site +
            `&emailcompany=` +
            emailcompany +
            `&cnpj=` +
            cnpj +
            `&business=` +
            business +
            `&codext=` +
            externalCode,
        )
        .then((response) => {
          return response.data;
        });
    };
  } else {
    let portMult = connection_platform.port_backend_intern;
    const auxPort = localStorage.getItem("port");

    if (auxPort) {
      portMult = auxPort;
    }

    return (dispatch) => {
      return axios
        .get(
          `${connection_platform.type_connect}://${pathname}:${portMult}/conn/updatecompany?companyid=` +
            companyid +
            `&inscricaoestadual=` +
            inscricaoestadual +
            `&estadualmunicipal=` +
            estadualmunicipal +
            `&site=` +
            site +
            `&emailcompany=` +
            emailcompany +
            `&cnpj=` +
            cnpj +
            `&business=` +
            business +
            `&codext=` +
            externalCode,
        )
        .then((response) => {
          return response.data;
        });
    };
  }
};

export const InsertCompanyV2 = (
  inscricaoestadual,
  estadualmunicipal,
  site,
  emailcompany,
  cnpj,
  business,
  iduser,
  codext,
) => {
  if (!connection_platform.multitenancy) {
    cnpj = cnpj.replace(/\D+/g, "");
    return (dispatch) => {
      return axios
        .get(
          `${connection_platform.type_connect}://${pathname}:${port}/conn/insertcompany?inscricaoestadual=` +
            inscricaoestadual +
            `&estadualmunicipal=` +
            estadualmunicipal +
            `&site=` +
            site +
            `&emailcompany=` +
            emailcompany +
            `&cnpj=` +
            cnpj +
            `&business=` +
            business +
            `&iduser=` +
            iduser +
            `&codext=` +
            codext,
        )
        .then((response) => {
          if (response.data) {
            dispatch(ShowModalsMenu("cadastro_company"));
          }
        });
    };
  } else {
    let portMult = connection_platform.port_backend_intern;
    const auxPort = localStorage.getItem("port");

    if (auxPort) {
      portMult = auxPort;
    }

    cnpj = cnpj.replace(/\D+/g, "");
    return (dispatch) => {
      return axios
        .get(
          `${connection_platform.type_connect}://${pathname}:${portMult}/conn/insertcompany?inscricaoestadual=` +
            inscricaoestadual +
            `&estadualmunicipal=` +
            estadualmunicipal +
            `&site=` +
            site +
            `&emailcompany=` +
            emailcompany +
            `&cnpj=` +
            cnpj +
            `&business=` +
            business +
            `&iduser=` +
            iduser +
            `&codext=` +
            codext,
        )
        .then((response) => {
          if (response.data) {
            dispatch(ShowModalsMenu("cadastro_company"));
          }
        });
    };
  }
};

/*
export const SearchCompanyV2 = (cnpj, empresa, setTotalOfRows) => {
  return (dispatch) => {
    return axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/getcompanys?cnpj=` +
          cnpj +
          `&empresa=` +
          empresa
      )
      .then((response) => {
        let total = 0;
        if (
          response.data &&
          Array.isArray(response.data) &&
          response.data.length
        ) {
          total = response.data.length;
        }
        setTotalOfRows(total);
        dispatch(getCompanys(response.data));
      });
  };
};
*/

export const SearchCompanyV2 = (
  cnpj,
  empresa,
  setTotalOfRows,
  codextemp = "",
) => {
  if (!connection_platform.multitenancy) {
    return (dispatch) => {
      return axios
        .get(
          `${connection_platform.type_connect}://${pathname}:${port}/conn/getcompanys?cnpj=` +
            cnpj +
            `&empresa=` +
            empresa +
            `&codextemp=` +
            codextemp,
        )
        .then((response) => {
          let total = 0;
          if (
            response.data &&
            Array.isArray(response.data) &&
            response.data.length
          ) {
            total = response.data.length;
          }

          return axios
            .get(
              `${
                connection_platform.type_connect
              }://${pathname}:${port}/conn/companys_v2?page=${1}&limit=${20}&title=${empresa}&cnpj=${cnpj}&codextemp=${codextemp}`,
            )
            .then((response2) => {
              setTotalOfRows(total);
              dispatch(getCompanys(response2.data));
            });
        });
    };
  } else {
    let portMult = connection_platform.port_backend_intern;
    const auxPort = localStorage.getItem("port");

    if (auxPort) {
      portMult = auxPort;
    }

    return (dispatch) => {
      return axios
        .get(
          `${connection_platform.type_connect}://${pathname}:${portMult}/conn/getcompanys?cnpj=` +
            cnpj +
            `&empresa=` +
            empresa +
            `&codextemp=` +
            codextemp,
        )
        .then((response) => {
          let total = 0;
          if (
            response.data &&
            Array.isArray(response.data) &&
            response.data.length
          ) {
            total = response.data.length;
          }

          return axios
            .get(
              `${
                connection_platform.type_connect
              }://${pathname}:${portMult}/conn/companys_v2?page=${1}&limit=${20}&title=${empresa}&cnpj=${cnpj}&codextemp=${codextemp}`,
            )
            .then((response2) => {
              setTotalOfRows(total);
              dispatch(getCompanys(response2.data));
            });
        });
    };
  }
};

export const UpdateSearchCompany = (
  cnpj,
  empresa,
  page = 1,
  codextemp = "",
) => {
  if (!connection_platform.multitenancy) {
    return (dispatch) => {
      return axios
        .get(
          `${
            connection_platform.type_connect
          }://${pathname}:${port}/conn/companys_v2?page=${page}&limit=${20}&title=${empresa}&cnpj=${cnpj}&codextemp=${codextemp}`,
        )
        .then((response) => {
          dispatch(getCompanys(response.data));
        });
    };
  } else {
    let portMult = connection_platform.port_backend_intern;
    const auxPort = localStorage.getItem("port");

    if (auxPort) {
      portMult = auxPort;
    }

    return (dispatch) => {
      return axios
        .get(
          `${
            connection_platform.type_connect
          }://${pathname}:${portMult}/conn/companys_v2?page=${page}&limit=${20}&title=${empresa}&cnpj=${cnpj}&codextemp=${codextemp}`,
        )
        .then((response) => {
          dispatch(getCompanys(response.data));
        });
    };
  }
};

// ######### Qualidade por Agente #####################

export async function getChannels() {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(`${apiBaseUrl}/conn/midias`);

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getCsatChannelCall(
  dateStart,
  dateEnd,
  channelId,
  avaliationId,
  source,
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/get-csat-midia-call?datestart=${dateStart}&dateend=${dateEnd}&idcanal=${channelId}&idavaliacao=${avaliationId}`,
      { cancelToken: source.token },
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
    return { status: 400, error };
  }
}

export async function getCsatDayChannelCall(
  dateStart,
  dateEnd,
  channelId,
  avaliationId,
  source,
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/get-csat-day-midia-call?datestart=${dateStart}&dateend=${dateEnd}&idcanal=${channelId}&idavaliacao=${avaliationId}`,
      { cancelToken: source.token },
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
    return { status: 400, error };
  }
}

export async function getCsatDayCall(channelId, avaliationId, source) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/get-csat-day-call?idcanal=${channelId}&idavaliacao=${avaliationId}`,
      { cancelToken: source.token },
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
    return { status: 400, error };
  }
}

export async function getCsatResultCall(channelId, avaliationId, source) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/get-csat-result-call?idcanal=${channelId}&idavaliacao=${avaliationId}`,
      { cancelToken: source.token },
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
    return { status: 400, error };
  }
}

export async function getNpsQuestCall(
  dateStart,
  dateEnd,
  channelId,
  avaliationId,
  type,
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/get-nps-quest-call?datestart=${dateStart}&dateend=${dateEnd}&idcanal=${channelId}&idavaliacao=${avaliationId}&type=${type}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getNpsResultCall(
  dateStart,
  dateEnd,
  channelId,
  avaliationId,
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/get-nps-result-call?datestart=${dateStart}&dateend=${dateEnd}&idcanal=${channelId}&idavaliacao=${avaliationId}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getSentSurveysCall(
  dateStart,
  dateEnd,
  channelId,
  avaliationId,
  source,
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/get-sent-surveys-call?datestart=${dateStart}&dateend=${dateEnd}&idcanal=${channelId}&idavaliacao=${avaliationId}`,
      { cancelToken: source.token },
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
    return { status: 400, error };
  }
}

export async function getSentSurveysMidiaCall(
  dateStart,
  dateEnd,
  channelId,
  avaliationId,
  source,
  setLoading,
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    setLoading(true);
    const response = await axios.get(
      `${apiBaseUrl}/conn/get-sent-surveys-midia-call?datestart=${dateStart}&dateend=${dateEnd}&idcanal=${channelId}&idavaliacao=${avaliationId}`,
      { cancelToken: source.token },
    );

    setLoading(false);
    return response;
  } catch (error) {
    if (axios.isCancel(error)) {
      console.log("cancelado pelo usuário: ", error);
    } else {
      console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
      setLoading(false);
    }
    return [];
  }
}

export async function getCompilationRateCall(
  dateStart,
  dateEnd,
  channelId,
  avaliationId,
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/get-compilation-rate-call?datestart=${dateStart}&dateend=${dateEnd}&idcanal=${channelId}&idavaliacao=${avaliationId}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getResearchHandledCall(
  dateStart,
  dateEnd,
  channelId,
  avaliationId,
  source,
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/get-research-handled-call?datestart=${dateStart}&dateend=${dateEnd}&idcanal=${channelId}&idavaliacao=${avaliationId}`,
      { cancelToken: source.token },
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
    return { status: 400, error };
  }
}

export async function getMoodMapCall(
  dateStart,
  dateEnd,
  channelId,
  avaliationId,
  source,
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/get-mood-map-call?datestart=${dateStart}&dateend=${dateEnd}&idcanal=${channelId}&idavaliacao=${avaliationId}`,
      { cancelToken: source.token },
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
    return { status: 400, error };
  }
}

export async function getNpsResultCallV2(
  dateStart,
  dateEnd,
  channelId,
  avaliationId,
  source,
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/get-nps-result-call?datestart=${dateStart}&dateend=${dateEnd}&idcanal=${channelId}&idavaliacao=${avaliationId}`,
      { cancelToken: source.token },
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
    return { status: 400, error };
  }
}

export async function getRankingGroupCall(
  dateStart,
  dateEnd,
  channelId,
  avaliationId,
  source,
  idsGroup,
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/get-ranking-group-call?datestart=${dateStart}&dateend=${dateEnd}&idcanal=${channelId}&idavaliacao=${avaliationId}&idgrupo=${idsGroup}`,
      { cancelToken: source.token },
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
    return { status: 400, error };
  }
}

export async function getRankingServiceCall(
  dateStart,
  dateEnd,
  channelId,
  avaliationId,
  source,
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/get-ranking-service-call?datestart=${dateStart}&dateend=${dateEnd}&idcanal=${channelId}&idavaliacao=${avaliationId}`,
      { cancelToken: source.token },
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
    return { status: 400, error };
  }
}

export async function getStatusReportCall() {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(`${apiBaseUrl}/conn/get-status-report`);
    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getQuickAnswerCall() {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(`${apiBaseUrl}/conn/get-quick-answers`);
    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function insertReportCall(data, statusSelected, textObservation) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/insert-report?serviceattendantid=${data.serviceattid}&cdrid=${data.cdrid}&id_status_report=${statusSelected}&observation=${textObservation}&user_insert=${data.userid}`,
    );
    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getEvaluationCall(data) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/get-evaluation?idcdr=${data.cdrid}`,
    );
    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getEvaluationCallV2(data) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/get-evaluation-call?idcdr=${data.cdrid}`,
    );
    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function insertEvaluationReviewCall(
  evaluation,
  data,
  userReducer,
  textObservation,
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/insert-evaluation-review?id_question=${evaluation.id_pergunta}&id_att_description=${data.serviceattid}&id_evaluation=${evaluation.id_avaliacao}&answer=${evaluation.valor}&idresposta=${evaluation.id_valor}&userinsert=${userReducer.id}&observation=${textObservation}`,
    );
    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function insertDealAttendanceCall(
  data,
  userReducer,
  changedProfile,
  changedPerfil,
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/insert-deal-attendance?idatendimento=${data.serviceattid}&user_response=${userReducer.id}&id_deal_status=2&cdrid=${data.cdrid}&changed_profile=${changedProfile}&changed_perfil=${changedPerfil}`,
    );
    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function updateDealAttendanceCall(
  data,
  userReducer,
  changedProfile,
  changedPerfil,
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/update-deal-attendance?idatendimento=${data.serviceattid}&user_response=${userReducer.id}&id_deal_status=2&cdrid=${data.cdrid}&changed_profile=${changedProfile}&changed_perfil=${changedPerfil}`,
    );
    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getEmailResponsibleCall() {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/get-email-responsible`,
    );
    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getReasonNonComplianceCall() {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/get-reason-non-compliance`,
    );
    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function insertNonComplianceCall(
  textObservation,
  data,
  reasonSelected,
  responsiblesSelected,
  dateCloser,
  userCloser,
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/insert-non-compliance?description=${textObservation}&idcdr=${data.cdrid}&id_reason_non_compliance=${reasonSelected.id}&user_insert=${data.userid}&id_email_responsible=${responsiblesSelected.id}&date_close=${dateCloser}&user_close=${userCloser}`,
    );
    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getDealCall(
  dateStart,
  dateEnd,
  channelId,
  avaliationId,
  source,
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/get-deal-call?datestart=${dateStart}&dateend=${dateEnd}&idcanal=${channelId}&idavaliacao=${avaliationId}`,
      { cancelToken: source.token },
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
    return { status: 400, error };
  }
}

export async function updateDealCall(
  dateStart,
  dateEnd,
  channelId,
  avaliationId,
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/get-deal-call?datestart=${dateStart}&dateend=${dateEnd}&idcanal=${channelId}&idavaliacao=${avaliationId}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
    return { status: 400, error };
  }
}

export async function updateTreatedDealCall(
  idatendimento,
  user_response,
  id_deal_status,
  cdrid,
  changed_profile,
  closed,
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/update-deal?idatendimento=${idatendimento}&user_response=${user_response}&id_deal_status=${id_deal_status}&cdrid=${cdrid}&changed_profile=${changed_profile}&closed=${closed}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
    return { status: 400, error };
  }
}

export async function insertDealCall(
  idatendimento,
  user_response,
  id_deal_status,
  cdrid,
  changed_profile,
  closed,
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/insert-deal?idatendimento=${idatendimento}&user_response=${user_response}&id_deal_status=${id_deal_status}&cdrid=${cdrid}&changed_profile=${changed_profile}&closed=${closed}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
    return { status: 400, error };
  }
}

export async function getDealStatusCall() {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(`${apiBaseUrl}/conn/get-deal-status`);

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getDealHistoricCall(phone) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;

  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/get-deal-historic?phone=${phone}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getCommentHistoricCall(serviceattendantid) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;

  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/get-evaluation-comment?serviceattendantid=${serviceattendantid}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function insertEvaluationCommentNpsCall(
  description,
  mimetypeid,
  user_insert,
  path,
  id_comment_parent,
  serviceattendantid,
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;

  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/insert-evaluation-comment-nps?description=${description}&mimetypeid=${mimetypeid}&user_insert=${user_insert}&path=${path}&id_comment_parent=${id_comment_parent}&serviceattendantid=${serviceattendantid}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function deleteEvaluationCall(idatendimento) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;

  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/delete-evaluation?idatendimento=${idatendimento}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getComparisonsNPSCall(
  yearStart,
  yearEnd,
  channelId,
  avaliationId,
  source,
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    let response = await axios.get(
      `${apiBaseUrl}/conn/get-nps-comparison-call?yearstart=${yearStart}&yearend=${yearEnd}&idcanal=${channelId}&idavaliacao=${avaliationId}`,
      { cancelToken: source.token },
    );
    return response;
  } catch (error) {
    console.log("getComparisonsNPSCall ERROR: ", error);
    return { status: 400, error };
  }
}

export async function getGradeAverageCall(
  yearStart,
  yearEnd,
  channelId,
  avaliationId,
  source,
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    let response = await axios.get(
      `${apiBaseUrl}/conn/get-average-nps-comparison-call?yearstart=${yearStart}&yearend=${yearEnd}&idcanal=${channelId}&idavaliacao=${avaliationId}`,
      { cancelToken: source.token },
    );
    return response;
  } catch (error) {
    console.log("getGradeAverageCall ERROR: ", error);
    return { status: 400, error };
  }
}

export async function getEngagementCall(
  yearStart,
  yearEnd,
  channelId,
  avaliationId,
  source,
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    let response = await axios.get(
      `${apiBaseUrl}/conn/get-nps-engagement-call?yearstart=${yearStart}&yearend=${yearEnd}&idcanal=${channelId}&idavaliacao=${avaliationId}`,
      { cancelToken: source.token },
    );
    return response;
  } catch (error) {
    console.log("getEngagementCall ERROR: ", error);
    return { status: 400, error };
  }
}

export async function getComparisonsProfileCall(
  yearStart,
  yearEnd,
  channelId,
  avaliationId,
  profile,
  source,
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;

  try {
    let response = await axios.get(
      `${apiBaseUrl}/conn/get-nps-profile-call?yearstart=${yearStart}&yearend=${yearEnd}&idcanal=${channelId}&idavaliacao=${avaliationId}&perfil=${profile}`,
      { cancelToken: source.token },
    );
    return response;
  } catch (error) {
    console.log("getComparisonsProfileCall ERROR: ", error);
    return { status: 400, error };
  }
}

export async function getSearchSendedCall(
  yearStart,
  yearEnd,
  channelId,
  avaliationId,
  source,
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    let response = await axios.get(
      `${apiBaseUrl}/conn/get-nps-profile-comparison-call?yearstart=${yearStart}&yearend=${yearEnd}&idcanal=${channelId}&idavaliacao=${avaliationId}`,
      { cancelToken: source.token },
    );
    return response;
  } catch (error) {
    console.log("getComparisonsNPS ERROR: ", error);
    return { status: 400, error };
  }
}

export async function getComparisonsNpsXServicesCall(
  yearStart,
  yearEnd,
  channelId,
  avaliationId,
  profile,
  source,
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    let response = await axios.get(
      `${apiBaseUrl}/conn/get-nps-procedure-comparison-call?yearstart=${yearStart}&yearend=${yearEnd}&idcanal=${channelId}&idavaliacao=${avaliationId}&perfil=${profile}`,
      { cancelToken: source.token },
    );
    return response;
  } catch (error) {
    console.log("getComparisonsNpsXServicesCall ERROR: ", error);
    return { status: 400, error };
  }
}

export async function indicatorsGeneralPdfCall(
  dateStart,
  dateEnd,
  channelId,
  avaliationId,
  source,
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/get-csat-subqual-answers-call?datestart=${dateStart}&dateend=${dateEnd}&idcanal=${channelId}&idavaliacao=${avaliationId}`,
      { cancelToken: source.token },
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
    return { status: 400, error };
  }
}

export async function getUnitGroupedCall(
  dateStart,
  dateEnd,
  channelId,
  avaliationId,
  source,
  idsGroup,
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/get-unity-group?datestart=${dateStart}&dateend=${dateEnd}&idcanal=${channelId}&idavaliacao=${avaliationId}&idgrupo=${idsGroup}`,
      { cancelToken: source.token },
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
    return { status: 400, error };
  }
}

export async function getUnitUserCall(
  dateStart,
  dateEnd,
  channelId,
  avaliationId,
  source,
  idsGroup,
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/get-unity-user?datestart=${dateStart}&dateend=${dateEnd}&idcanal=${channelId}&idavaliacao=${avaliationId}&idgrupo=${idsGroup}`,
      { cancelToken: source.token },
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
    return { status: 400, error };
  }
}

export async function getNpsResultCallV3(
  dateStart,
  dateEnd,
  channelId,
  avaliationId,
  type,
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/get-nps-result-call-v2?datestart=${dateStart}&dateend=${dateEnd}&idcanal=${channelId}&idavaliacao=${avaliationId}&type=${type}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getSentNpsCsatCall(
  dateStart,
  dateEnd,
  channelId,
  avaliationId,
  source,
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/get-sent-nps-csat-call?datestart=${dateStart}&dateend=${dateEnd}&idcanal=${channelId}&idavaliacao=${avaliationId}`,
      { cancelToken: source.token },
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
    return { status: 400, error };
  }
}

export async function getDealHistoricCallV2(phone) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;

  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/get-deal-historic-call?phone=${phone}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
    return { status: 400, error };
  }
}

export async function getAvaliations() {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(`${apiBaseUrl}/conn/get-list-evaluations`);

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
    return { status: 400, error };
  }
}

export async function getDealCallPagineted(
  dateStart,
  dateEnd,
  channelId,
  avaliationId,
  page,
  limit,
  filter,
  source,
  perfilNPS = "",
  idsGroup,
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/get-deal-call-v2?datestart=${dateStart}&dateend=${dateEnd}&idcanal=${channelId}&idavaliacao=${avaliationId}&page=${page}&limit=${limit}&filter=${filter}&perfil=${perfilNPS}&idgrupo=${idsGroup}`,
      { cancelToken: source.token },
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
    return { status: 400, error };
  }
}

export async function getDealCallCount(
  dateStart,
  dateEnd,
  channelId,
  avaliationId,
  filter,
  source,
  perfilNPS = "",
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/get-count-deal-call-v2?datestart=${dateStart}&dateend=${dateEnd}&idcanal=${channelId}&idavaliacao=${avaliationId}&filter=${filter}&perfil=${perfilNPS}`,
      { cancelToken: source.token },
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
    return { status: 400, error };
  }
}

export async function updateDealCallPagineted(
  dateStart,
  dateEnd,
  channelId,
  avaliationId,
  page,
  limit,
  filter,
  perfilNPS = "",
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/get-deal-call-v2?datestart=${dateStart}&dateend=${dateEnd}&idcanal=${channelId}&idavaliacao=${avaliationId}&page=${page}&limit=${limit}&filter=${filter}&perfil=${perfilNPS}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
    return { status: 400, error };
  }
}

export async function updateDealCallCount(
  dateStart,
  dateEnd,
  channelId,
  avaliationId,
  filter,
  perfilNPS = "",
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/get-count-deal-call-v2?datestart=${dateStart}&dateend=${dateEnd}&idcanal=${channelId}&idavaliacao=${avaliationId}&filter=${filter}&perfil=${perfilNPS}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
    return { status: 400, error };
  }
}

//SideContent

export async function listHelpSideContentStepOne(tipo = 1, apiBaseUrl) {
  //const apiBaseUrl = `${connection_platform.faqRoute}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/getcategoria-v2?tipo=${tipo}`,
    );

    return response;
  } catch (error) {
    console.log(
      "ERRO AO CARREGAR REQUISIÇÃO(listHelpSideContentStepOne):",
      error,
    );
  }
}

export async function listHelpSideContentStepTwo(
  idcategoria,
  tipo = 1,
  apiBaseUrl,
) {
  //const apiBaseUrl = `${connection_platform.faqRoute}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/getcategoriasecao-v2?idcategoria=${idcategoria}&tipo=${tipo}`,
    );

    return response;
  } catch (error) {
    console.log(
      "ERRO AO CARREGAR REQUISIÇÃO(listHelpSideContentStepOne):",
      error,
    );
  }
}

export async function listHelpSideContentStepThree(
  idsecao,
  tipo = 1,
  apiBaseUrl,
) {
  //const apiBaseUrl = `${connection_platform.faqRoute}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/getsecaoassunto-v2?idsecao=${idsecao}&tipo=${tipo}`,
    );

    return response;
  } catch (error) {
    console.log(
      "ERRO AO CARREGAR REQUISIÇÃO(listHelpSideContentStepOne):",
      error,
    );
  }
}

export async function listHelpSideContentStepFour(
  idassunto,
  tipo = 1,
  apiBaseUrl,
) {
  //const apiBaseUrl = `${connection_platform.faqRoute}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/conteudo-v2?idassunto=${idassunto}&tipo=${tipo}`,
    );

    return response;
  } catch (error) {
    console.log(
      "ERRO AO CARREGAR REQUISIÇÃO(listHelpSideContentStepOne):",
      error,
    );
  }
}

export async function uploadFileSideContent(data, ContactId, ipcurrent) {
  try {
    let filePathMidia = "";
    let filePath = ipcurrent.midias.filter(
      (idmidia) => parseInt(idmidia.id) === parseInt(ContactId.idmidia),
    );
    filePathMidia = filePath[0] ? filePath[0].recorder_file_path : "";
    const response = await axios.post(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/insertuploadv2?filepath=${filePathMidia}`,
      data,
    );
    return response;
  } catch (error) {
    console.log(error);
  }
}

export async function listHelpSideContentStepOneCampaign(
  tipo = 2,
  idgrupo,
  apiBaseUrl,
) {
  //const apiBaseUrl = `${connection_platform.faqRoute}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/getcategoria-v2?tipo=${tipo}&idgrupo=${idgrupo}`,
    );

    return response;
  } catch (error) {
    console.log(
      "ERRO AO CARREGAR REQUISIÇÃO(listHelpSideContentStepOne):",
      error,
    );
  }
}

export async function listHelpSideContentStepTwoCampaign(
  idcategoria,
  tipo = 2,
  idgrupo,
  apiBaseUrl,
) {
  //const apiBaseUrl = `${connection_platform.faqRoute}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/getcategoriasecao-v2?idcategoria=${idcategoria}&tipo=${tipo}&idgrupo=${idgrupo}`,
    );

    return response;
  } catch (error) {
    console.log(
      "ERRO AO CARREGAR REQUISIÇÃO(listHelpSideContentStepOne):",
      error,
    );
  }
}

export async function listHelpSideContentStepThreeCampaign(
  idsecao,
  tipo = 2,
  idgrupo,
  apiBaseUrl,
) {
  //const apiBaseUrl = `${connection_platform.faqRoute}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/getsecaoassunto-v2?idsecao=${idsecao}&tipo=${tipo}&idgrupo=${idgrupo}`,
    );

    return response;
  } catch (error) {
    console.log(
      "ERRO AO CARREGAR REQUISIÇÃO(listHelpSideContentStepOne):",
      error,
    );
  }
}

export async function listHelpSideContentStepFourCampaign(
  idassunto,
  tipo = 2,
  idgrupo,
  apiBaseUrl,
) {
  //const apiBaseUrl = `${connection_platform.faqRoute}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/conteudo-v2?idassunto=${idassunto}&tipo=${tipo}&idgrupo=${idgrupo}`,
    );

    return response;
  } catch (error) {
    console.log(
      "ERRO AO CARREGAR REQUISIÇÃO(listHelpSideContentStepOne):",
      error,
    );
  }
}

export async function getRankingGroupCallEnviadas(
  dateStart,
  dateEnd,
  idcanal,
  idavaliacao,
  idsGroup,
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/get-ranking-group-call-enviadas?datestart=${dateStart}&dateend=${dateEnd}&idcanal=${idcanal}&idavaliacao=${idavaliacao}&idgrupo=${idsGroup}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getRankingServiceCallEnviadas(
  dateStart,
  dateEnd,
  idcanal,
  idavaliacao,
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/get-ranking-service-call-enviadas?datestart=${dateStart}&dateend=${dateEnd}&idcanal=${idcanal}&idavaliacao=${idavaliacao}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getRankingGroupCallCsat(
  dateStart,
  dateEnd,
  idcanal,
  idavaliacao,
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/get-ranking-group-call-csat?datestart=${dateStart}&dateend=${dateEnd}&idcanal=${idcanal}&idavaliacao=${idavaliacao}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getRankingServiceCallCsat(
  dateStart,
  dateEnd,
  idcanal,
  idavaliacao,
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/get-ranking-service-call-csat?datestart=${dateStart}&dateend=${dateEnd}&idcanal=${idcanal}&idavaliacao=${idavaliacao}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export async function getViewTypeEvaluation(source) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/get-view-type-evaluation`,
      { cancelToken: source.token },
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
    return { status: 400, error };
  }
}

export async function getDealCallCountCSAT(
  dateStart,
  dateEnd,
  channelId,
  avaliationId,
  filter,
  source,
  perfilCSAT,
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/get-count-deal-call-csat?datestart=${dateStart}&dateend=${dateEnd}&idcanal=${channelId}&idavaliacao=${avaliationId}&filter=${filter}&idconceito=${perfilCSAT}`,
      { cancelToken: source.token },
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
    return { status: 400, error };
  }
}

export async function getDealCallPaginetedCSAT(
  dateStart,
  dateEnd,
  channelId,
  avaliationId,
  page,
  limit,
  filter,
  source,
  perfilCSAT,
  idsGroup,
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/get-deal-call-csat?datestart=${dateStart}&dateend=${dateEnd}&idcanal=${channelId}&idavaliacao=${avaliationId}&page=${page}&limit=${limit}&filter=${filter}&idconceito=${perfilCSAT}&idgrupo=${idsGroup}`,
      { cancelToken: source.token },
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
    return { status: 400, error };
  }
}

export async function updateDealCallCountCSAT(
  dateStart,
  dateEnd,
  channelId,
  avaliationId,
  filter,
  filterCSAT,
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/get-count-deal-call-csat?datestart=${dateStart}&dateend=${dateEnd}&idcanal=${channelId}&idavaliacao=${avaliationId}&filter=${filter}&idconceito=${filterCSAT}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
    return { status: 400, error };
  }
}

export async function updateDealCallPaginetedCSAT(
  dateStart,
  dateEnd,
  channelId,
  avaliationId,
  page,
  limit,
  filter,
  filterCSAT,
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/get-deal-call-csat?datestart=${dateStart}&dateend=${dateEnd}&idcanal=${channelId}&idavaliacao=${avaliationId}&page=${page}&limit=${limit}&filter=${filter}&idconceito=${filterCSAT}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
    return { status: 400, error };
  }
}

export async function getFilterConceptCsat() {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/get-filter-concept-csat`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
    return { status: 400, error };
  }
}

export async function insertEvaluationReviewCallV2(
  evaluation,
  data,
  userReducer,
  textObservation,
) {
  const apiBaseUrl = `${connection_platform.type_connect}://${pathname}:${port}`;
  try {
    const response = await axios.get(
      `${apiBaseUrl}/conn/insert-evaluation-review-v2?id_question=${evaluation.id_pergunta}&id_att_description=${data.serviceattid}&id_evaluation=${evaluation.id_avaliacao}&answer=${evaluation.valor}&idresposta=${evaluation.id_valor}&userinsert=${userReducer.id}&observation=${textObservation}&scopenew=${evaluation.scopenew}&scopeold=${evaluation.scopeold}&answerold=${evaluation.answerold}`,
    );
    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
  }
}

export const editDetailsCsat = (
  numero_cliente,
  conceito,
  nota_csat,
  cor_conceito,
) => ({
  type: types.EDIT_CALL_CENTER_CSAT,
  numero_cliente,
  conceito,
  nota_csat,
  cor_conceito,
});

export async function getCampaignsActiveV2(
  datestart,
  dateend,
  idcanal,
  idcampanha,
  filter,
  limit,
  page,
) {
  try {
    const response = await axios.get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/get-campaign-active-v2?datestart=${datestart}&dateend=${dateend}&idcanal=${idcanal}&idcampanha=${idcampanha}&filter=${filter}&limit=${limit}&page=${page}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
    return { status: 400, error };
  }
}

export async function getCampaignActiveCount(
  datestart,
  dateend,
  idcanal,
  idcampanha,
  filter,
) {
  try {
    const response = await axios.get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/get-campaign-active-count?datestart=${datestart}&dateend=${dateend}&idcanal=${idcanal}&idcampanha=${idcampanha}&filter=${filter}`,
    );

    return response;
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
    return { status: 400, error };
  }
}

export const updateContactOnEditV2 = async (
  contactid,
  displayname,
  name,
  email,
  cpf,
  rg,
  codigoexterno,
  nascimento,
  endereco,
  numero,
  district,
  cepassociationid,
  numberdel,
  particular,
  contatode,
  editAtendimento,
  detailscontact,
  idrelacao = "",
  idcargo = "",
) => {
  try {
    const response = await axios.get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/updatecontactv2?contactid=` +
        contactid +
        `&displayname=` +
        codeBase64Convert(displayname) +
        `&name=` +
        codeBase64Convert(name) +
        `&email=` +
        email +
        `&cpf=` +
        cpf +
        `&rg=` +
        rg +
        `&codigoexterno=` +
        codigoexterno +
        `&nascimento=` +
        nascimento +
        `&district=` +
        district +
        `&endereco=` +
        endereco +
        `&numero=` +
        numero +
        `&cepassociationid=` +
        cepassociationid +
        `&particular=` +
        particular +
        `&contatode=` +
        contatode +
        `&idrelacao=` +
        idrelacao +
        `&idcargo=` +
        idcargo,
    );

    if (!!response && response.data) {
      if (editAtendimento) {
      }

      return response.data;
    }

    return { status: 400, error: "no data" };
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
    return { status: 400, error };
  }
};

export const updateContactOnEdit = async (
  contactid,
  displayname,
  name,
  email,
  cpf,
  rg,
  codigoexterno,
  nascimento,
  endereco,
  numero,
  district,
  cepassociationid,
  numberdel,
  particular,
  contatode,
  editAtendimento,
  detailscontact,
) => {
  try {
    const response = await axios.get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/updatecontact?contactid=` +
        contactid +
        `&displayname=` +
        displayname +
        `&name=` +
        name +
        `&email=` +
        email +
        `&cpf=` +
        cpf +
        `&rg=` +
        rg +
        `&codigoexterno=` +
        codigoexterno +
        `&nascimento=` +
        nascimento +
        `&district=` +
        district +
        `&endereco=` +
        endereco +
        `&numero=` +
        numero +
        `&cepassociationid=` +
        cepassociationid +
        `&particular=` +
        particular +
        `&contatode=` +
        contatode,
    );

    if (!!response && response.data) {
      if (editAtendimento) {
      }

      return response.data;
    }

    return { status: 400, error: "no data" };
  } catch (error) {
    console.log("ERRO AO CARREGAR REQUISIÇÃO:", error);
    return { status: 400, error };
  }
};

export const deleteNumberContactOnEdit = async (
  numberdel,
  informationusers,
) => {
  try {
    let iduser = informationusers.id;
    for (let number of numberdel) {
      await axios.get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/deletenumber?idphone=` +
          number +
          `&iduser=` +
          iduser,
      );
    }
  } catch (error) {
    console.log(error);
  }
};

export const updateContactNumberOnEdit = async (
  numberscontact,
  iduser,
  contactid,
) => {
  let error = [];
  await Promise.all(
    numberscontact.map(async (number) => {
      if (number.type === 0) {
        try {
          const response = await axios.get(
            `${connection_platform.type_connect}://${pathname}:${port}/conn/phonexist?contactid=${contactid}&number=${number.number}`,
          );

          if (response.data.length === 0) {
            await axios.get(
              `${connection_platform.type_connect}://${pathname}:${port}/conn/updatephonev2?idphone=${number.idphone}&phonetypeid=${number.phonetypeid}&number=${number.number}&midiaid=${number.midiaid}`,
            );
          } else {
            //dispatch(ErrorNumberExist(number.number));
            error.push({ number: number.number });
          }
        } catch (error) {
          console.error("Erro na atualização de telefone:", error);
        }
      } else {
        if (number.number !== "") {
          try {
            const response = await axios.get(
              `${connection_platform.type_connect}://${pathname}:${port}/conn/phonexist?contactid=${contactid}&number=${number.number}`,
            );

            if (response.data.length === 0) {
              const insertResponse = await axios.get(
                `${connection_platform.type_connect}://${pathname}:${port}/conn/insertphonev2?phonetypeid=${number.phonetypeid}&number=${number.number}&iduser=${iduser}&midiaid=${number.midiaid}`,
              );

              if (insertResponse.data !== "") {
                const data = insertResponse.data;
                await axios.get(
                  `${connection_platform.type_connect}://${pathname}:${port}/conn/insertcontactphone?contactid=${contactid}&phoneid=${data[0].id}`,
                );
              }
            } else {
              //dispatch(ErrorNumberExist(number.number));
              error.push({ number: number.number });
            }
          } catch (error) {
            console.error("Erro na inserção de telefone:", error);
          }
        }
      }
    }),
  );

  return error;
};

export async function testConnectionWhenInSecondPlan() {
  await axios.get(
    `${connection_platform.type_connect}://${pathname}:${port}/conn/testconection`,
  );
}

export const UpdateByeAttendantQuarentine = (idatendimento) => {
  return axios
    .get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/updatebyeattstandby?idatendimento=${idatendimento}`,
    )
    .then((response) => {
      if (response[0] !== undefined) {
        return response.data[1].rows[0].datestart;
      } else {
        return Moment().format("YYYY-MM-DDT23:59:00");
      }
    });
};

export const addListQuarentineCallQueue = (
  standbyId,
  cdrId,
  idAtendimento,
  contactName,
  scoreValue,
  scoreClass,
  dateTime,
  phoneNumber,
  midiaId,
  contactId,
  unreadMessages,
) => ({
  type: types.ADD_QUARENTINE_QUEUE,
  standbyId,
  cdrId,
  idAtendimento,
  contactName,
  scoreValue,
  scoreClass,
  dateTime,
  phoneNumber,
  midiaId,
  contactId,
  unreadMessages,
});

export const addCcontactIdsToQuarentine = (contactId) => ({
  type: types.ADD_CONTACTIDS_TO_QUARENTINE,
  contactId,
});

export const removeContactIdsToQuarentine = (contactId) => ({
  type: types.REMOVE_CONTACTIDS_TO_QUARENTINE,
  contactId,
});
export const removeItemFromListQuarentineCallQueue = (
  standbyId,
  cdrId,
  idAtendimento,
) => ({
  type: types.REMOVE_QUARENTINE_QUEUE,
  standbyId,
  cdrId,
  idAtendimento,
});
export const removeItemFromListQuarentineCallQueueWithCdr = (cdrId) => ({
  type: types.REMOVE_QUARENTINE_QUEUE_WITH_CDR,
  cdrId,
});

export const editNumberOfUnreadedMessages = (cdrId, unreadMessages) => ({
  type: types.EDIT_NUMBER_OF_UNREAD_MESSAGES_OF_QUARENTINE_QUEUE,
  cdrId,
  unreadMessages,
});

export const addOneMoreUnreadedMessage = (cdrId) => ({
  type: types.ADD_ONE_MORE_UNREADED_MESSAGE_OF_QUARENTINE_QUEUE,
  cdrId,
});

export const addOneMoreUnreadedMessageInQueue = (cdrid) => ({
  type: types.ADD_ONE_MORE_UNREAD_MESSAGES_QUEUE,
  cdrid,
});

export const editInitialDateFilterQuarentine = (initial) => ({
  type: types.EDIT_INITIAL_DATE_FILTER_QUARENTINE,
  initial,
});

export const editFinalDateFilterQuarentine = (final) => ({
  type: types.EDIT_FINAL_DATE_FILTER_QUARENTINE,
  final,
});

export const changeNextCallQueueTab = (isActive) => ({
  type: types.CHANGE_NEXT_CALL_QUEUE_TAB,
  isActive,
});

export const changeWaitingCallQueueTab = (isActive) => ({
  type: types.CHANGE_WAITING_CALL_QUEUE_TAB,
  isActive,
});

export const changeChatCallQueueTab = (isActive) => ({
  type: types.CHANGE_CHAT_CALL_QUEUE_TAB,
  isActive,
});

export const ClearAtdSimult = () => {
  console.log("INGENIUM_INITIALLOGIN");
  return { type: types.CLEAR_ATD_SIMULT_ALL };
};

export const ClearAtd = () => {
  console.log("INGENIUM_INITIALLOGIN");
  return { type: types.CLEAR_ATD_ALL };
};

export const ClearQuarentine = () => {
  console.log("INGENIUM_INITIALLOGIN");
  return { type: types.CLEAR_QUARENTINE_ALL };
};

export const setIsReconnectModalActive = (status) => ({
  type: types.CHANGE_RECONNECT_MODAL_STATUS,
  status,
});

export const changeNumberOfUnreadedMessagesOfAnItem = (cdrId, qtd) => ({
  type: types.CHANGE_NUMBER_OF_UNREADED_MESSAGES_OF_AN_ITEM,
  cdrId,
  qtd,
});

export const getNumberOfUnreadedMessages = async (cdrId) => {
  try {
    const response = await axios.get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/carregamento-reading?cdr=${cdrId}`,
    );
    return response;
  } catch (error) {
    console.log("getNumberOfUnreadedMessages ERROR: ", error);
  }
};

export const ClearMessageALL = () => {
  console.log("INGENIUM_INITIALLOGIN");
  return { type: types.CLEAR_MESSAGE_ALL };
};

export const editQtdMsgMonitoring = (cdr) => ({
  type: types.EDIT_QTD_MSG_MONITORING,
  cdr,
});

export const editTotalQtdMsgMonitoring = (cdr, qtdmessage) => ({
  type: types.EDIT_TOTAL_QTD_MSG_MONITORING,
  cdr,
  qtdmessage,
});

export const clearQtdMsgMonitoring = (cdr) => ({
  type: types.CLEAR_QTD_MSG_MONITORING,
  cdr,
});

export const editIsFromStandbyMonitoring = (cdr, isFromStandby) => ({
  type: types.EDIT_IS_FROM_STANDBY_MONITORING,
  cdr,
  isFromStandby,
});

export const addTmnoreplyPerAgent = (data) => ({
  type: types.ADD_TMNOREPLY_PER_AGENT,
  data,
});

export async function getCompanyInfo(id) {
  if (!connection_platform.multitenancy) {
    try {
      const response = await axios.get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/companys_byID?id=${id}`,
      );
      return response.data;
    } catch (error) {
      console.log("getCompanysPaginated ERROR: ", error);
    }
  } else {
    let portMult = connection_platform.port_backend_intern;
    const auxPort = localStorage.getItem("port");

    if (auxPort) {
      portMult = auxPort;
    }

    try {
      const response = await axios.get(
        `${connection_platform.type_connect}://${pathname}:${portMult}/conn/companys_byID?id=${id}`,
      );
      return response.data;
    } catch (error) {
      console.log("getCompanysPaginated ERROR: ", error);
    }
  }
}

export const clearGetCEP = () => ({
  type: types.CLEAR_GETCEP,
});

export const addEnterpriseAdditionalInfos = (
  cdr,
  enterpriseAdditionalInfos,
) => ({
  type: types.ADD_ENTERPRISE_ADDITIONAL_INFOS,
  cdr,
  enterpriseAdditionalInfos,
});
export const addContactAdditionalInfos = (cdr, contactAdditionalInfos) => ({
  type: types.ADD_CONTACT_ADDITIONAL_INFOS,
  cdr,
  contactAdditionalInfos,
});

export const AddMessagesInBatch = (cdr, messages) => ({
  type: types.ADD_MESSAGES_IN_BATCH,
  cdr,
  messages,
});

export const ChangeLastCdrClicked = (cdr, lastCdrClicked) => ({
  type: types.CHANGE_LAST_CDR_CLICKED,
  cdr,
  lastCdrClicked,
});

export const AddMessagesInBatchReverseMode = (cdr, messages) => ({
  type: types.ADD_MESSAGES_IN_BATCH_REVERSE_MODE,
  cdr,
  messages,
});

export const fetchPreviousMessages = async (number, mediaId) => {
  try {
    const data = {
      number: number,
      idmidia: mediaId,
    };
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const response = await axios.post(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/interactionbycdr`,
      data,
      config,
    );
    return response;
  } catch (error) {
    console.log("fetchPreviousMessages ERROR: ", error);
  }
};

// export const RemoveAtd = (idatendimento) => {
//   previusMessagesService.removeLoadedCdrsByCdr(idatendimento);
//   return {
//     type: types.ATD_DEL,
//     idatendimento: idatendimento,
//   };
// };

export const changeSelectedChatMonitoring = (chatInfos) => ({
  type: types.CHANGE_SELECTED_CHAT_MONITORING,
  chatInfos,
});

const getInformationOfAtdSimult = (atdsimult, numberscontact) => {
  let informations = {
    idatendimento: null,
    menubot: null,
    cliente: null,
    nomesubservico: null,
  };
  const hasAtdsimult = Array.isArray(atdsimult) && atdsimult.length > 0;
  if (!hasAtdsimult) return informations;
  atdsimult.forEach((atd) => {
    const findNumber = numberscontact.find((number) =>
      number.number.includes(atd.telefone),
    );

    if (findNumber) {
      informations.idatendimento = atd.idatendimento;
      informations.menubot = atd.menubot;
      informations.cliente = atd.cliente;
      informations.nomesubservico = atd.nomesubservico;
    }
  });

  return informations;
};

const editEnterpriseInformation = (
  enterpriseAdditionalInfos,
  newInfosToMenuBot,
) => {
  const newEnterpriseAdditionalInfos = enterpriseAdditionalInfos.map(
    (enterpriseAditionalInfo) => {
      if (enterpriseAditionalInfo.startsWith("Empresa na Agenda:")) {
        return newInfosToMenuBot.empresaNaAgenda
          ? `Empresa na Agenda: ${newInfosToMenuBot.empresaNaAgenda}`
          : "";
      }
      if (enterpriseAditionalInfo.startsWith("CNPJ:")) {
        return newInfosToMenuBot.cnpjEmpresa
          ? `CNPJ: ${newInfosToMenuBot.cnpjEmpresa}`
          : "";
      }
      if (enterpriseAditionalInfo.startsWith("Código Externo:")) {
        return newInfosToMenuBot.codigoEmpresa
          ? `Código Externo: ${newInfosToMenuBot.codigoEmpresa}`
          : "";
      }

      return enterpriseAditionalInfo;
    },
  );
  const filteredNewEnterpriseAdditionalInfos =
    newEnterpriseAdditionalInfos.filter((enterpriseAdditionalInfo) =>
      Boolean(enterpriseAdditionalInfo),
    );
  const isToAddEnterprise =
    Boolean(newInfosToMenuBot.empresaNaAgenda) &&
    !filteredNewEnterpriseAdditionalInfos.some((enterpriseAdditionalInfo) =>
      enterpriseAdditionalInfo.startsWith("Empresa na Agenda:"),
    );
  if (isToAddEnterprise) {
    filteredNewEnterpriseAdditionalInfos.push(
      `Empresa na Agenda: ${newInfosToMenuBot.empresaNaAgenda}`,
    );
  }
  const isToAddCnpj =
    Boolean(newInfosToMenuBot.cnpjEmpresa) &&
    !filteredNewEnterpriseAdditionalInfos.some((enterpriseAdditionalInfo) =>
      enterpriseAdditionalInfo.startsWith("CNPJ:"),
    );
  if (isToAddCnpj) {
    filteredNewEnterpriseAdditionalInfos.push(
      `CNPJ: ${newInfosToMenuBot.cnpjEmpresa}`,
    );
  }
  const isToAddExternalCode =
    Boolean(newInfosToMenuBot.codigoEmpresa) &&
    !filteredNewEnterpriseAdditionalInfos.some((enterpriseAdditionalInfo) =>
      enterpriseAdditionalInfo.startsWith("Código Externo:"),
    );
  if (isToAddExternalCode) {
    filteredNewEnterpriseAdditionalInfos.push(
      `Código Externo: ${newInfosToMenuBot.codigoEmpresa}`,
    );
  }

  return filteredNewEnterpriseAdditionalInfos;
};

const editContactInformation = (contactAdditionalInfos, newInfosToMenuBot) => {
  const newContactAdditionalInfos = contactAdditionalInfos.map(
    (contactAdditionalInfo) => {
      if (contactAdditionalInfo.startsWith("Código Externo:")) {
        return newInfosToMenuBot.codigoContato
          ? `Código Externo: ${newInfosToMenuBot.codigoContato}`
          : "";
      }

      return contactAdditionalInfo;
    },
  );

  const filteredNewContactAdditionalInfos = newContactAdditionalInfos.filter(
    (contactAdditionalInfo) => Boolean(contactAdditionalInfo),
  );
  const isToAddExternalCode =
    Boolean(newInfosToMenuBot.codigoContato) &&
    !filteredNewContactAdditionalInfos.some((contactAdditionalInfo) =>
      contactAdditionalInfo.startsWith("Código Externo:"),
    );
  if (isToAddExternalCode) {
    filteredNewContactAdditionalInfos.push(
      `Código Externo: ${newInfosToMenuBot.codigoContato}`,
    );
  }

  return filteredNewContactAdditionalInfos;
};

export const editMenuBotAndAditionalInformationOfContactAndEnterprise = (
  numberscontact,
  newInfosToMenuBot,
) => {
  return (dispatch, getState) => {
    try {
      const { atdsimult } = getState();
      const { idatendimento, menubot, cliente, nomesubservico } =
        getInformationOfAtdSimult(atdsimult, numberscontact);
      let newMenuBot = cloneDeep(menubot);
      if (idatendimento === null) return;
      if (newMenuBot === "" || newMenuBot === null) {
        newMenuBot = `Nome na Agenda: ${newInfosToMenuBot.nomeNaAgenda}~¿`;
      } else if (typeof newMenuBot === "string") {
        const MenuBot = newMenuBot.split("~¿");
        const NewMenuBot = Array.isArray(MenuBot)
          ? MenuBot.map((info) => {
              if (info.startsWith("Nome na Agenda:")) {
                return newInfosToMenuBot.nomeNaAgenda
                  ? `Nome na Agenda: ${newInfosToMenuBot.nomeNaAgenda}`
                  : "";
              } else {
                return info;
              }
            })
          : [];
        const filteredNewMenuBot = NewMenuBot.filter((info) => Boolean(info));
        const isToAddName =
          Boolean(newInfosToMenuBot.nomeNaAgenda) &&
          !filteredNewMenuBot.some((info) =>
            info.startsWith("Nome na Agenda:"),
          );
        if (isToAddName) {
          filteredNewMenuBot.push(
            `Nome na Agenda: ${newInfosToMenuBot.nomeNaAgenda}`,
          );
        }

        newMenuBot = filteredNewMenuBot.join("~¿");
      }
      dispatch(EditInfoCli(idatendimento, cliente, newMenuBot, nomesubservico));

      //Pegando informações do atendimento
      const atd = atdsimult.find(
        (atd) => parseInt(idatendimento) === parseInt(atd.idatendimento),
      );
      if (!Boolean(atd)) return;

      //Editando informações da empresa
      const enterpriseAdditionalInfosRaw = atd.enterpriseAdditionalInfos;
      const hasEnterpriseAdditionalInfos = Array.isArray(
        enterpriseAdditionalInfosRaw,
      );
      const enterpriseAdditionalInfos = hasEnterpriseAdditionalInfos
        ? enterpriseAdditionalInfosRaw
        : [];
      const filteredNewEnterpriseAdditionalInfos = editEnterpriseInformation(
        enterpriseAdditionalInfos,
        newInfosToMenuBot,
      );
      dispatch(
        addEnterpriseAdditionalInfos(
          idatendimento,
          filteredNewEnterpriseAdditionalInfos,
        ),
      );

      //Editando informações do contato
      const contactAdditionalInfosRaw = atd.contactAdditionalInfos;
      const hasContactAdditionalInfos = Array.isArray(
        contactAdditionalInfosRaw,
      );
      const contactAdditionalInfos = hasContactAdditionalInfos
        ? contactAdditionalInfosRaw
        : [];

      const filteredNewContactAdditionalInfos = editContactInformation(
        contactAdditionalInfos,
        newInfosToMenuBot,
      );
      dispatch(
        addContactAdditionalInfos(
          idatendimento,
          filteredNewContactAdditionalInfos,
        ),
      );
    } catch (error) {
      console.log(
        "editMenuBotAndAditionalInformationOfContactAndEnterprise ERROR: ",
        error,
      );
    }
  };
};

export const fetchInfomailById = async (id) => {
  try {
    const response = await axios.get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/list-infomail-byid?id=${id}`,
    );
    return response;
  } catch (error) {
    console.log("fetchInfomailById ERROR: ", error);
  }
};

export const setIsOpenFaqDragable = (status) => ({
  type: types.CHANGE_IS_OPEN_FAQ_DRAGABLE,
  status,
});

// export const addAtendimentoEfective = (
//   idatendimento,
//   cliente,
//   telefone,
//   servico,
//   datatimeatd,
//   criticidade,
//   menubot,
//   subservico,
//   serviceatd,
//   recuperation,
//   recuperationtime,
//   direction,
//   idmidia,
//   timecomplete,
//   statusagent,
//   line,
//   queueid,
//   serverid,
//   qtdmessage,
//   pathfile,
//   mcdu,
//   nomesubservico,
//   infoinitcall,
//   nomecliente,
//   protocolo,
//   idsubservico,
//   acw,
//   isDialNc2,
//   arrayChannels,
//   caseId,
//   statusatd,
//   score_class,
//   score_value,
//   nps_call,
//   isTabulation,
//   enterpriseAdditionalInfos,
//   contactAdditionalInfos,
//   lastCdrClicked
// ) => ({
//   type: types.ADD_ATENDIMENTO,
//   id: nextAttId++,
//   idatendimento: idatendimento,
//   cliente: cliente,
//   telefone: telefone,
//   servico: servico,
//   datatimeatd: datatimeatd,
//   criticidade: criticidade,
//   menubot,
//   subservico,
//   serviceatd,
//   recuperation,
//   recuperationtime: recuperationtime,
//   respatendente: false,
//   respclient: false,
//   direction: direction,
//   idmidia: idmidia,
//   timecomplete: timecomplete,
//   statusagent: statusagent,
//   line: line,
//   queueid: queueid,
//   serverid: serverid,
//   qtdmessage: qtdmessage,
//   pathfile: pathfile,
//   mcdu: mcdu,
//   nomesubservico: nomesubservico,
//   infoinitcall: infoinitcall,
//   nomecliente: nomecliente,
//   protocolo: protocolo,
//   idsubservico,
//   acw,
//   isDialNc2,
//   arrayChannels,
//   caseId,
//   statusatd,
//   score_class,
//   score_value,
//   nps_call,
//   isTabulation,
//   enterpriseAdditionalInfos,
//   contactAdditionalInfos,
//   lastCdrClicked,
// });

export const getMessagesToVerifyIfActivationIsCompleted = async (
  cdr,
  informationusers,
) => {
  try {
    const response = await axios.get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/carregamento-new?cdr=${cdr}&idgroup=${informationusers.idgroup}&supervisor=${informationusers.supervisor}`,
    );
    const hasResponse = Boolean(response);
    if (!hasResponse) return [];
    const hasData = Array.isArray(response.data);
    if (!hasData) return [];
    return response.data;
  } catch (error) {
    return [];
  }
};

function ReturningCallbackIn(
  queueid,
  inforetorno,
  recvcount,
  cdrid,
  mediaid,
  srvin,
  caller,
  called,
  cbackcount,
  status,
) {
  return (dispatch, getState) => {
    dispatch(
      ReturningCallback(
        queueid,
        inforetorno,
        recvcount,
        cdrid,
        mediaid,
        srvin,
        caller,
        called,
      ),
    );
    if (status != "2") {
      dispatch(
        returnListCallQueue("", queueid, "2", parseInt(cbackcount + 1), "você"),
      );
    }
  };
}

export function SolicitarChamadaAtiva(mediaid, destination) {
  return (dispatch, getState) => {
    try {
      const {
        atendimento: ContactId,
        routergroups: permrouter,
        outservices: outband,
        informationusers: infouser,
        listcallqueue: queue,
        ipcurrent,
        status: statusAgent,
      } = getState();

      if (ContactId.length !== 0) {
        localStorage.setItem("current-service", ContactId.idatendimento);
      }

      if (!statusAgent.allowCall) {
        dispatch(InterationNotifier("Pausa não permite ativo", "permission"));
        return true;
      }

      if (!permrouter || permrouter.length === 0) return;

      let chamado = destination;
      const rawNumber = chamado;
      let tipochamada = 0;
      let DDD = permrouter[0].areacodeid || "71";

      const valorfixo = [1, 2, 3, 4],
        valormovel = [5, 6, 7, 8, 9];
      const removeDigits =
        connection_platform.remove_digits || parseInt(mediaid) !== 1;

      if (
        removeDigits &&
        chamado.startsWith("0") &&
        !chamado.startsWith("00") &&
        !chamado.startsWith("0800")
      ) {
        chamado = chamado.substring(1);
      }

      function definirTipoChamada(mediaid, tipo) {
        const tipos = {
          fixoInterurbano: [3, 17, 19, 18, 20, 21, 23, 22, 24, 25],
          movelInterurbano: [4, 17, 19, 18, 20, 21, 23, 22, 13, 24, 25],
          fixoLocal: [1, 17, 19, 18, 20, 21, 23, 22, 24, 25],
          movelLocal: [2, 17, 19, 18, 20, 21, 23, 22, 13, 24, 25],
        };

        // Converte mediaid para inteiro
        const midiaConvertida = parseInt(mediaid, 10);

        // Se mediaid for 1, busca no objeto `tipos`, senão segue a lógica específica
        if (midiaConvertida === 1) {
          return tipos[tipo] ? tipos[tipo][midiaConvertida - 1] || 0 : 0;
        } else {
          const mapeamentoMidia = {
            2: 24,
            3: 22,
            4: 18,
            5: 17,
            6: 20,
            8: 19,
            9: 21,
            10: 23,
            12: 13,
            15: 26,
          };

          return mapeamentoMidia[midiaConvertida] || midiaConvertida;
        }
      }

      if (
        (chamado.length >= 10 ||
          chamado.length === 8 ||
          chamado.length === 9) &&
        !chamado.startsWith("00")
      ) {
        if (
          chamado.startsWith("55") &&
          (mediaid === 5 || mediaid === "5") &&
          chamado.length > 11
        )
          chamado = chamado.substr(2);
        if (chamado.length === 8 || chamado.length === 9)
          chamado = DDD + chamado;
      }

      let chamadoValidado = chamado.replace(/^0(?!0|800|300)/, "");
      console.log("INGENIUM_ACTVECALL_0 : ", chamado);

      let dddValidado =
        chamadoValidado.length >= 10 ? chamadoValidado.substr(0, 2) : "";

      console.log("INGENIUM_ACTVECALL_0 : ", chamadoValidado);

      if (
        chamadoValidado.length >= 10 &&
        !chamadoValidado.startsWith("00") &&
        !chamadoValidado.startsWith("0800")
      ) {
        if (valorfixo.includes(parseInt(chamadoValidado[2]))) {
          tipochamada = definirTipoChamada(
            mediaid,
            dddValidado && parseInt(dddValidado) !== parseInt(DDD)
              ? "fixoInterurbano"
              : "fixoLocal",
          );
        } else if (valormovel.includes(parseInt(chamadoValidado[2]))) {
          tipochamada = definirTipoChamada(
            mediaid,
            dddValidado && parseInt(dddValidado) !== parseInt(DDD)
              ? "movelInterurbano"
              : "movelLocal",
          );
        }
      } else if (chamadoValidado.startsWith("0800")) {
        tipochamada = 8;
      } else if (chamadoValidado.startsWith("00")) {
        tipochamada = 5;
      } else {
      }

      console.log("INGENIUM_ACTVECALL_1 : ", tipochamada);

      // function buscarRota() {
      //     let rota = null;

      //     console.log("INGENIUM_ACTVECALL_1 : ",permrouter)

      //     permrouter.forEach(result => {

      //         if (result.calltypeid === tipochamada && parseInt(result.idmidia) === parseInt(mediaid)) {
      //             rota = result;
      //         }
      //     });
      //     return rota;
      // }

      function buscarRota() {
        let rota = [];

        console.log("INGENIUM_ACTVECALL_1 : ", permrouter);

        const doisPrimeirosDigitos = chamadoValidado.substring(0, 2);

        // Só verifica `areacode` se `mediaid` for 1
        const verificarAreacode = parseInt(mediaid) === 1;
        const verificarWhatsappInternacional = parseInt(mediaid) === 5;

        // Verifica se existe pelo menos um item com areacode correspondente (somente se `mediaid` for 1)
        const existeAreaCode = verificarAreacode
          ? permrouter.some(
              (result) =>
                result.areacode &&
                String(result.areacode).startsWith(doisPrimeirosDigitos),
            )
          : false;

        permrouter.forEach((result) => {
          if (
            result.calltypeid === tipochamada &&
            parseInt(result.idmidia) === parseInt(mediaid) &&
            (!verificarAreacode ||
              !existeAreaCode ||
              (result.areacode &&
                String(result.areacode).startsWith(doisPrimeirosDigitos)))
          ) {
            rota.push(result);
          }
          if (result.calltypeid === 11 && rota.length === 0) {
            if (
              parseInt(chamado) >= parseInt(result.partialnumber) &&
              parseInt(chamado) <= parseInt(result.partialnumber_end)
            ) {
              rota.push(result);
            }
          } else if (result.calltypeid === 6 && rota.length === 0) {
            if (parseInt(chamado) === parseInt(result.partialnumber)) {
              rota.push(result);
            }
          } else if (
            tipochamada === 5 &&
            mediaid === 5 &&
            result.calltypeid === 17
          ) {
            rota.push(result);
            chamado = chamado.replace(/^00/, "");
          }
        });

        console.log("INGENIUM_ACTVECALL_1222222 : ", rota);

        if (rota && rota.length > 1) {
          let isExistOther = false;
          rota.forEach((result) => {
            const lastEight = String(chamado).slice(-8);
            if (
              parseInt(lastEight) >= parseInt(result.partialnumber) &&
              parseInt(lastEight) <= parseInt(result.partialnumber_end)
            ) {
              rota = result;
              isExistOther = true;
            }
          });
          if (!isExistOther) {
            rota = rota.filter((temp) => temp.isdefault === "t");
            rota = rota.length !== 0 ? rota[0] : [];
          }
        } else if (rota.length === 1) {
          rota = rota[0];
        }

        return rota;
      }

      const rotaEncontrada = buscarRota();

      console.log("INGENIUMACTIVECALL", rotaEncontrada);

      if (rotaEncontrada.length === 0) {
        toast.error("Sem rota de saída!");
        return;
      }

      let retorno = 0;
      // let queueData = queue.find(q => q.caller.includes(chamado));
      let queueData = queue.find(
        (q) => q.caller.includes(chamado) && q.mediaid === mediaid,
      );
      if (queueData) {
        retorno = 1;
      }

      let queueid = queueData && queueData.queueid ? queueData.queueid : null;
      let recvcount =
        queueData && queueData.recvcount ? queueData.recvcount : null;
      let cdrid = queueData && queueData.cdrid ? queueData.cdrid : null;
      let srvin =
        queueData && queueData.serviceinid ? queueData.serviceinid : null;
      let caller = queueData && queueData.caller ? queueData.caller : null;
      let called = queueData && queueData.called ? queueData.called : null;
      let cbackcount =
        queueData && queueData.callback_count ? queueData.callback_count : null;
      let queueStatus =
        queueData && queueData.queueStatus ? queueData.queueStatus : null;
      let tech = rotaEncontrada.tech;
      let idgrupo_rota = rotaEncontrada.idgrupo_rota;
      let idgrupo_transb = rotaEncontrada.idgrupo_transb;
      let checkRota = true;

      if (mediaid === 5 || mediaid === 8) {
        chamado = chamado.trim();
      }

      if (mediaid === 1) {
        if (retorno === 1) {
          dispatch(
            RequestActiveCallSocketVoz(
              outband,
              infouser,
              rotaEncontrada.idtrunk,
              mediaid,
              chamado,
              rotaEncontrada.addtech,
              rotaEncontrada.scripttrunk,
              rotaEncontrada.operator,
              true,
              queueid,
              recvcount,
              null,
              tech,
              idgrupo_rota,
              idgrupo_transb,
              ipcurrent,
              cdrid,
              checkRota,
            ),
          );
          dispatch(
            ReturningCallbackIn(
              queueid,
              true,
              recvcount,
              cdrid,
              mediaid,
              srvin,
              caller,
              called,
              cbackcount,
              queueStatus,
            ),
          );
        } else {
          dispatch(
            RequestActiveCallSocketVoz(
              outband,
              infouser,
              rotaEncontrada.idtrunk,
              mediaid,
              chamado,
              rotaEncontrada.addtech,
              rotaEncontrada.scripttrunk,
              rotaEncontrada.operator,
              false,
              queueid,
              recvcount,
              null,
              tech,
              idgrupo_rota,
              idgrupo_transb,
              ipcurrent,
              cdrid,
              checkRota,
            ),
          );
          dispatch(
            ReturningCallbackIn(
              queueid,
              true,
              recvcount,
              cdrid,
              mediaid,
              srvin,
              caller,
              called,
              cbackcount,
              queueStatus,
            ),
          );
        }
      } else {
        if (retorno === 1) {
          dispatch(
            RequestActiveCall(
              outband,
              infouser,
              rotaEncontrada.idtrunk,
              mediaid,
              chamado,
              rotaEncontrada.addtech,
              rotaEncontrada.scripttrunk,
              rotaEncontrada.operator,
              true,
              queueid,
              recvcount,
              cbackcount,
              idgrupo_transb,
              cdrid,
              undefined,
              undefined,
              rawNumber,
            ),
          );
          dispatch(
            ReturningCallbackIn(
              queueid,
              true,
              recvcount,
              cdrid,
              mediaid,
              srvin,
              caller,
              called,
              cbackcount,
              queueStatus,
            ),
          );
        } else {
          dispatch(
            RequestActiveCall(
              outband,
              infouser,
              rotaEncontrada.idtrunk,
              mediaid,
              chamado,
              rotaEncontrada.addtech,
              rotaEncontrada.scripttrunk,
              rotaEncontrada.operator,
              false,
              queueid,
              recvcount,
              cbackcount,
              idgrupo_transb,
              undefined,
              undefined,
              undefined,
              rawNumber,
            ),
          );
        }
      }

      dispatch(ShowInfoDisplay("Clientes"));
      dispatch(ShowActiveCall(""));
    } catch (error) {
      toast.error("Ocorreu um erro, tente novamente!");
    }
  };
}

export const editClientWallet = (permissionWallet) => ({
  type: types.EDIT_CLIENT_WALLET,
  permissionWallet,
});

export const getContactPositions = async () => {
  try {
    const response = await axios.get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/get-contact-positions`,
    );
    return response;
  } catch (error) {
    console.log("getContactPositions Error: ", error);
  }
};

export const getContactRelations = async () => {
  try {
    const response = await axios.get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/get-contact-relations`,
    );
    return response;
  } catch (error) {
    console.log("getContactRelations Error: ", error);
  }
};

export async function updateUserFilters(userId, filterObj) {
  try {
    const filterJson = JSON.stringify(filterObj);
    const data = {
      filters_user_json: filterJson,
    };
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const response = await axios.put(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/update-user-filters/${userId}`,
      data,
      config,
    );
    return response;
  } catch (error) {}
}

export async function getFreeAgentsById(groupId, userId, urlParams) {
  try {
    const response = await axios.get(
      `${urlParams}?userId=${userId}&groupId=${groupId}`,
    );
    // await new Promise((r) => setTimeout(r, 300));
    // const mockResources = {
    //   69: {
    //     resourceId: "69",
    //     status: "ACTIVE",
    //     lastUpdated: 1769018597210,
    //     data: { groupId: 69 },
    //     max_agents_on_pause: 2,
    //     free_pause_agents: false,
    //     users_in_pause: [231, 375, 407],
    //   },
    // };

    // const resource = mockResources[groupId];

    // if (!resource) {
    //   return {
    //     status: 404,
    //     data: { message: "Resource not found" },
    //   };
    // }
    return response;
    // return {
    //   status: 200,
    //   data: resource,
    // };
  } catch (error) {
    console.log("getFreeAgentsById Error: ", error);
    return error ? error.response : null;
  }
}

export const updateUserByRV = async (sipId) => {
  try {
    const respose = await axios.get(
      `${connection_platform.type_connect}://${pathname}:${port}/conn/updateuserbyrv?id=${sipId}`,
    );
    return respose;
  } catch (error) {
    console.log("updateUserByRV ERROR: ", error);
  }
};

export const habilitarBotaoAtenderStandby = () => ({
  type: types.HABILITAR_BOTAO_ATENDER_STANDBY,
});
export const desabilitarBotaoAtenderStandby = () => ({
  type: types.DESABILITAR_BOTAO_ATENDER_STANDBY,
});
